/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AcceptInvitationRouteImport } from './routes/accept-invitation'
import { Route as ActivateRouteImport } from './routes/activate'
import { Route as FaceDiagnosticsRouteImport } from './routes/face-diagnostics'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as GetTheAppRouteImport } from './routes/get-the-app'
import { Route as KioskRouteImport } from './routes/kiosk'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as ResetCodeRouteImport } from './routes/reset-code'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as TwoFactorRouteImport } from './routes/two-factor'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedSplatRouteImport } from './routes/_authenticated/$'
import { Route as AuthenticatedAccountRouteImport } from './routes/_authenticated/account'
import { Route as AuthenticatedAccountingRouteImport } from './routes/_authenticated/accounting'
import { Route as AuthenticatedAlertsRouteImport } from './routes/_authenticated/alerts'
import { Route as AuthenticatedApprovalsRouteImport } from './routes/_authenticated/approvals'
import { Route as AuthenticatedAuditRouteImport } from './routes/_authenticated/audit'
import { Route as AuthenticatedBranchesRouteImport } from './routes/_authenticated/branches'
import { Route as AuthenticatedCollectionsRouteImport } from './routes/_authenticated/collections'
import { Route as AuthenticatedCompaniesRouteImport } from './routes/_authenticated/companies'
import { Route as AuthenticatedDepartmentsRouteImport } from './routes/_authenticated/departments'
import { Route as AuthenticatedNotificationsRouteImport } from './routes/_authenticated/notifications'
import { Route as AuthenticatedPayrollRouteImport } from './routes/_authenticated/payroll'
import { Route as AuthenticatedPositionsRouteImport } from './routes/_authenticated/positions'
import { Route as AuthenticatedProductAttributesRouteImport } from './routes/_authenticated/product-attributes'
import { Route as AuthenticatedRolesRouteImport } from './routes/_authenticated/roles'
import { Route as AuthenticatedSequencesRouteImport } from './routes/_authenticated/sequences'
import { Route as AuthenticatedTwoFactorSetupRouteImport } from './routes/_authenticated/two-factor-setup'
import { Route as AuthenticatedUsersRouteImport } from './routes/_authenticated/users'
import { Route as ApplyTokenRouteImport } from './routes/apply.$token'
import { Route as SupportEndedRouteImport } from './routes/support.ended'
import { Route as SupportEnterRouteImport } from './routes/support.enter'
import { Route as AuthenticatedAccountIndexRouteImport } from './routes/_authenticated/account.index'
import { Route as AuthenticatedAccountNotificationsRouteImport } from './routes/_authenticated/account.notifications'
import { Route as AuthenticatedAccountSecurityRouteImport } from './routes/_authenticated/account.security'
import { Route as AuthenticatedAccountingIndexRouteImport } from './routes/_authenticated/accounting/index'
import { Route as AuthenticatedAccountingAnalysisTagsRouteImport } from './routes/_authenticated/accounting/analysis-tags'
import { Route as AuthenticatedAccountingAssetsRouteImport } from './routes/_authenticated/accounting/assets'
import { Route as AuthenticatedAccountingBankRulesRouteImport } from './routes/_authenticated/accounting/bank-rules'
import { Route as AuthenticatedAccountingBankTransactionsRouteImport } from './routes/_authenticated/accounting/bank-transactions'
import { Route as AuthenticatedAccountingBillsRouteImport } from './routes/_authenticated/accounting/bills'
import { Route as AuthenticatedAccountingBudgetsRouteImport } from './routes/_authenticated/accounting/budgets'
import { Route as AuthenticatedAccountingCashSalesRouteImport } from './routes/_authenticated/accounting/cash-sales'
import { Route as AuthenticatedAccountingChartRouteImport } from './routes/_authenticated/accounting/chart'
import { Route as AuthenticatedAccountingChequesRouteImport } from './routes/_authenticated/accounting/cheques'
import { Route as AuthenticatedAccountingCloseRouteImport } from './routes/_authenticated/accounting/close'
import { Route as AuthenticatedAccountingCostCentersRouteImport } from './routes/_authenticated/accounting/cost-centers'
import { Route as AuthenticatedAccountingCreditNotesRouteImport } from './routes/_authenticated/accounting/credit-notes'
import { Route as AuthenticatedAccountingInvoicesRouteImport } from './routes/_authenticated/accounting/invoices'
import { Route as AuthenticatedAccountingJournalRouteImport } from './routes/_authenticated/accounting/journal'
import { Route as AuthenticatedAccountingJournalsRouteImport } from './routes/_authenticated/accounting/journals'
import { Route as AuthenticatedAccountingPaymentTermsRouteImport } from './routes/_authenticated/accounting/payment-terms'
import { Route as AuthenticatedAccountingPaymentsRouteImport } from './routes/_authenticated/accounting/payments'
import { Route as AuthenticatedAccountingPeriodsRouteImport } from './routes/_authenticated/accounting/periods'
import { Route as AuthenticatedAccountingPostingIntentsRouteImport } from './routes/_authenticated/accounting/posting-intents'
import { Route as AuthenticatedAccountingPrepaidRouteImport } from './routes/_authenticated/accounting/prepaid'
import { Route as AuthenticatedAccountingReconciliationRouteImport } from './routes/_authenticated/accounting/reconciliation'
import { Route as AuthenticatedAccountingRecurringRouteImport } from './routes/_authenticated/accounting/recurring'
import { Route as AuthenticatedAccountingSalesReceiptsRouteImport } from './routes/_authenticated/accounting/sales-receipts'
import { Route as AuthenticatedAccountingSettingsRouteImport } from './routes/_authenticated/accounting/settings'
import { Route as AuthenticatedAccountingStatementsRouteImport } from './routes/_authenticated/accounting/statements'
import { Route as AuthenticatedAccountingTaxRouteImport } from './routes/_authenticated/accounting/tax'
import { Route as AuthenticatedAccountingTrialBalanceRouteImport } from './routes/_authenticated/accounting/trial-balance'
import { Route as AuthenticatedAccountingWorkingCapitalRouteImport } from './routes/_authenticated/accounting/working-capital'
import { Route as AuthenticatedAccountingPayrollPaymentsRouteImport } from './routes/_authenticated/accounting_.payroll-payments'
import { Route as AuthenticatedCustomersIndexRouteImport } from './routes/_authenticated/customers/index'
import { Route as AuthenticatedCustomersNewRouteImport } from './routes/_authenticated/customers/new'
import { Route as AuthenticatedHrIndexRouteImport } from './routes/_authenticated/hr/index'
import { Route as AuthenticatedHrAssetsRouteImport } from './routes/_authenticated/hr/assets'
import { Route as AuthenticatedHrAttendanceRouteImport } from './routes/_authenticated/hr/attendance'
import { Route as AuthenticatedHrAttendanceBoardRouteImport } from './routes/_authenticated/hr/attendance-board'
import { Route as AuthenticatedHrAttendanceCorrectionsRouteImport } from './routes/_authenticated/hr/attendance-corrections'
import { Route as AuthenticatedHrCashCustodyRouteImport } from './routes/_authenticated/hr/cash-custody'
import { Route as AuthenticatedHrExpensesRouteImport } from './routes/_authenticated/hr/expenses'
import { Route as AuthenticatedHrFieldSettingsRouteImport } from './routes/_authenticated/hr/field-settings'
import { Route as AuthenticatedHrLeaveRouteImport } from './routes/_authenticated/hr/leave'
import { Route as AuthenticatedHrOrgRouteImport } from './routes/_authenticated/hr/org'
import { Route as AuthenticatedHrSettingsRouteImport } from './routes/_authenticated/hr/settings'
import { Route as AuthenticatedHrWorkEntriesRouteImport } from './routes/_authenticated/hr/work-entries'
import { Route as AuthenticatedHrWorkSchedulesRouteImport } from './routes/_authenticated/hr/work-schedules'
import { Route as AuthenticatedInventoryIndexRouteImport } from './routes/_authenticated/inventory/index'
import { Route as AuthenticatedInventoryAccessRouteImport } from './routes/_authenticated/inventory/access'
import { Route as AuthenticatedInventoryAdjustmentsRouteImport } from './routes/_authenticated/inventory/adjustments'
import { Route as AuthenticatedInventoryDisposalsRouteImport } from './routes/_authenticated/inventory/disposals'
import { Route as AuthenticatedInventoryLocationsRouteImport } from './routes/_authenticated/inventory/locations'
import { Route as AuthenticatedInventoryMovementsRouteImport } from './routes/_authenticated/inventory/movements'
import { Route as AuthenticatedInventorySerialsRouteImport } from './routes/_authenticated/inventory/serials'
import { Route as AuthenticatedInventoryStockRouteImport } from './routes/_authenticated/inventory/stock'
import { Route as AuthenticatedInventoryWarehousesRouteImport } from './routes/_authenticated/inventory/warehouses'
import { Route as AuthenticatedPayrollAdvancesRouteImport } from './routes/_authenticated/payroll/advances'
import { Route as AuthenticatedPayrollBulkAssignRouteImport } from './routes/_authenticated/payroll/bulk-assign'
import { Route as AuthenticatedPayrollComponentsRouteImport } from './routes/_authenticated/payroll/components'
import { Route as AuthenticatedPayrollPayslipsRouteImport } from './routes/_authenticated/payroll/payslips'
import { Route as AuthenticatedPayrollRunsRouteImport } from './routes/_authenticated/payroll/runs'
import { Route as AuthenticatedPayrollSettingsRouteImport } from './routes/_authenticated/payroll/settings'
import { Route as AuthenticatedProductCategoriesIndexRouteImport } from './routes/_authenticated/product-categories/index'
import { Route as AuthenticatedProductCategoriesNewRouteImport } from './routes/_authenticated/product-categories/new'
import { Route as AuthenticatedProductsIndexRouteImport } from './routes/_authenticated/products/index'
import { Route as AuthenticatedProductsNewRouteImport } from './routes/_authenticated/products/new'
import { Route as AuthenticatedProductsUnitsOfMeasureRouteImport } from './routes/_authenticated/products/units-of-measure'
import { Route as AuthenticatedPurchasingIndexRouteImport } from './routes/_authenticated/purchasing/index'
import { Route as AuthenticatedPurchasingLandedCostCategoriesRouteImport } from './routes/_authenticated/purchasing/landed-cost-categories'
import { Route as AuthenticatedPurchasingLandedCostsRouteImport } from './routes/_authenticated/purchasing/landed-costs'
import { Route as AuthenticatedPurchasingOrdersRouteImport } from './routes/_authenticated/purchasing/orders'
import { Route as AuthenticatedPurchasingReceiptsRouteImport } from './routes/_authenticated/purchasing/receipts'
import { Route as AuthenticatedPurchasingReturnsRouteImport } from './routes/_authenticated/purchasing/returns'
import { Route as AuthenticatedRecruitmentIndexRouteImport } from './routes/_authenticated/recruitment/index'
import { Route as AuthenticatedRolesIndexRouteImport } from './routes/_authenticated/roles/index'
import { Route as AuthenticatedRolesRoleIdRouteImport } from './routes/_authenticated/roles/$roleId'
import { Route as AuthenticatedRolesNewRouteImport } from './routes/_authenticated/roles/new'
import { Route as AuthenticatedSalesIndexRouteImport } from './routes/_authenticated/sales/index'
import { Route as AuthenticatedSalesOrdersRouteImport } from './routes/_authenticated/sales/orders'
import { Route as AuthenticatedSalesReservationsRouteImport } from './routes/_authenticated/sales/reservations'
import { Route as AuthenticatedSalesReturnsRouteImport } from './routes/_authenticated/sales/returns'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings.index'
import { Route as AuthenticatedSettingsAlertsRouteImport } from './routes/_authenticated/settings.alerts'
import { Route as AuthenticatedSettingsDataImportRouteImport } from './routes/_authenticated/settings.data-import'
import { Route as AuthenticatedSettingsNotificationsRouteImport } from './routes/_authenticated/settings.notifications'
import { Route as AuthenticatedSettingsWorkflowsRouteImport } from './routes/_authenticated/settings/workflows'
import { Route as AuthenticatedSuppliersIndexRouteImport } from './routes/_authenticated/suppliers/index'
import { Route as AuthenticatedSuppliersNewRouteImport } from './routes/_authenticated/suppliers/new'
import { Route as AuthenticatedTagsIndexRouteImport } from './routes/_authenticated/tags/index'
import { Route as AuthenticatedAccountingAssetsAssetIdRouteImport } from './routes/_authenticated/accounting/assets/$assetId'
import { Route as AuthenticatedAccountingAssetsDepreciationRouteImport } from './routes/_authenticated/accounting/assets/depreciation'
import { Route as AuthenticatedAccountingBankAccountsIndexRouteImport } from './routes/_authenticated/accounting/bank-accounts.index'
import { Route as AuthenticatedAccountingBillsNewRouteImport } from './routes/_authenticated/accounting/bills.new'
import { Route as AuthenticatedAccountingBillsPayRouteImport } from './routes/_authenticated/accounting/bills.pay'
import { Route as AuthenticatedAccountingBudgetsBudgetIdRouteImport } from './routes/_authenticated/accounting/budgets.$budgetId'
import { Route as AuthenticatedAccountingBudgetsNewRouteImport } from './routes/_authenticated/accounting/budgets.new'
import { Route as AuthenticatedAccountingCardCreditsNewRouteImport } from './routes/_authenticated/accounting/card-credits.new'
import { Route as AuthenticatedAccountingCashSalesNewRouteImport } from './routes/_authenticated/accounting/cash-sales.new'
import { Route as AuthenticatedAccountingChequesOutstandingRouteImport } from './routes/_authenticated/accounting/cheques.outstanding'
import { Route as AuthenticatedAccountingCreditNotesNewRouteImport } from './routes/_authenticated/accounting/credit-notes.new'
import { Route as AuthenticatedAccountingDepositsIndexRouteImport } from './routes/_authenticated/accounting/deposits.index'
import { Route as AuthenticatedAccountingDepositsDepositIdRouteImport } from './routes/_authenticated/accounting/deposits.$depositId'
import { Route as AuthenticatedAccountingDepositsNewRouteImport } from './routes/_authenticated/accounting/deposits.new'
import { Route as AuthenticatedAccountingExpensesIndexRouteImport } from './routes/_authenticated/accounting/expenses/index'
import { Route as AuthenticatedAccountingExpensesDocumentIdRouteImport } from './routes/_authenticated/accounting/expenses.$documentId'
import { Route as AuthenticatedAccountingExpensesNewRouteImport } from './routes/_authenticated/accounting/expenses.new'
import { Route as AuthenticatedAccountingInvoicesNewRouteImport } from './routes/_authenticated/accounting/invoices.new'
import { Route as AuthenticatedAccountingJournalEntryIdRouteImport } from './routes/_authenticated/accounting/journal.$entryId'
import { Route as AuthenticatedAccountingJournalNewRouteImport } from './routes/_authenticated/accounting/journal.new'
import { Route as AuthenticatedAccountingOpeningBalancesIndexRouteImport } from './routes/_authenticated/accounting/opening-balances/index'
import { Route as AuthenticatedAccountingOpeningBalancesBatchIdRouteImport } from './routes/_authenticated/accounting/opening-balances/$batchId'
import { Route as AuthenticatedAccountingPaymentsPaymentIdRouteImport } from './routes/_authenticated/accounting/payments.$paymentId'
import { Route as AuthenticatedAccountingPaymentsNewRouteImport } from './routes/_authenticated/accounting/payments.new'
import { Route as AuthenticatedAccountingReconcileIndexRouteImport } from './routes/_authenticated/accounting/reconcile.index'
import { Route as AuthenticatedAccountingReconcileReconciliationIdRouteImport } from './routes/_authenticated/accounting/reconcile.$reconciliationId'
import { Route as AuthenticatedAccountingReconciliationStatementIdRouteImport } from './routes/_authenticated/accounting/reconciliation.$statementId'
import { Route as AuthenticatedAccountingRefundsNewRouteImport } from './routes/_authenticated/accounting/refunds.new'
import { Route as AuthenticatedAccountingReportsIndexRouteImport } from './routes/_authenticated/accounting/reports.index'
import { Route as AuthenticatedAccountingReportsReportTokenRouteImport } from './routes/_authenticated/accounting/reports.$reportToken'
import { Route as AuthenticatedAccountingReportsAgingRouteImport } from './routes/_authenticated/accounting/reports.aging'
import { Route as AuthenticatedAccountingReportsBalanceSheetRouteImport } from './routes/_authenticated/accounting/reports.balance-sheet'
import { Route as AuthenticatedAccountingReportsCashFlowRouteImport } from './routes/_authenticated/accounting/reports.cash-flow'
import { Route as AuthenticatedAccountingReportsCashPositionRouteImport } from './routes/_authenticated/accounting/reports.cash-position'
import { Route as AuthenticatedAccountingReportsCostByNameRouteImport } from './routes/_authenticated/accounting/reports.cost-by-name'
import { Route as AuthenticatedAccountingReportsGeneralLedgerRouteImport } from './routes/_authenticated/accounting/reports.general-ledger'
import { Route as AuthenticatedAccountingReportsMonthlyStatementsRouteImport } from './routes/_authenticated/accounting/reports.monthly-statements'
import { Route as AuthenticatedAccountingReportsProfitAndLossRouteImport } from './routes/_authenticated/accounting/reports.profit-and-loss'
import { Route as AuthenticatedAccountingReportsTaxRouteImport } from './routes/_authenticated/accounting/reports.tax'
import { Route as AuthenticatedAccountingSalesReceiptsNewRouteImport } from './routes/_authenticated/accounting/sales-receipts.new'
import { Route as AuthenticatedAccountingSalesIndexRouteImport } from './routes/_authenticated/accounting/sales/index'
import { Route as AuthenticatedAccountingSpendIndexRouteImport } from './routes/_authenticated/accounting/spend.index'
import { Route as AuthenticatedAccountingSpendDocumentIdRouteImport } from './routes/_authenticated/accounting/spend.$documentId'
import { Route as AuthenticatedAccountingSpendNewRouteImport } from './routes/_authenticated/accounting/spend.new'
import { Route as AuthenticatedAccountingSupplierCreditsNewRouteImport } from './routes/_authenticated/accounting/supplier-credits.new'
import { Route as AuthenticatedAccountingSupplierStatementSupplierIdRouteImport } from './routes/_authenticated/accounting/supplier-statement.$supplierId'
import { Route as AuthenticatedAccountingTransfersNewRouteImport } from './routes/_authenticated/accounting/transfers.new'
import { Route as AuthenticatedCustomersCustomerIdIndexRouteImport } from './routes/_authenticated/customers/$customerId/index'
import { Route as AuthenticatedCustomersCustomerIdEditRouteImport } from './routes/_authenticated/customers/$customerId/edit'
import { Route as AuthenticatedGroupReportsIndexRouteImport } from './routes/_authenticated/group/reports/index'
import { Route as AuthenticatedGroupReportsBalanceSheetRouteImport } from './routes/_authenticated/group/reports/balance-sheet'
import { Route as AuthenticatedGroupReportsProfitAndLossRouteImport } from './routes/_authenticated/group/reports/profit-and-loss'
import { Route as AuthenticatedHrAssetsAssetIdRouteImport } from './routes/_authenticated/hr/assets.$assetId'
import { Route as AuthenticatedHrAttendanceCorrectionsRequestIdRouteImport } from './routes/_authenticated/hr/attendance-corrections.$requestId'
import { Route as AuthenticatedHrCashCustodyCustodyIdRouteImport } from './routes/_authenticated/hr/cash-custody.$custodyId'
import { Route as AuthenticatedHrEmployeesIndexRouteImport } from './routes/_authenticated/hr/employees.index'
import { Route as AuthenticatedHrEmployeesEmployeeIdRouteImport } from './routes/_authenticated/hr/employees.$employeeId'
import { Route as AuthenticatedHrEmployeesNewRouteImport } from './routes/_authenticated/hr/employees.new'
import { Route as AuthenticatedHrExpensesClaimIdRouteImport } from './routes/_authenticated/hr/expenses.$claimId'
import { Route as AuthenticatedHrLeaveRequestIdRouteImport } from './routes/_authenticated/hr/leave.$requestId'
import { Route as AuthenticatedHrPerformanceIndexRouteImport } from './routes/_authenticated/hr/performance/index'
import { Route as AuthenticatedHrPerformanceSchedulesRouteImport } from './routes/_authenticated/hr/performance/schedules'
import { Route as AuthenticatedHrPerformanceTemplatesRouteImport } from './routes/_authenticated/hr/performance/templates'
import { Route as AuthenticatedHrReportsIndexRouteImport } from './routes/_authenticated/hr/reports.index'
import { Route as AuthenticatedHrReportsAbsenceCoverageRouteImport } from './routes/_authenticated/hr/reports.absence-coverage'
import { Route as AuthenticatedHrReportsAbsenceDetailRouteImport } from './routes/_authenticated/hr/reports.absence-detail'
import { Route as AuthenticatedHrReportsAnalyticsRouteImport } from './routes/_authenticated/hr/reports.analytics'
import { Route as AuthenticatedHrReportsAssetCustodyRouteImport } from './routes/_authenticated/hr/reports.asset-custody'
import { Route as AuthenticatedHrReportsAssetExceptionsRouteImport } from './routes/_authenticated/hr/reports.asset-exceptions'
import { Route as AuthenticatedHrReportsAttendanceExceptionsRouteImport } from './routes/_authenticated/hr/reports.attendance-exceptions'
import { Route as AuthenticatedHrReportsAttendanceSheetRouteImport } from './routes/_authenticated/hr/reports.attendance-sheet'
import { Route as AuthenticatedHrReportsAttendanceSummaryRouteImport } from './routes/_authenticated/hr/reports.attendance-summary'
import { Route as AuthenticatedHrReportsBirthdaysRouteImport } from './routes/_authenticated/hr/reports.birthdays'
import { Route as AuthenticatedHrReportsBreaksSessionsRouteImport } from './routes/_authenticated/hr/reports.breaks-sessions'
import { Route as AuthenticatedHrReportsCashCustodyBalancesRouteImport } from './routes/_authenticated/hr/reports.cash-custody-balances'
import { Route as AuthenticatedHrReportsDemographicsRouteImport } from './routes/_authenticated/hr/reports.demographics'
import { Route as AuthenticatedHrReportsDocumentExpiryRouteImport } from './routes/_authenticated/hr/reports.document-expiry'
import { Route as AuthenticatedHrReportsExpenseAgeingRouteImport } from './routes/_authenticated/hr/reports.expense-ageing'
import { Route as AuthenticatedHrReportsExpenseClaimsRouteImport } from './routes/_authenticated/hr/reports.expense-claims'
import { Route as AuthenticatedHrReportsHeadcountRouteImport } from './routes/_authenticated/hr/reports.headcount'
import { Route as AuthenticatedHrReportsHolidayRollRouteImport } from './routes/_authenticated/hr/reports.holiday-roll'
import { Route as AuthenticatedHrReportsJoinersLeaversRouteImport } from './routes/_authenticated/hr/reports.joiners-leavers'
import { Route as AuthenticatedHrReportsLatenessRouteImport } from './routes/_authenticated/hr/reports.lateness'
import { Route as AuthenticatedHrReportsLeaveBalancesRouteImport } from './routes/_authenticated/hr/reports.leave-balances'
import { Route as AuthenticatedHrReportsLeaveLiabilityRouteImport } from './routes/_authenticated/hr/reports.leave-liability'
import { Route as AuthenticatedHrReportsLeaveTakenRouteImport } from './routes/_authenticated/hr/reports.leave-taken'
import { Route as AuthenticatedHrReportsOrgHygieneRouteImport } from './routes/_authenticated/hr/reports.org-hygiene'
import { Route as AuthenticatedHrReportsOvertimeRouteImport } from './routes/_authenticated/hr/reports.overtime'
import { Route as AuthenticatedHrReportsPayrollDeductionsRouteImport } from './routes/_authenticated/hr/reports.payroll-deductions'
import { Route as AuthenticatedHrReportsPayrollRegisterRouteImport } from './routes/_authenticated/hr/reports.payroll-register'
import { Route as AuthenticatedHrReportsPayrollSummaryRouteImport } from './routes/_authenticated/hr/reports.payroll-summary'
import { Route as AuthenticatedHrReportsPayrollVarianceRouteImport } from './routes/_authenticated/hr/reports.payroll-variance'
import { Route as AuthenticatedHrReportsPermissionRequestsRouteImport } from './routes/_authenticated/hr/reports.permission-requests'
import { Route as AuthenticatedHrReportsProbationContractRouteImport } from './routes/_authenticated/hr/reports.probation-contract'
import { Route as AuthenticatedHrReportsReviewCompletionRouteImport } from './routes/_authenticated/hr/reports.review-completion'
import { Route as AuthenticatedHrReportsRosterBankRouteImport } from './routes/_authenticated/hr/reports.roster-bank'
import { Route as AuthenticatedHrReportsRosterCompensationRouteImport } from './routes/_authenticated/hr/reports.roster-compensation'
import { Route as AuthenticatedHrReportsRosterContactRouteImport } from './routes/_authenticated/hr/reports.roster-contact'
import { Route as AuthenticatedHrReportsRosterEmergencyRouteImport } from './routes/_authenticated/hr/reports.roster-emergency'
import { Route as AuthenticatedHrReportsRosterEmploymentRouteImport } from './routes/_authenticated/hr/reports.roster-employment'
import { Route as AuthenticatedHrReportsRosterTeamMemberRouteImport } from './routes/_authenticated/hr/reports.roster-team-member'
import { Route as AuthenticatedHrReportsScoreDistributionRouteImport } from './routes/_authenticated/hr/reports.score-distribution'
import { Route as AuthenticatedHrReportsTimeOffReviewRouteImport } from './routes/_authenticated/hr/reports.time-off-review'
import { Route as AuthenticatedHrReportsTurnoverRouteImport } from './routes/_authenticated/hr/reports.turnover'
import { Route as AuthenticatedHrReportsViolationsRouteImport } from './routes/_authenticated/hr/reports.violations'
import { Route as AuthenticatedHrReportsWorkHoursRouteImport } from './routes/_authenticated/hr/reports.work-hours'
import { Route as AuthenticatedHrViolationsIndexRouteImport } from './routes/_authenticated/hr/violations.index'
import { Route as AuthenticatedHrViolationsViolationIdRouteImport } from './routes/_authenticated/hr/violations.$violationId'
import { Route as AuthenticatedInventoryCountsIndexRouteImport } from './routes/_authenticated/inventory/counts/index'
import { Route as AuthenticatedInventoryLotsIndexRouteImport } from './routes/_authenticated/inventory/lots/index'
import { Route as AuthenticatedInventoryLotsLotIdRouteImport } from './routes/_authenticated/inventory/lots/$lotId'
import { Route as AuthenticatedInventoryReportsIndexRouteImport } from './routes/_authenticated/inventory/reports/index'
import { Route as AuthenticatedInventoryReportsAgingRouteImport } from './routes/_authenticated/inventory/reports/aging'
import { Route as AuthenticatedInventoryReportsNoSalesRouteImport } from './routes/_authenticated/inventory/reports/no-sales'
import { Route as AuthenticatedInventoryReportsPerformanceRouteImport } from './routes/_authenticated/inventory/reports/performance'
import { Route as AuthenticatedInventoryReportsReplenishmentRouteImport } from './routes/_authenticated/inventory/reports/replenishment'
import { Route as AuthenticatedInventoryReportsStockValuationRouteImport } from './routes/_authenticated/inventory/reports/stock-valuation'
import { Route as AuthenticatedInventoryReportsStockValueRouteImport } from './routes/_authenticated/inventory/reports/stock-value'
import { Route as AuthenticatedInventorySerialsUnitIdRouteImport } from './routes/_authenticated/inventory/serials.$unitId'
import { Route as AuthenticatedInventoryTransfersIndexRouteImport } from './routes/_authenticated/inventory/transfers/index'
import { Route as AuthenticatedInventoryTransfersTransferIdRouteImport } from './routes/_authenticated/inventory/transfers/$transferId'
import { Route as AuthenticatedInventoryTransfersNewRouteImport } from './routes/_authenticated/inventory/transfers/new'
import { Route as AuthenticatedPayrollPayslipsPayslipIdRouteImport } from './routes/_authenticated/payroll/payslips.$payslipId'
import { Route as AuthenticatedPayrollRunsRunIdRouteImport } from './routes/_authenticated/payroll/runs.$runId'
import { Route as AuthenticatedPayrollSettlementsRunIdRouteImport } from './routes/_authenticated/payroll/settlements.$runId'
import { Route as AuthenticatedProductCategoriesCategoryIdEditRouteImport } from './routes/_authenticated/product-categories/$categoryId/edit'
import { Route as AuthenticatedProductsProductIdIndexRouteImport } from './routes/_authenticated/products/$productId/index'
import { Route as AuthenticatedProductsProductIdEditRouteImport } from './routes/_authenticated/products/$productId/edit'
import { Route as AuthenticatedPurchasingLandedCostsNewRouteImport } from './routes/_authenticated/purchasing/landed-costs.new'
import { Route as AuthenticatedPurchasingOrdersNewRouteImport } from './routes/_authenticated/purchasing/orders.new'
import { Route as AuthenticatedPurchasingReportsGoodsReceivedNotInvoicedRouteImport } from './routes/_authenticated/purchasing/reports.goods-received-not-invoiced'
import { Route as AuthenticatedPurchasingReportsLandedCostsPendingRouteImport } from './routes/_authenticated/purchasing/reports.landed-costs-pending'
import { Route as AuthenticatedPurchasingReportsThreeWayMatchRouteImport } from './routes/_authenticated/purchasing/reports.three-way-match'
import { Route as AuthenticatedPurchasingReturnsNewRouteImport } from './routes/_authenticated/purchasing/returns.new'
import { Route as AuthenticatedRecruitmentCandidatesCandidateIdRouteImport } from './routes/_authenticated/recruitment/candidates.$candidateId'
import { Route as AuthenticatedRecruitmentOpeningsOpeningIdRouteImport } from './routes/_authenticated/recruitment/openings.$openingId'
import { Route as AuthenticatedSalesOrdersNewRouteImport } from './routes/_authenticated/sales/orders.new'
import { Route as AuthenticatedSalesReportsTrendRouteImport } from './routes/_authenticated/sales/reports/trend'
import { Route as AuthenticatedSalesReturnsNewRouteImport } from './routes/_authenticated/sales/returns.new'
import { Route as AuthenticatedSuppliersSupplierIdIndexRouteImport } from './routes/_authenticated/suppliers/$supplierId/index'
import { Route as AuthenticatedSuppliersSupplierIdEditRouteImport } from './routes/_authenticated/suppliers/$supplierId/edit'
import { Route as AuthenticatedAccountingAccountsAccountIdRegisterRouteImport } from './routes/_authenticated/accounting/accounts.$accountId.register'
import { Route as AuthenticatedAccountingBankAccountsAccountIdIndexRouteImport } from './routes/_authenticated/accounting/bank-accounts.$accountId.index'
import { Route as AuthenticatedAccountingBillsBillIdIndexRouteImport } from './routes/_authenticated/accounting/bills.$billId.index'
import { Route as AuthenticatedAccountingBillsBillIdDebitNoteRouteImport } from './routes/_authenticated/accounting/bills.$billId.debit-note'
import { Route as AuthenticatedAccountingBillsBillIdEditRouteImport } from './routes/_authenticated/accounting/bills.$billId.edit'
import { Route as AuthenticatedAccountingCashSalesCashSaleIdIndexRouteImport } from './routes/_authenticated/accounting/cash-sales.$cashSaleId.index'
import { Route as AuthenticatedAccountingCashSalesCashSaleIdEditRouteImport } from './routes/_authenticated/accounting/cash-sales.$cashSaleId.edit'
import { Route as AuthenticatedAccountingChequesChequeIdIndexRouteImport } from './routes/_authenticated/accounting/cheques.$chequeId.index'
import { Route as AuthenticatedAccountingInvoicesInvoiceIdIndexRouteImport } from './routes/_authenticated/accounting/invoices.$invoiceId.index'
import { Route as AuthenticatedAccountingInvoicesInvoiceIdCreditNoteRouteImport } from './routes/_authenticated/accounting/invoices.$invoiceId.credit-note'
import { Route as AuthenticatedAccountingInvoicesInvoiceIdEditRouteImport } from './routes/_authenticated/accounting/invoices.$invoiceId.edit'
import { Route as AuthenticatedAccountingSalesReceiptsCashSaleIdIndexRouteImport } from './routes/_authenticated/accounting/sales-receipts.$cashSaleId.index'
import { Route as AuthenticatedAccountingSalesReceiptsCashSaleIdEditRouteImport } from './routes/_authenticated/accounting/sales-receipts.$cashSaleId.edit'
import { Route as AuthenticatedHrEmployeesEmployeeIdEditRouteImport } from './routes/_authenticated/hr/employees.$employeeId.edit'
import { Route as AuthenticatedHrEmployeesEmployeeIdOnboardingRouteImport } from './routes/_authenticated/hr/employees.$employeeId.onboarding'
import { Route as AuthenticatedHrPerformanceCyclesCycleIdRouteImport } from './routes/_authenticated/hr/performance/cycles.$cycleId'
import { Route as AuthenticatedHrPerformanceReviewsReviewIdRouteImport } from './routes/_authenticated/hr/performance/reviews.$reviewId'
import { Route as AuthenticatedInventoryCountsSessionIdIndexRouteImport } from './routes/_authenticated/inventory/counts/$sessionId/index'
import { Route as AuthenticatedInventoryCountsSessionIdReviewRouteImport } from './routes/_authenticated/inventory/counts/$sessionId/review'
import { Route as AuthenticatedInventoryReportsInsightsReportRouteImport } from './routes/_authenticated/inventory/reports/insights.$report'
import { Route as AuthenticatedPurchasingLandedCostsLandedCostIdIndexRouteImport } from './routes/_authenticated/purchasing/landed-costs.$landedCostId.index'
import { Route as AuthenticatedPurchasingOrdersOrderIdIndexRouteImport } from './routes/_authenticated/purchasing/orders.$orderId.index'
import { Route as AuthenticatedPurchasingOrdersOrderIdEditRouteImport } from './routes/_authenticated/purchasing/orders.$orderId.edit'
import { Route as AuthenticatedPurchasingOrdersOrderIdReceiveRouteImport } from './routes/_authenticated/purchasing/orders.$orderId.receive'
import { Route as AuthenticatedPurchasingReceiptsReceiptIdIndexRouteImport } from './routes/_authenticated/purchasing/receipts.$receiptId.index'
import { Route as AuthenticatedPurchasingReturnsReturnIdIndexRouteImport } from './routes/_authenticated/purchasing/returns.$returnId.index'
import { Route as AuthenticatedSalesOrdersOrderIdIndexRouteImport } from './routes/_authenticated/sales/orders.$orderId.index'
import { Route as AuthenticatedSalesOrdersOrderIdEditRouteImport } from './routes/_authenticated/sales/orders.$orderId.edit'
import { Route as AuthenticatedSalesReturnsReturnIdIndexRouteImport } from './routes/_authenticated/sales/returns.$returnId.index'
import { Route as AuthenticatedAccountingBankAccountsAccountIdReconcileReconciliationIdRouteImport } from './routes/_authenticated/accounting/bank-accounts.$accountId.reconcile.$reconciliationId'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInvitationRoute = AcceptInvitationRouteImport.update({
  id: '/accept-invitation',
  path: '/accept-invitation',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivateRoute = ActivateRouteImport.update({
  id: '/activate',
  path: '/activate',
  getParentRoute: () => rootRouteImport,
} as any)
const FaceDiagnosticsRoute = FaceDiagnosticsRouteImport.update({
  id: '/face-diagnostics',
  path: '/face-diagnostics',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const GetTheAppRoute = GetTheAppRouteImport.update({
  id: '/get-the-app',
  path: '/get-the-app',
  getParentRoute: () => rootRouteImport,
} as any)
const KioskRoute = KioskRouteImport.update({
  id: '/kiosk',
  path: '/kiosk',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetCodeRoute = ResetCodeRouteImport.update({
  id: '/reset-code',
  path: '/reset-code',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const TwoFactorRoute = TwoFactorRouteImport.update({
  id: '/two-factor',
  path: '/two-factor',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSplatRoute = AuthenticatedSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAccountingRoute = AuthenticatedAccountingRouteImport.update({
  id: '/accounting',
  path: '/accounting',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAlertsRoute = AuthenticatedAlertsRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedApprovalsRoute = AuthenticatedApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAuditRoute = AuthenticatedAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedBranchesRoute = AuthenticatedBranchesRouteImport.update({
  id: '/branches',
  path: '/branches',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCollectionsRoute =
  AuthenticatedCollectionsRouteImport.update({
    id: '/collections',
    path: '/collections',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCompaniesRoute = AuthenticatedCompaniesRouteImport.update({
  id: '/companies',
  path: '/companies',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDepartmentsRoute =
  AuthenticatedDepartmentsRouteImport.update({
    id: '/departments',
    path: '/departments',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedNotificationsRoute =
  AuthenticatedNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPayrollRoute = AuthenticatedPayrollRouteImport.update({
  id: '/payroll',
  path: '/payroll',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPositionsRoute = AuthenticatedPositionsRouteImport.update({
  id: '/positions',
  path: '/positions',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedProductAttributesRoute =
  AuthenticatedProductAttributesRouteImport.update({
    id: '/product-attributes',
    path: '/product-attributes',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRolesRoute = AuthenticatedRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSequencesRoute = AuthenticatedSequencesRouteImport.update({
  id: '/sequences',
  path: '/sequences',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTwoFactorSetupRoute =
  AuthenticatedTwoFactorSetupRouteImport.update({
    id: '/two-factor-setup',
    path: '/two-factor-setup',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUsersRoute = AuthenticatedUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const ApplyTokenRoute = ApplyTokenRouteImport.update({
  id: '/apply/$token',
  path: '/apply/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportEndedRoute = SupportEndedRouteImport.update({
  id: '/support/ended',
  path: '/support/ended',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportEnterRoute = SupportEnterRouteImport.update({
  id: '/support/enter',
  path: '/support/enter',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAccountIndexRoute =
  AuthenticatedAccountIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAccountRoute,
  } as any)
const AuthenticatedAccountNotificationsRoute =
  AuthenticatedAccountNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedAccountRoute,
  } as any)
const AuthenticatedAccountSecurityRoute =
  AuthenticatedAccountSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => AuthenticatedAccountRoute,
  } as any)
const AuthenticatedAccountingIndexRoute =
  AuthenticatedAccountingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingAnalysisTagsRoute =
  AuthenticatedAccountingAnalysisTagsRouteImport.update({
    id: '/analysis-tags',
    path: '/analysis-tags',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingAssetsRoute =
  AuthenticatedAccountingAssetsRouteImport.update({
    id: '/assets',
    path: '/assets',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingBankRulesRoute =
  AuthenticatedAccountingBankRulesRouteImport.update({
    id: '/bank-rules',
    path: '/bank-rules',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingBankTransactionsRoute =
  AuthenticatedAccountingBankTransactionsRouteImport.update({
    id: '/bank-transactions',
    path: '/bank-transactions',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingBillsRoute =
  AuthenticatedAccountingBillsRouteImport.update({
    id: '/bills',
    path: '/bills',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingBudgetsRoute =
  AuthenticatedAccountingBudgetsRouteImport.update({
    id: '/budgets',
    path: '/budgets',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingCashSalesRoute =
  AuthenticatedAccountingCashSalesRouteImport.update({
    id: '/cash-sales',
    path: '/cash-sales',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingChartRoute =
  AuthenticatedAccountingChartRouteImport.update({
    id: '/chart',
    path: '/chart',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingChequesRoute =
  AuthenticatedAccountingChequesRouteImport.update({
    id: '/cheques',
    path: '/cheques',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingCloseRoute =
  AuthenticatedAccountingCloseRouteImport.update({
    id: '/close',
    path: '/close',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingCostCentersRoute =
  AuthenticatedAccountingCostCentersRouteImport.update({
    id: '/cost-centers',
    path: '/cost-centers',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingCreditNotesRoute =
  AuthenticatedAccountingCreditNotesRouteImport.update({
    id: '/credit-notes',
    path: '/credit-notes',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingInvoicesRoute =
  AuthenticatedAccountingInvoicesRouteImport.update({
    id: '/invoices',
    path: '/invoices',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingJournalRoute =
  AuthenticatedAccountingJournalRouteImport.update({
    id: '/journal',
    path: '/journal',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingJournalsRoute =
  AuthenticatedAccountingJournalsRouteImport.update({
    id: '/journals',
    path: '/journals',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingPaymentTermsRoute =
  AuthenticatedAccountingPaymentTermsRouteImport.update({
    id: '/payment-terms',
    path: '/payment-terms',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingPaymentsRoute =
  AuthenticatedAccountingPaymentsRouteImport.update({
    id: '/payments',
    path: '/payments',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingPeriodsRoute =
  AuthenticatedAccountingPeriodsRouteImport.update({
    id: '/periods',
    path: '/periods',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingPostingIntentsRoute =
  AuthenticatedAccountingPostingIntentsRouteImport.update({
    id: '/posting-intents',
    path: '/posting-intents',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingPrepaidRoute =
  AuthenticatedAccountingPrepaidRouteImport.update({
    id: '/prepaid',
    path: '/prepaid',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingReconciliationRoute =
  AuthenticatedAccountingReconciliationRouteImport.update({
    id: '/reconciliation',
    path: '/reconciliation',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingRecurringRoute =
  AuthenticatedAccountingRecurringRouteImport.update({
    id: '/recurring',
    path: '/recurring',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingSalesReceiptsRoute =
  AuthenticatedAccountingSalesReceiptsRouteImport.update({
    id: '/sales-receipts',
    path: '/sales-receipts',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingSettingsRoute =
  AuthenticatedAccountingSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingStatementsRoute =
  AuthenticatedAccountingStatementsRouteImport.update({
    id: '/statements',
    path: '/statements',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingTaxRoute =
  AuthenticatedAccountingTaxRouteImport.update({
    id: '/tax',
    path: '/tax',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingTrialBalanceRoute =
  AuthenticatedAccountingTrialBalanceRouteImport.update({
    id: '/trial-balance',
    path: '/trial-balance',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingWorkingCapitalRoute =
  AuthenticatedAccountingWorkingCapitalRouteImport.update({
    id: '/working-capital',
    path: '/working-capital',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingPayrollPaymentsRoute =
  AuthenticatedAccountingPayrollPaymentsRouteImport.update({
    id: '/accounting_/payroll-payments',
    path: '/accounting/payroll-payments',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCustomersIndexRoute =
  AuthenticatedCustomersIndexRouteImport.update({
    id: '/customers/',
    path: '/customers/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCustomersNewRoute =
  AuthenticatedCustomersNewRouteImport.update({
    id: '/customers/new',
    path: '/customers/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrIndexRoute = AuthenticatedHrIndexRouteImport.update({
  id: '/hr/',
  path: '/hr/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedHrAssetsRoute = AuthenticatedHrAssetsRouteImport.update({
  id: '/hr/assets',
  path: '/hr/assets',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedHrAttendanceRoute =
  AuthenticatedHrAttendanceRouteImport.update({
    id: '/hr/attendance',
    path: '/hr/attendance',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrAttendanceBoardRoute =
  AuthenticatedHrAttendanceBoardRouteImport.update({
    id: '/hr/attendance-board',
    path: '/hr/attendance-board',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrAttendanceCorrectionsRoute =
  AuthenticatedHrAttendanceCorrectionsRouteImport.update({
    id: '/hr/attendance-corrections',
    path: '/hr/attendance-corrections',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrCashCustodyRoute =
  AuthenticatedHrCashCustodyRouteImport.update({
    id: '/hr/cash-custody',
    path: '/hr/cash-custody',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrExpensesRoute = AuthenticatedHrExpensesRouteImport.update({
  id: '/hr/expenses',
  path: '/hr/expenses',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedHrFieldSettingsRoute =
  AuthenticatedHrFieldSettingsRouteImport.update({
    id: '/hr/field-settings',
    path: '/hr/field-settings',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrLeaveRoute = AuthenticatedHrLeaveRouteImport.update({
  id: '/hr/leave',
  path: '/hr/leave',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedHrOrgRoute = AuthenticatedHrOrgRouteImport.update({
  id: '/hr/org',
  path: '/hr/org',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedHrSettingsRoute = AuthenticatedHrSettingsRouteImport.update({
  id: '/hr/settings',
  path: '/hr/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedHrWorkEntriesRoute =
  AuthenticatedHrWorkEntriesRouteImport.update({
    id: '/hr/work-entries',
    path: '/hr/work-entries',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrWorkSchedulesRoute =
  AuthenticatedHrWorkSchedulesRouteImport.update({
    id: '/hr/work-schedules',
    path: '/hr/work-schedules',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInventoryIndexRoute =
  AuthenticatedInventoryIndexRouteImport.update({
    id: '/inventory/',
    path: '/inventory/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInventoryAccessRoute =
  AuthenticatedInventoryAccessRouteImport.update({
    id: '/inventory/access',
    path: '/inventory/access',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInventoryAdjustmentsRoute =
  AuthenticatedInventoryAdjustmentsRouteImport.update({
    id: '/inventory/adjustments',
    path: '/inventory/adjustments',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInventoryDisposalsRoute =
  AuthenticatedInventoryDisposalsRouteImport.update({
    id: '/inventory/disposals',
    path: '/inventory/disposals',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInventoryLocationsRoute =
  AuthenticatedInventoryLocationsRouteImport.update({
    id: '/inventory/locations',
    path: '/inventory/locations',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInventoryMovementsRoute =
  AuthenticatedInventoryMovementsRouteImport.update({
    id: '/inventory/movements',
    path: '/inventory/movements',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInventorySerialsRoute =
  AuthenticatedInventorySerialsRouteImport.update({
    id: '/inventory/serials',
    path: '/inventory/serials',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInventoryStockRoute =
  AuthenticatedInventoryStockRouteImport.update({
    id: '/inventory/stock',
    path: '/inventory/stock',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInventoryWarehousesRoute =
  AuthenticatedInventoryWarehousesRouteImport.update({
    id: '/inventory/warehouses',
    path: '/inventory/warehouses',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPayrollAdvancesRoute =
  AuthenticatedPayrollAdvancesRouteImport.update({
    id: '/advances',
    path: '/advances',
    getParentRoute: () => AuthenticatedPayrollRoute,
  } as any)
const AuthenticatedPayrollBulkAssignRoute =
  AuthenticatedPayrollBulkAssignRouteImport.update({
    id: '/bulk-assign',
    path: '/bulk-assign',
    getParentRoute: () => AuthenticatedPayrollRoute,
  } as any)
const AuthenticatedPayrollComponentsRoute =
  AuthenticatedPayrollComponentsRouteImport.update({
    id: '/components',
    path: '/components',
    getParentRoute: () => AuthenticatedPayrollRoute,
  } as any)
const AuthenticatedPayrollPayslipsRoute =
  AuthenticatedPayrollPayslipsRouteImport.update({
    id: '/payslips',
    path: '/payslips',
    getParentRoute: () => AuthenticatedPayrollRoute,
  } as any)
const AuthenticatedPayrollRunsRoute =
  AuthenticatedPayrollRunsRouteImport.update({
    id: '/runs',
    path: '/runs',
    getParentRoute: () => AuthenticatedPayrollRoute,
  } as any)
const AuthenticatedPayrollSettingsRoute =
  AuthenticatedPayrollSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedPayrollRoute,
  } as any)
const AuthenticatedProductCategoriesIndexRoute =
  AuthenticatedProductCategoriesIndexRouteImport.update({
    id: '/product-categories/',
    path: '/product-categories/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProductCategoriesNewRoute =
  AuthenticatedProductCategoriesNewRouteImport.update({
    id: '/product-categories/new',
    path: '/product-categories/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProductsIndexRoute =
  AuthenticatedProductsIndexRouteImport.update({
    id: '/products/',
    path: '/products/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProductsNewRoute =
  AuthenticatedProductsNewRouteImport.update({
    id: '/products/new',
    path: '/products/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProductsUnitsOfMeasureRoute =
  AuthenticatedProductsUnitsOfMeasureRouteImport.update({
    id: '/products/units-of-measure',
    path: '/products/units-of-measure',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPurchasingIndexRoute =
  AuthenticatedPurchasingIndexRouteImport.update({
    id: '/purchasing/',
    path: '/purchasing/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPurchasingLandedCostCategoriesRoute =
  AuthenticatedPurchasingLandedCostCategoriesRouteImport.update({
    id: '/purchasing/landed-cost-categories',
    path: '/purchasing/landed-cost-categories',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPurchasingLandedCostsRoute =
  AuthenticatedPurchasingLandedCostsRouteImport.update({
    id: '/purchasing/landed-costs',
    path: '/purchasing/landed-costs',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPurchasingOrdersRoute =
  AuthenticatedPurchasingOrdersRouteImport.update({
    id: '/purchasing/orders',
    path: '/purchasing/orders',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPurchasingReceiptsRoute =
  AuthenticatedPurchasingReceiptsRouteImport.update({
    id: '/purchasing/receipts',
    path: '/purchasing/receipts',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPurchasingReturnsRoute =
  AuthenticatedPurchasingReturnsRouteImport.update({
    id: '/purchasing/returns',
    path: '/purchasing/returns',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRecruitmentIndexRoute =
  AuthenticatedRecruitmentIndexRouteImport.update({
    id: '/recruitment/',
    path: '/recruitment/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRolesIndexRoute = AuthenticatedRolesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRolesRoute,
} as any)
const AuthenticatedRolesRoleIdRoute =
  AuthenticatedRolesRoleIdRouteImport.update({
    id: '/$roleId',
    path: '/$roleId',
    getParentRoute: () => AuthenticatedRolesRoute,
  } as any)
const AuthenticatedRolesNewRoute = AuthenticatedRolesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthenticatedRolesRoute,
} as any)
const AuthenticatedSalesIndexRoute = AuthenticatedSalesIndexRouteImport.update({
  id: '/sales/',
  path: '/sales/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSalesOrdersRoute =
  AuthenticatedSalesOrdersRouteImport.update({
    id: '/sales/orders',
    path: '/sales/orders',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSalesReservationsRoute =
  AuthenticatedSalesReservationsRouteImport.update({
    id: '/sales/reservations',
    path: '/sales/reservations',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSalesReturnsRoute =
  AuthenticatedSalesReturnsRouteImport.update({
    id: '/sales/returns',
    path: '/sales/returns',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsAlertsRoute =
  AuthenticatedSettingsAlertsRouteImport.update({
    id: '/settings/alerts',
    path: '/settings/alerts',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsDataImportRoute =
  AuthenticatedSettingsDataImportRouteImport.update({
    id: '/settings/data-import',
    path: '/settings/data-import',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsNotificationsRoute =
  AuthenticatedSettingsNotificationsRouteImport.update({
    id: '/settings/notifications',
    path: '/settings/notifications',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsWorkflowsRoute =
  AuthenticatedSettingsWorkflowsRouteImport.update({
    id: '/settings/workflows',
    path: '/settings/workflows',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSuppliersIndexRoute =
  AuthenticatedSuppliersIndexRouteImport.update({
    id: '/suppliers/',
    path: '/suppliers/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSuppliersNewRoute =
  AuthenticatedSuppliersNewRouteImport.update({
    id: '/suppliers/new',
    path: '/suppliers/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTagsIndexRoute = AuthenticatedTagsIndexRouteImport.update({
  id: '/tags/',
  path: '/tags/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAccountingAssetsAssetIdRoute =
  AuthenticatedAccountingAssetsAssetIdRouteImport.update({
    id: '/$assetId',
    path: '/$assetId',
    getParentRoute: () => AuthenticatedAccountingAssetsRoute,
  } as any)
const AuthenticatedAccountingAssetsDepreciationRoute =
  AuthenticatedAccountingAssetsDepreciationRouteImport.update({
    id: '/depreciation',
    path: '/depreciation',
    getParentRoute: () => AuthenticatedAccountingAssetsRoute,
  } as any)
const AuthenticatedAccountingBankAccountsIndexRoute =
  AuthenticatedAccountingBankAccountsIndexRouteImport.update({
    id: '/bank-accounts/',
    path: '/bank-accounts/',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingBillsNewRoute =
  AuthenticatedAccountingBillsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedAccountingBillsRoute,
  } as any)
const AuthenticatedAccountingBillsPayRoute =
  AuthenticatedAccountingBillsPayRouteImport.update({
    id: '/pay',
    path: '/pay',
    getParentRoute: () => AuthenticatedAccountingBillsRoute,
  } as any)
const AuthenticatedAccountingBudgetsBudgetIdRoute =
  AuthenticatedAccountingBudgetsBudgetIdRouteImport.update({
    id: '/$budgetId',
    path: '/$budgetId',
    getParentRoute: () => AuthenticatedAccountingBudgetsRoute,
  } as any)
const AuthenticatedAccountingBudgetsNewRoute =
  AuthenticatedAccountingBudgetsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedAccountingBudgetsRoute,
  } as any)
const AuthenticatedAccountingCardCreditsNewRoute =
  AuthenticatedAccountingCardCreditsNewRouteImport.update({
    id: '/card-credits/new',
    path: '/card-credits/new',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingCashSalesNewRoute =
  AuthenticatedAccountingCashSalesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedAccountingCashSalesRoute,
  } as any)
const AuthenticatedAccountingChequesOutstandingRoute =
  AuthenticatedAccountingChequesOutstandingRouteImport.update({
    id: '/outstanding',
    path: '/outstanding',
    getParentRoute: () => AuthenticatedAccountingChequesRoute,
  } as any)
const AuthenticatedAccountingCreditNotesNewRoute =
  AuthenticatedAccountingCreditNotesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedAccountingCreditNotesRoute,
  } as any)
const AuthenticatedAccountingDepositsIndexRoute =
  AuthenticatedAccountingDepositsIndexRouteImport.update({
    id: '/deposits/',
    path: '/deposits/',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingDepositsDepositIdRoute =
  AuthenticatedAccountingDepositsDepositIdRouteImport.update({
    id: '/deposits/$depositId',
    path: '/deposits/$depositId',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingDepositsNewRoute =
  AuthenticatedAccountingDepositsNewRouteImport.update({
    id: '/deposits/new',
    path: '/deposits/new',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingExpensesIndexRoute =
  AuthenticatedAccountingExpensesIndexRouteImport.update({
    id: '/expenses/',
    path: '/expenses/',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingExpensesDocumentIdRoute =
  AuthenticatedAccountingExpensesDocumentIdRouteImport.update({
    id: '/expenses/$documentId',
    path: '/expenses/$documentId',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingExpensesNewRoute =
  AuthenticatedAccountingExpensesNewRouteImport.update({
    id: '/expenses/new',
    path: '/expenses/new',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingInvoicesNewRoute =
  AuthenticatedAccountingInvoicesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedAccountingInvoicesRoute,
  } as any)
const AuthenticatedAccountingJournalEntryIdRoute =
  AuthenticatedAccountingJournalEntryIdRouteImport.update({
    id: '/$entryId',
    path: '/$entryId',
    getParentRoute: () => AuthenticatedAccountingJournalRoute,
  } as any)
const AuthenticatedAccountingJournalNewRoute =
  AuthenticatedAccountingJournalNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedAccountingJournalRoute,
  } as any)
const AuthenticatedAccountingOpeningBalancesIndexRoute =
  AuthenticatedAccountingOpeningBalancesIndexRouteImport.update({
    id: '/opening-balances/',
    path: '/opening-balances/',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingOpeningBalancesBatchIdRoute =
  AuthenticatedAccountingOpeningBalancesBatchIdRouteImport.update({
    id: '/opening-balances/$batchId',
    path: '/opening-balances/$batchId',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingPaymentsPaymentIdRoute =
  AuthenticatedAccountingPaymentsPaymentIdRouteImport.update({
    id: '/$paymentId',
    path: '/$paymentId',
    getParentRoute: () => AuthenticatedAccountingPaymentsRoute,
  } as any)
const AuthenticatedAccountingPaymentsNewRoute =
  AuthenticatedAccountingPaymentsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedAccountingPaymentsRoute,
  } as any)
const AuthenticatedAccountingReconcileIndexRoute =
  AuthenticatedAccountingReconcileIndexRouteImport.update({
    id: '/reconcile/',
    path: '/reconcile/',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingReconcileReconciliationIdRoute =
  AuthenticatedAccountingReconcileReconciliationIdRouteImport.update({
    id: '/reconcile/$reconciliationId',
    path: '/reconcile/$reconciliationId',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingReconciliationStatementIdRoute =
  AuthenticatedAccountingReconciliationStatementIdRouteImport.update({
    id: '/$statementId',
    path: '/$statementId',
    getParentRoute: () => AuthenticatedAccountingReconciliationRoute,
  } as any)
const AuthenticatedAccountingRefundsNewRoute =
  AuthenticatedAccountingRefundsNewRouteImport.update({
    id: '/refunds/new',
    path: '/refunds/new',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingReportsIndexRoute =
  AuthenticatedAccountingReportsIndexRouteImport.update({
    id: '/reports/',
    path: '/reports/',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingReportsReportTokenRoute =
  AuthenticatedAccountingReportsReportTokenRouteImport.update({
    id: '/reports/$reportToken',
    path: '/reports/$reportToken',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingReportsAgingRoute =
  AuthenticatedAccountingReportsAgingRouteImport.update({
    id: '/reports/aging',
    path: '/reports/aging',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingReportsBalanceSheetRoute =
  AuthenticatedAccountingReportsBalanceSheetRouteImport.update({
    id: '/reports/balance-sheet',
    path: '/reports/balance-sheet',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingReportsCashFlowRoute =
  AuthenticatedAccountingReportsCashFlowRouteImport.update({
    id: '/reports/cash-flow',
    path: '/reports/cash-flow',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingReportsCashPositionRoute =
  AuthenticatedAccountingReportsCashPositionRouteImport.update({
    id: '/reports/cash-position',
    path: '/reports/cash-position',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingReportsCostByNameRoute =
  AuthenticatedAccountingReportsCostByNameRouteImport.update({
    id: '/reports/cost-by-name',
    path: '/reports/cost-by-name',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingReportsGeneralLedgerRoute =
  AuthenticatedAccountingReportsGeneralLedgerRouteImport.update({
    id: '/reports/general-ledger',
    path: '/reports/general-ledger',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingReportsMonthlyStatementsRoute =
  AuthenticatedAccountingReportsMonthlyStatementsRouteImport.update({
    id: '/reports/monthly-statements',
    path: '/reports/monthly-statements',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingReportsProfitAndLossRoute =
  AuthenticatedAccountingReportsProfitAndLossRouteImport.update({
    id: '/reports/profit-and-loss',
    path: '/reports/profit-and-loss',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingReportsTaxRoute =
  AuthenticatedAccountingReportsTaxRouteImport.update({
    id: '/reports/tax',
    path: '/reports/tax',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingSalesReceiptsNewRoute =
  AuthenticatedAccountingSalesReceiptsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedAccountingSalesReceiptsRoute,
  } as any)
const AuthenticatedAccountingSalesIndexRoute =
  AuthenticatedAccountingSalesIndexRouteImport.update({
    id: '/sales/',
    path: '/sales/',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingSpendIndexRoute =
  AuthenticatedAccountingSpendIndexRouteImport.update({
    id: '/spend/',
    path: '/spend/',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingSpendDocumentIdRoute =
  AuthenticatedAccountingSpendDocumentIdRouteImport.update({
    id: '/spend/$documentId',
    path: '/spend/$documentId',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingSpendNewRoute =
  AuthenticatedAccountingSpendNewRouteImport.update({
    id: '/spend/new',
    path: '/spend/new',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingSupplierCreditsNewRoute =
  AuthenticatedAccountingSupplierCreditsNewRouteImport.update({
    id: '/supplier-credits/new',
    path: '/supplier-credits/new',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingSupplierStatementSupplierIdRoute =
  AuthenticatedAccountingSupplierStatementSupplierIdRouteImport.update({
    id: '/supplier-statement/$supplierId',
    path: '/supplier-statement/$supplierId',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingTransfersNewRoute =
  AuthenticatedAccountingTransfersNewRouteImport.update({
    id: '/transfers/new',
    path: '/transfers/new',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedCustomersCustomerIdIndexRoute =
  AuthenticatedCustomersCustomerIdIndexRouteImport.update({
    id: '/customers/$customerId/',
    path: '/customers/$customerId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCustomersCustomerIdEditRoute =
  AuthenticatedCustomersCustomerIdEditRouteImport.update({
    id: '/customers/$customerId/edit',
    path: '/customers/$customerId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedGroupReportsIndexRoute =
  AuthenticatedGroupReportsIndexRouteImport.update({
    id: '/group/reports/',
    path: '/group/reports/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedGroupReportsBalanceSheetRoute =
  AuthenticatedGroupReportsBalanceSheetRouteImport.update({
    id: '/group/reports/balance-sheet',
    path: '/group/reports/balance-sheet',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedGroupReportsProfitAndLossRoute =
  AuthenticatedGroupReportsProfitAndLossRouteImport.update({
    id: '/group/reports/profit-and-loss',
    path: '/group/reports/profit-and-loss',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrAssetsAssetIdRoute =
  AuthenticatedHrAssetsAssetIdRouteImport.update({
    id: '/$assetId',
    path: '/$assetId',
    getParentRoute: () => AuthenticatedHrAssetsRoute,
  } as any)
const AuthenticatedHrAttendanceCorrectionsRequestIdRoute =
  AuthenticatedHrAttendanceCorrectionsRequestIdRouteImport.update({
    id: '/$requestId',
    path: '/$requestId',
    getParentRoute: () => AuthenticatedHrAttendanceCorrectionsRoute,
  } as any)
const AuthenticatedHrCashCustodyCustodyIdRoute =
  AuthenticatedHrCashCustodyCustodyIdRouteImport.update({
    id: '/$custodyId',
    path: '/$custodyId',
    getParentRoute: () => AuthenticatedHrCashCustodyRoute,
  } as any)
const AuthenticatedHrEmployeesIndexRoute =
  AuthenticatedHrEmployeesIndexRouteImport.update({
    id: '/hr/employees/',
    path: '/hr/employees/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrEmployeesEmployeeIdRoute =
  AuthenticatedHrEmployeesEmployeeIdRouteImport.update({
    id: '/hr/employees/$employeeId',
    path: '/hr/employees/$employeeId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrEmployeesNewRoute =
  AuthenticatedHrEmployeesNewRouteImport.update({
    id: '/hr/employees/new',
    path: '/hr/employees/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrExpensesClaimIdRoute =
  AuthenticatedHrExpensesClaimIdRouteImport.update({
    id: '/$claimId',
    path: '/$claimId',
    getParentRoute: () => AuthenticatedHrExpensesRoute,
  } as any)
const AuthenticatedHrLeaveRequestIdRoute =
  AuthenticatedHrLeaveRequestIdRouteImport.update({
    id: '/$requestId',
    path: '/$requestId',
    getParentRoute: () => AuthenticatedHrLeaveRoute,
  } as any)
const AuthenticatedHrPerformanceIndexRoute =
  AuthenticatedHrPerformanceIndexRouteImport.update({
    id: '/hr/performance/',
    path: '/hr/performance/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrPerformanceSchedulesRoute =
  AuthenticatedHrPerformanceSchedulesRouteImport.update({
    id: '/hr/performance/schedules',
    path: '/hr/performance/schedules',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrPerformanceTemplatesRoute =
  AuthenticatedHrPerformanceTemplatesRouteImport.update({
    id: '/hr/performance/templates',
    path: '/hr/performance/templates',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsIndexRoute =
  AuthenticatedHrReportsIndexRouteImport.update({
    id: '/hr/reports/',
    path: '/hr/reports/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsAbsenceCoverageRoute =
  AuthenticatedHrReportsAbsenceCoverageRouteImport.update({
    id: '/hr/reports/absence-coverage',
    path: '/hr/reports/absence-coverage',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsAbsenceDetailRoute =
  AuthenticatedHrReportsAbsenceDetailRouteImport.update({
    id: '/hr/reports/absence-detail',
    path: '/hr/reports/absence-detail',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsAnalyticsRoute =
  AuthenticatedHrReportsAnalyticsRouteImport.update({
    id: '/hr/reports/analytics',
    path: '/hr/reports/analytics',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsAssetCustodyRoute =
  AuthenticatedHrReportsAssetCustodyRouteImport.update({
    id: '/hr/reports/asset-custody',
    path: '/hr/reports/asset-custody',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsAssetExceptionsRoute =
  AuthenticatedHrReportsAssetExceptionsRouteImport.update({
    id: '/hr/reports/asset-exceptions',
    path: '/hr/reports/asset-exceptions',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsAttendanceExceptionsRoute =
  AuthenticatedHrReportsAttendanceExceptionsRouteImport.update({
    id: '/hr/reports/attendance-exceptions',
    path: '/hr/reports/attendance-exceptions',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsAttendanceSheetRoute =
  AuthenticatedHrReportsAttendanceSheetRouteImport.update({
    id: '/hr/reports/attendance-sheet',
    path: '/hr/reports/attendance-sheet',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsAttendanceSummaryRoute =
  AuthenticatedHrReportsAttendanceSummaryRouteImport.update({
    id: '/hr/reports/attendance-summary',
    path: '/hr/reports/attendance-summary',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsBirthdaysRoute =
  AuthenticatedHrReportsBirthdaysRouteImport.update({
    id: '/hr/reports/birthdays',
    path: '/hr/reports/birthdays',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsBreaksSessionsRoute =
  AuthenticatedHrReportsBreaksSessionsRouteImport.update({
    id: '/hr/reports/breaks-sessions',
    path: '/hr/reports/breaks-sessions',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsCashCustodyBalancesRoute =
  AuthenticatedHrReportsCashCustodyBalancesRouteImport.update({
    id: '/hr/reports/cash-custody-balances',
    path: '/hr/reports/cash-custody-balances',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsDemographicsRoute =
  AuthenticatedHrReportsDemographicsRouteImport.update({
    id: '/hr/reports/demographics',
    path: '/hr/reports/demographics',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsDocumentExpiryRoute =
  AuthenticatedHrReportsDocumentExpiryRouteImport.update({
    id: '/hr/reports/document-expiry',
    path: '/hr/reports/document-expiry',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsExpenseAgeingRoute =
  AuthenticatedHrReportsExpenseAgeingRouteImport.update({
    id: '/hr/reports/expense-ageing',
    path: '/hr/reports/expense-ageing',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsExpenseClaimsRoute =
  AuthenticatedHrReportsExpenseClaimsRouteImport.update({
    id: '/hr/reports/expense-claims',
    path: '/hr/reports/expense-claims',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsHeadcountRoute =
  AuthenticatedHrReportsHeadcountRouteImport.update({
    id: '/hr/reports/headcount',
    path: '/hr/reports/headcount',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsHolidayRollRoute =
  AuthenticatedHrReportsHolidayRollRouteImport.update({
    id: '/hr/reports/holiday-roll',
    path: '/hr/reports/holiday-roll',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsJoinersLeaversRoute =
  AuthenticatedHrReportsJoinersLeaversRouteImport.update({
    id: '/hr/reports/joiners-leavers',
    path: '/hr/reports/joiners-leavers',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsLatenessRoute =
  AuthenticatedHrReportsLatenessRouteImport.update({
    id: '/hr/reports/lateness',
    path: '/hr/reports/lateness',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsLeaveBalancesRoute =
  AuthenticatedHrReportsLeaveBalancesRouteImport.update({
    id: '/hr/reports/leave-balances',
    path: '/hr/reports/leave-balances',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsLeaveLiabilityRoute =
  AuthenticatedHrReportsLeaveLiabilityRouteImport.update({
    id: '/hr/reports/leave-liability',
    path: '/hr/reports/leave-liability',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsLeaveTakenRoute =
  AuthenticatedHrReportsLeaveTakenRouteImport.update({
    id: '/hr/reports/leave-taken',
    path: '/hr/reports/leave-taken',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsOrgHygieneRoute =
  AuthenticatedHrReportsOrgHygieneRouteImport.update({
    id: '/hr/reports/org-hygiene',
    path: '/hr/reports/org-hygiene',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsOvertimeRoute =
  AuthenticatedHrReportsOvertimeRouteImport.update({
    id: '/hr/reports/overtime',
    path: '/hr/reports/overtime',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsPayrollDeductionsRoute =
  AuthenticatedHrReportsPayrollDeductionsRouteImport.update({
    id: '/hr/reports/payroll-deductions',
    path: '/hr/reports/payroll-deductions',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsPayrollRegisterRoute =
  AuthenticatedHrReportsPayrollRegisterRouteImport.update({
    id: '/hr/reports/payroll-register',
    path: '/hr/reports/payroll-register',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsPayrollSummaryRoute =
  AuthenticatedHrReportsPayrollSummaryRouteImport.update({
    id: '/hr/reports/payroll-summary',
    path: '/hr/reports/payroll-summary',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsPayrollVarianceRoute =
  AuthenticatedHrReportsPayrollVarianceRouteImport.update({
    id: '/hr/reports/payroll-variance',
    path: '/hr/reports/payroll-variance',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsPermissionRequestsRoute =
  AuthenticatedHrReportsPermissionRequestsRouteImport.update({
    id: '/hr/reports/permission-requests',
    path: '/hr/reports/permission-requests',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsProbationContractRoute =
  AuthenticatedHrReportsProbationContractRouteImport.update({
    id: '/hr/reports/probation-contract',
    path: '/hr/reports/probation-contract',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsReviewCompletionRoute =
  AuthenticatedHrReportsReviewCompletionRouteImport.update({
    id: '/hr/reports/review-completion',
    path: '/hr/reports/review-completion',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsRosterBankRoute =
  AuthenticatedHrReportsRosterBankRouteImport.update({
    id: '/hr/reports/roster-bank',
    path: '/hr/reports/roster-bank',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsRosterCompensationRoute =
  AuthenticatedHrReportsRosterCompensationRouteImport.update({
    id: '/hr/reports/roster-compensation',
    path: '/hr/reports/roster-compensation',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsRosterContactRoute =
  AuthenticatedHrReportsRosterContactRouteImport.update({
    id: '/hr/reports/roster-contact',
    path: '/hr/reports/roster-contact',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsRosterEmergencyRoute =
  AuthenticatedHrReportsRosterEmergencyRouteImport.update({
    id: '/hr/reports/roster-emergency',
    path: '/hr/reports/roster-emergency',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsRosterEmploymentRoute =
  AuthenticatedHrReportsRosterEmploymentRouteImport.update({
    id: '/hr/reports/roster-employment',
    path: '/hr/reports/roster-employment',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsRosterTeamMemberRoute =
  AuthenticatedHrReportsRosterTeamMemberRouteImport.update({
    id: '/hr/reports/roster-team-member',
    path: '/hr/reports/roster-team-member',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsScoreDistributionRoute =
  AuthenticatedHrReportsScoreDistributionRouteImport.update({
    id: '/hr/reports/score-distribution',
    path: '/hr/reports/score-distribution',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsTimeOffReviewRoute =
  AuthenticatedHrReportsTimeOffReviewRouteImport.update({
    id: '/hr/reports/time-off-review',
    path: '/hr/reports/time-off-review',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsTurnoverRoute =
  AuthenticatedHrReportsTurnoverRouteImport.update({
    id: '/hr/reports/turnover',
    path: '/hr/reports/turnover',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsViolationsRoute =
  AuthenticatedHrReportsViolationsRouteImport.update({
    id: '/hr/reports/violations',
    path: '/hr/reports/violations',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrReportsWorkHoursRoute =
  AuthenticatedHrReportsWorkHoursRouteImport.update({
    id: '/hr/reports/work-hours',
    path: '/hr/reports/work-hours',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrViolationsIndexRoute =
  AuthenticatedHrViolationsIndexRouteImport.update({
    id: '/hr/violations/',
    path: '/hr/violations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrViolationsViolationIdRoute =
  AuthenticatedHrViolationsViolationIdRouteImport.update({
    id: '/hr/violations/$violationId',
    path: '/hr/violations/$violationId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInventoryCountsIndexRoute =
  AuthenticatedInventoryCountsIndexRouteImport.update({
    id: '/inventory/counts/',
    path: '/inventory/counts/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInventoryLotsIndexRoute =
  AuthenticatedInventoryLotsIndexRouteImport.update({
    id: '/inventory/lots/',
    path: '/inventory/lots/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInventoryLotsLotIdRoute =
  AuthenticatedInventoryLotsLotIdRouteImport.update({
    id: '/inventory/lots/$lotId',
    path: '/inventory/lots/$lotId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInventoryReportsIndexRoute =
  AuthenticatedInventoryReportsIndexRouteImport.update({
    id: '/inventory/reports/',
    path: '/inventory/reports/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInventoryReportsAgingRoute =
  AuthenticatedInventoryReportsAgingRouteImport.update({
    id: '/inventory/reports/aging',
    path: '/inventory/reports/aging',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInventoryReportsNoSalesRoute =
  AuthenticatedInventoryReportsNoSalesRouteImport.update({
    id: '/inventory/reports/no-sales',
    path: '/inventory/reports/no-sales',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInventoryReportsPerformanceRoute =
  AuthenticatedInventoryReportsPerformanceRouteImport.update({
    id: '/inventory/reports/performance',
    path: '/inventory/reports/performance',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInventoryReportsReplenishmentRoute =
  AuthenticatedInventoryReportsReplenishmentRouteImport.update({
    id: '/inventory/reports/replenishment',
    path: '/inventory/reports/replenishment',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInventoryReportsStockValuationRoute =
  AuthenticatedInventoryReportsStockValuationRouteImport.update({
    id: '/inventory/reports/stock-valuation',
    path: '/inventory/reports/stock-valuation',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInventoryReportsStockValueRoute =
  AuthenticatedInventoryReportsStockValueRouteImport.update({
    id: '/inventory/reports/stock-value',
    path: '/inventory/reports/stock-value',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInventorySerialsUnitIdRoute =
  AuthenticatedInventorySerialsUnitIdRouteImport.update({
    id: '/$unitId',
    path: '/$unitId',
    getParentRoute: () => AuthenticatedInventorySerialsRoute,
  } as any)
const AuthenticatedInventoryTransfersIndexRoute =
  AuthenticatedInventoryTransfersIndexRouteImport.update({
    id: '/inventory/transfers/',
    path: '/inventory/transfers/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInventoryTransfersTransferIdRoute =
  AuthenticatedInventoryTransfersTransferIdRouteImport.update({
    id: '/inventory/transfers/$transferId',
    path: '/inventory/transfers/$transferId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInventoryTransfersNewRoute =
  AuthenticatedInventoryTransfersNewRouteImport.update({
    id: '/inventory/transfers/new',
    path: '/inventory/transfers/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPayrollPayslipsPayslipIdRoute =
  AuthenticatedPayrollPayslipsPayslipIdRouteImport.update({
    id: '/$payslipId',
    path: '/$payslipId',
    getParentRoute: () => AuthenticatedPayrollPayslipsRoute,
  } as any)
const AuthenticatedPayrollRunsRunIdRoute =
  AuthenticatedPayrollRunsRunIdRouteImport.update({
    id: '/$runId',
    path: '/$runId',
    getParentRoute: () => AuthenticatedPayrollRunsRoute,
  } as any)
const AuthenticatedPayrollSettlementsRunIdRoute =
  AuthenticatedPayrollSettlementsRunIdRouteImport.update({
    id: '/settlements/$runId',
    path: '/settlements/$runId',
    getParentRoute: () => AuthenticatedPayrollRoute,
  } as any)
const AuthenticatedProductCategoriesCategoryIdEditRoute =
  AuthenticatedProductCategoriesCategoryIdEditRouteImport.update({
    id: '/product-categories/$categoryId/edit',
    path: '/product-categories/$categoryId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProductsProductIdIndexRoute =
  AuthenticatedProductsProductIdIndexRouteImport.update({
    id: '/products/$productId/',
    path: '/products/$productId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProductsProductIdEditRoute =
  AuthenticatedProductsProductIdEditRouteImport.update({
    id: '/products/$productId/edit',
    path: '/products/$productId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPurchasingLandedCostsNewRoute =
  AuthenticatedPurchasingLandedCostsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedPurchasingLandedCostsRoute,
  } as any)
const AuthenticatedPurchasingOrdersNewRoute =
  AuthenticatedPurchasingOrdersNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedPurchasingOrdersRoute,
  } as any)
const AuthenticatedPurchasingReportsGoodsReceivedNotInvoicedRoute =
  AuthenticatedPurchasingReportsGoodsReceivedNotInvoicedRouteImport.update({
    id: '/purchasing/reports/goods-received-not-invoiced',
    path: '/purchasing/reports/goods-received-not-invoiced',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPurchasingReportsLandedCostsPendingRoute =
  AuthenticatedPurchasingReportsLandedCostsPendingRouteImport.update({
    id: '/purchasing/reports/landed-costs-pending',
    path: '/purchasing/reports/landed-costs-pending',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPurchasingReportsThreeWayMatchRoute =
  AuthenticatedPurchasingReportsThreeWayMatchRouteImport.update({
    id: '/purchasing/reports/three-way-match',
    path: '/purchasing/reports/three-way-match',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPurchasingReturnsNewRoute =
  AuthenticatedPurchasingReturnsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedPurchasingReturnsRoute,
  } as any)
const AuthenticatedRecruitmentCandidatesCandidateIdRoute =
  AuthenticatedRecruitmentCandidatesCandidateIdRouteImport.update({
    id: '/recruitment/candidates/$candidateId',
    path: '/recruitment/candidates/$candidateId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRecruitmentOpeningsOpeningIdRoute =
  AuthenticatedRecruitmentOpeningsOpeningIdRouteImport.update({
    id: '/recruitment/openings/$openingId',
    path: '/recruitment/openings/$openingId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSalesOrdersNewRoute =
  AuthenticatedSalesOrdersNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedSalesOrdersRoute,
  } as any)
const AuthenticatedSalesReportsTrendRoute =
  AuthenticatedSalesReportsTrendRouteImport.update({
    id: '/sales/reports/trend',
    path: '/sales/reports/trend',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSalesReturnsNewRoute =
  AuthenticatedSalesReturnsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedSalesReturnsRoute,
  } as any)
const AuthenticatedSuppliersSupplierIdIndexRoute =
  AuthenticatedSuppliersSupplierIdIndexRouteImport.update({
    id: '/suppliers/$supplierId/',
    path: '/suppliers/$supplierId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSuppliersSupplierIdEditRoute =
  AuthenticatedSuppliersSupplierIdEditRouteImport.update({
    id: '/suppliers/$supplierId/edit',
    path: '/suppliers/$supplierId/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountingAccountsAccountIdRegisterRoute =
  AuthenticatedAccountingAccountsAccountIdRegisterRouteImport.update({
    id: '/accounts/$accountId/register',
    path: '/accounts/$accountId/register',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingBankAccountsAccountIdIndexRoute =
  AuthenticatedAccountingBankAccountsAccountIdIndexRouteImport.update({
    id: '/bank-accounts/$accountId/',
    path: '/bank-accounts/$accountId/',
    getParentRoute: () => AuthenticatedAccountingRoute,
  } as any)
const AuthenticatedAccountingBillsBillIdIndexRoute =
  AuthenticatedAccountingBillsBillIdIndexRouteImport.update({
    id: '/$billId/',
    path: '/$billId/',
    getParentRoute: () => AuthenticatedAccountingBillsRoute,
  } as any)
const AuthenticatedAccountingBillsBillIdDebitNoteRoute =
  AuthenticatedAccountingBillsBillIdDebitNoteRouteImport.update({
    id: '/$billId/debit-note',
    path: '/$billId/debit-note',
    getParentRoute: () => AuthenticatedAccountingBillsRoute,
  } as any)
const AuthenticatedAccountingBillsBillIdEditRoute =
  AuthenticatedAccountingBillsBillIdEditRouteImport.update({
    id: '/$billId/edit',
    path: '/$billId/edit',
    getParentRoute: () => AuthenticatedAccountingBillsRoute,
  } as any)
const AuthenticatedAccountingCashSalesCashSaleIdIndexRoute =
  AuthenticatedAccountingCashSalesCashSaleIdIndexRouteImport.update({
    id: '/$cashSaleId/',
    path: '/$cashSaleId/',
    getParentRoute: () => AuthenticatedAccountingCashSalesRoute,
  } as any)
const AuthenticatedAccountingCashSalesCashSaleIdEditRoute =
  AuthenticatedAccountingCashSalesCashSaleIdEditRouteImport.update({
    id: '/$cashSaleId/edit',
    path: '/$cashSaleId/edit',
    getParentRoute: () => AuthenticatedAccountingCashSalesRoute,
  } as any)
const AuthenticatedAccountingChequesChequeIdIndexRoute =
  AuthenticatedAccountingChequesChequeIdIndexRouteImport.update({
    id: '/$chequeId/',
    path: '/$chequeId/',
    getParentRoute: () => AuthenticatedAccountingChequesRoute,
  } as any)
const AuthenticatedAccountingInvoicesInvoiceIdIndexRoute =
  AuthenticatedAccountingInvoicesInvoiceIdIndexRouteImport.update({
    id: '/$invoiceId/',
    path: '/$invoiceId/',
    getParentRoute: () => AuthenticatedAccountingInvoicesRoute,
  } as any)
const AuthenticatedAccountingInvoicesInvoiceIdCreditNoteRoute =
  AuthenticatedAccountingInvoicesInvoiceIdCreditNoteRouteImport.update({
    id: '/$invoiceId/credit-note',
    path: '/$invoiceId/credit-note',
    getParentRoute: () => AuthenticatedAccountingInvoicesRoute,
  } as any)
const AuthenticatedAccountingInvoicesInvoiceIdEditRoute =
  AuthenticatedAccountingInvoicesInvoiceIdEditRouteImport.update({
    id: '/$invoiceId/edit',
    path: '/$invoiceId/edit',
    getParentRoute: () => AuthenticatedAccountingInvoicesRoute,
  } as any)
const AuthenticatedAccountingSalesReceiptsCashSaleIdIndexRoute =
  AuthenticatedAccountingSalesReceiptsCashSaleIdIndexRouteImport.update({
    id: '/$cashSaleId/',
    path: '/$cashSaleId/',
    getParentRoute: () => AuthenticatedAccountingSalesReceiptsRoute,
  } as any)
const AuthenticatedAccountingSalesReceiptsCashSaleIdEditRoute =
  AuthenticatedAccountingSalesReceiptsCashSaleIdEditRouteImport.update({
    id: '/$cashSaleId/edit',
    path: '/$cashSaleId/edit',
    getParentRoute: () => AuthenticatedAccountingSalesReceiptsRoute,
  } as any)
const AuthenticatedHrEmployeesEmployeeIdEditRoute =
  AuthenticatedHrEmployeesEmployeeIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedHrEmployeesEmployeeIdRoute,
  } as any)
const AuthenticatedHrEmployeesEmployeeIdOnboardingRoute =
  AuthenticatedHrEmployeesEmployeeIdOnboardingRouteImport.update({
    id: '/onboarding',
    path: '/onboarding',
    getParentRoute: () => AuthenticatedHrEmployeesEmployeeIdRoute,
  } as any)
const AuthenticatedHrPerformanceCyclesCycleIdRoute =
  AuthenticatedHrPerformanceCyclesCycleIdRouteImport.update({
    id: '/hr/performance/cycles/$cycleId',
    path: '/hr/performance/cycles/$cycleId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrPerformanceReviewsReviewIdRoute =
  AuthenticatedHrPerformanceReviewsReviewIdRouteImport.update({
    id: '/hr/performance/reviews/$reviewId',
    path: '/hr/performance/reviews/$reviewId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInventoryCountsSessionIdIndexRoute =
  AuthenticatedInventoryCountsSessionIdIndexRouteImport.update({
    id: '/inventory/counts/$sessionId/',
    path: '/inventory/counts/$sessionId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInventoryCountsSessionIdReviewRoute =
  AuthenticatedInventoryCountsSessionIdReviewRouteImport.update({
    id: '/inventory/counts/$sessionId/review',
    path: '/inventory/counts/$sessionId/review',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInventoryReportsInsightsReportRoute =
  AuthenticatedInventoryReportsInsightsReportRouteImport.update({
    id: '/inventory/reports/insights/$report',
    path: '/inventory/reports/insights/$report',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPurchasingLandedCostsLandedCostIdIndexRoute =
  AuthenticatedPurchasingLandedCostsLandedCostIdIndexRouteImport.update({
    id: '/$landedCostId/',
    path: '/$landedCostId/',
    getParentRoute: () => AuthenticatedPurchasingLandedCostsRoute,
  } as any)
const AuthenticatedPurchasingOrdersOrderIdIndexRoute =
  AuthenticatedPurchasingOrdersOrderIdIndexRouteImport.update({
    id: '/$orderId/',
    path: '/$orderId/',
    getParentRoute: () => AuthenticatedPurchasingOrdersRoute,
  } as any)
const AuthenticatedPurchasingOrdersOrderIdEditRoute =
  AuthenticatedPurchasingOrdersOrderIdEditRouteImport.update({
    id: '/$orderId/edit',
    path: '/$orderId/edit',
    getParentRoute: () => AuthenticatedPurchasingOrdersRoute,
  } as any)
const AuthenticatedPurchasingOrdersOrderIdReceiveRoute =
  AuthenticatedPurchasingOrdersOrderIdReceiveRouteImport.update({
    id: '/$orderId/receive',
    path: '/$orderId/receive',
    getParentRoute: () => AuthenticatedPurchasingOrdersRoute,
  } as any)
const AuthenticatedPurchasingReceiptsReceiptIdIndexRoute =
  AuthenticatedPurchasingReceiptsReceiptIdIndexRouteImport.update({
    id: '/$receiptId/',
    path: '/$receiptId/',
    getParentRoute: () => AuthenticatedPurchasingReceiptsRoute,
  } as any)
const AuthenticatedPurchasingReturnsReturnIdIndexRoute =
  AuthenticatedPurchasingReturnsReturnIdIndexRouteImport.update({
    id: '/$returnId/',
    path: '/$returnId/',
    getParentRoute: () => AuthenticatedPurchasingReturnsRoute,
  } as any)
const AuthenticatedSalesOrdersOrderIdIndexRoute =
  AuthenticatedSalesOrdersOrderIdIndexRouteImport.update({
    id: '/$orderId/',
    path: '/$orderId/',
    getParentRoute: () => AuthenticatedSalesOrdersRoute,
  } as any)
const AuthenticatedSalesOrdersOrderIdEditRoute =
  AuthenticatedSalesOrdersOrderIdEditRouteImport.update({
    id: '/$orderId/edit',
    path: '/$orderId/edit',
    getParentRoute: () => AuthenticatedSalesOrdersRoute,
  } as any)
const AuthenticatedSalesReturnsReturnIdIndexRoute =
  AuthenticatedSalesReturnsReturnIdIndexRouteImport.update({
    id: '/$returnId/',
    path: '/$returnId/',
    getParentRoute: () => AuthenticatedSalesReturnsRoute,
  } as any)
const AuthenticatedAccountingBankAccountsAccountIdReconcileReconciliationIdRoute =
  AuthenticatedAccountingBankAccountsAccountIdReconcileReconciliationIdRouteImport.update(
    {
      id: '/bank-accounts/$accountId/reconcile/$reconciliationId',
      path: '/bank-accounts/$accountId/reconcile/$reconciliationId',
      getParentRoute: () => AuthenticatedAccountingRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/accept-invitation': typeof AcceptInvitationRoute
  '/activate': typeof ActivateRoute
  '/face-diagnostics': typeof FaceDiagnosticsRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/get-the-app': typeof GetTheAppRoute
  '/kiosk': typeof KioskRoute
  '/login': typeof LoginRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/reset-code': typeof ResetCodeRoute
  '/reset-password': typeof ResetPasswordRoute
  '/two-factor': typeof TwoFactorRoute
  '/$': typeof AuthenticatedSplatRoute
  '/account': typeof AuthenticatedAccountRouteWithChildren
  '/accounting': typeof AuthenticatedAccountingRouteWithChildren
  '/alerts': typeof AuthenticatedAlertsRoute
  '/approvals': typeof AuthenticatedApprovalsRoute
  '/audit': typeof AuthenticatedAuditRoute
  '/branches': typeof AuthenticatedBranchesRoute
  '/collections': typeof AuthenticatedCollectionsRoute
  '/companies': typeof AuthenticatedCompaniesRoute
  '/departments': typeof AuthenticatedDepartmentsRoute
  '/notifications': typeof AuthenticatedNotificationsRoute
  '/payroll': typeof AuthenticatedPayrollRouteWithChildren
  '/positions': typeof AuthenticatedPositionsRoute
  '/product-attributes': typeof AuthenticatedProductAttributesRoute
  '/roles': typeof AuthenticatedRolesRouteWithChildren
  '/sequences': typeof AuthenticatedSequencesRoute
  '/two-factor-setup': typeof AuthenticatedTwoFactorSetupRoute
  '/users': typeof AuthenticatedUsersRoute
  '/apply/$token': typeof ApplyTokenRoute
  '/support/ended': typeof SupportEndedRoute
  '/support/enter': typeof SupportEnterRoute
  '/account/notifications': typeof AuthenticatedAccountNotificationsRoute
  '/account/security': typeof AuthenticatedAccountSecurityRoute
  '/accounting/analysis-tags': typeof AuthenticatedAccountingAnalysisTagsRoute
  '/accounting/assets': typeof AuthenticatedAccountingAssetsRouteWithChildren
  '/accounting/bank-rules': typeof AuthenticatedAccountingBankRulesRoute
  '/accounting/bank-transactions': typeof AuthenticatedAccountingBankTransactionsRoute
  '/accounting/bills': typeof AuthenticatedAccountingBillsRouteWithChildren
  '/accounting/budgets': typeof AuthenticatedAccountingBudgetsRouteWithChildren
  '/accounting/cash-sales': typeof AuthenticatedAccountingCashSalesRouteWithChildren
  '/accounting/chart': typeof AuthenticatedAccountingChartRoute
  '/accounting/cheques': typeof AuthenticatedAccountingChequesRouteWithChildren
  '/accounting/close': typeof AuthenticatedAccountingCloseRoute
  '/accounting/cost-centers': typeof AuthenticatedAccountingCostCentersRoute
  '/accounting/credit-notes': typeof AuthenticatedAccountingCreditNotesRouteWithChildren
  '/accounting/invoices': typeof AuthenticatedAccountingInvoicesRouteWithChildren
  '/accounting/journal': typeof AuthenticatedAccountingJournalRouteWithChildren
  '/accounting/journals': typeof AuthenticatedAccountingJournalsRoute
  '/accounting/payment-terms': typeof AuthenticatedAccountingPaymentTermsRoute
  '/accounting/payments': typeof AuthenticatedAccountingPaymentsRouteWithChildren
  '/accounting/periods': typeof AuthenticatedAccountingPeriodsRoute
  '/accounting/posting-intents': typeof AuthenticatedAccountingPostingIntentsRoute
  '/accounting/prepaid': typeof AuthenticatedAccountingPrepaidRoute
  '/accounting/reconciliation': typeof AuthenticatedAccountingReconciliationRouteWithChildren
  '/accounting/recurring': typeof AuthenticatedAccountingRecurringRoute
  '/accounting/sales-receipts': typeof AuthenticatedAccountingSalesReceiptsRouteWithChildren
  '/accounting/settings': typeof AuthenticatedAccountingSettingsRoute
  '/accounting/statements': typeof AuthenticatedAccountingStatementsRoute
  '/accounting/tax': typeof AuthenticatedAccountingTaxRoute
  '/accounting/trial-balance': typeof AuthenticatedAccountingTrialBalanceRoute
  '/accounting/working-capital': typeof AuthenticatedAccountingWorkingCapitalRoute
  '/accounting/payroll-payments': typeof AuthenticatedAccountingPayrollPaymentsRoute
  '/customers/new': typeof AuthenticatedCustomersNewRoute
  '/hr/assets': typeof AuthenticatedHrAssetsRouteWithChildren
  '/hr/attendance': typeof AuthenticatedHrAttendanceRoute
  '/hr/attendance-board': typeof AuthenticatedHrAttendanceBoardRoute
  '/hr/attendance-corrections': typeof AuthenticatedHrAttendanceCorrectionsRouteWithChildren
  '/hr/cash-custody': typeof AuthenticatedHrCashCustodyRouteWithChildren
  '/hr/expenses': typeof AuthenticatedHrExpensesRouteWithChildren
  '/hr/field-settings': typeof AuthenticatedHrFieldSettingsRoute
  '/hr/leave': typeof AuthenticatedHrLeaveRouteWithChildren
  '/hr/org': typeof AuthenticatedHrOrgRoute
  '/hr/settings': typeof AuthenticatedHrSettingsRoute
  '/hr/work-entries': typeof AuthenticatedHrWorkEntriesRoute
  '/hr/work-schedules': typeof AuthenticatedHrWorkSchedulesRoute
  '/inventory/access': typeof AuthenticatedInventoryAccessRoute
  '/inventory/adjustments': typeof AuthenticatedInventoryAdjustmentsRoute
  '/inventory/disposals': typeof AuthenticatedInventoryDisposalsRoute
  '/inventory/locations': typeof AuthenticatedInventoryLocationsRoute
  '/inventory/movements': typeof AuthenticatedInventoryMovementsRoute
  '/inventory/serials': typeof AuthenticatedInventorySerialsRouteWithChildren
  '/inventory/stock': typeof AuthenticatedInventoryStockRoute
  '/inventory/warehouses': typeof AuthenticatedInventoryWarehousesRoute
  '/payroll/advances': typeof AuthenticatedPayrollAdvancesRoute
  '/payroll/bulk-assign': typeof AuthenticatedPayrollBulkAssignRoute
  '/payroll/components': typeof AuthenticatedPayrollComponentsRoute
  '/payroll/payslips': typeof AuthenticatedPayrollPayslipsRouteWithChildren
  '/payroll/runs': typeof AuthenticatedPayrollRunsRouteWithChildren
  '/payroll/settings': typeof AuthenticatedPayrollSettingsRoute
  '/product-categories/new': typeof AuthenticatedProductCategoriesNewRoute
  '/products/new': typeof AuthenticatedProductsNewRoute
  '/products/units-of-measure': typeof AuthenticatedProductsUnitsOfMeasureRoute
  '/purchasing/landed-cost-categories': typeof AuthenticatedPurchasingLandedCostCategoriesRoute
  '/purchasing/landed-costs': typeof AuthenticatedPurchasingLandedCostsRouteWithChildren
  '/purchasing/orders': typeof AuthenticatedPurchasingOrdersRouteWithChildren
  '/purchasing/receipts': typeof AuthenticatedPurchasingReceiptsRouteWithChildren
  '/purchasing/returns': typeof AuthenticatedPurchasingReturnsRouteWithChildren
  '/roles/$roleId': typeof AuthenticatedRolesRoleIdRoute
  '/roles/new': typeof AuthenticatedRolesNewRoute
  '/sales/orders': typeof AuthenticatedSalesOrdersRouteWithChildren
  '/sales/reservations': typeof AuthenticatedSalesReservationsRoute
  '/sales/returns': typeof AuthenticatedSalesReturnsRouteWithChildren
  '/settings/alerts': typeof AuthenticatedSettingsAlertsRoute
  '/settings/data-import': typeof AuthenticatedSettingsDataImportRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/settings/workflows': typeof AuthenticatedSettingsWorkflowsRoute
  '/suppliers/new': typeof AuthenticatedSuppliersNewRoute
  '/account/': typeof AuthenticatedAccountIndexRoute
  '/accounting/': typeof AuthenticatedAccountingIndexRoute
  '/customers/': typeof AuthenticatedCustomersIndexRoute
  '/hr/': typeof AuthenticatedHrIndexRoute
  '/inventory/': typeof AuthenticatedInventoryIndexRoute
  '/product-categories/': typeof AuthenticatedProductCategoriesIndexRoute
  '/products/': typeof AuthenticatedProductsIndexRoute
  '/purchasing/': typeof AuthenticatedPurchasingIndexRoute
  '/recruitment/': typeof AuthenticatedRecruitmentIndexRoute
  '/roles/': typeof AuthenticatedRolesIndexRoute
  '/sales/': typeof AuthenticatedSalesIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/suppliers/': typeof AuthenticatedSuppliersIndexRoute
  '/tags/': typeof AuthenticatedTagsIndexRoute
  '/accounting/assets/$assetId': typeof AuthenticatedAccountingAssetsAssetIdRoute
  '/accounting/assets/depreciation': typeof AuthenticatedAccountingAssetsDepreciationRoute
  '/accounting/bills/new': typeof AuthenticatedAccountingBillsNewRoute
  '/accounting/bills/pay': typeof AuthenticatedAccountingBillsPayRoute
  '/accounting/budgets/$budgetId': typeof AuthenticatedAccountingBudgetsBudgetIdRoute
  '/accounting/budgets/new': typeof AuthenticatedAccountingBudgetsNewRoute
  '/accounting/card-credits/new': typeof AuthenticatedAccountingCardCreditsNewRoute
  '/accounting/cash-sales/new': typeof AuthenticatedAccountingCashSalesNewRoute
  '/accounting/cheques/outstanding': typeof AuthenticatedAccountingChequesOutstandingRoute
  '/accounting/credit-notes/new': typeof AuthenticatedAccountingCreditNotesNewRoute
  '/accounting/deposits/$depositId': typeof AuthenticatedAccountingDepositsDepositIdRoute
  '/accounting/deposits/new': typeof AuthenticatedAccountingDepositsNewRoute
  '/accounting/expenses/$documentId': typeof AuthenticatedAccountingExpensesDocumentIdRoute
  '/accounting/expenses/new': typeof AuthenticatedAccountingExpensesNewRoute
  '/accounting/invoices/new': typeof AuthenticatedAccountingInvoicesNewRoute
  '/accounting/journal/$entryId': typeof AuthenticatedAccountingJournalEntryIdRoute
  '/accounting/journal/new': typeof AuthenticatedAccountingJournalNewRoute
  '/accounting/opening-balances/$batchId': typeof AuthenticatedAccountingOpeningBalancesBatchIdRoute
  '/accounting/payments/$paymentId': typeof AuthenticatedAccountingPaymentsPaymentIdRoute
  '/accounting/payments/new': typeof AuthenticatedAccountingPaymentsNewRoute
  '/accounting/reconcile/$reconciliationId': typeof AuthenticatedAccountingReconcileReconciliationIdRoute
  '/accounting/reconciliation/$statementId': typeof AuthenticatedAccountingReconciliationStatementIdRoute
  '/accounting/refunds/new': typeof AuthenticatedAccountingRefundsNewRoute
  '/accounting/reports/$reportToken': typeof AuthenticatedAccountingReportsReportTokenRoute
  '/accounting/reports/aging': typeof AuthenticatedAccountingReportsAgingRoute
  '/accounting/reports/balance-sheet': typeof AuthenticatedAccountingReportsBalanceSheetRoute
  '/accounting/reports/cash-flow': typeof AuthenticatedAccountingReportsCashFlowRoute
  '/accounting/reports/cash-position': typeof AuthenticatedAccountingReportsCashPositionRoute
  '/accounting/reports/cost-by-name': typeof AuthenticatedAccountingReportsCostByNameRoute
  '/accounting/reports/general-ledger': typeof AuthenticatedAccountingReportsGeneralLedgerRoute
  '/accounting/reports/monthly-statements': typeof AuthenticatedAccountingReportsMonthlyStatementsRoute
  '/accounting/reports/profit-and-loss': typeof AuthenticatedAccountingReportsProfitAndLossRoute
  '/accounting/reports/tax': typeof AuthenticatedAccountingReportsTaxRoute
  '/accounting/sales-receipts/new': typeof AuthenticatedAccountingSalesReceiptsNewRoute
  '/accounting/spend/$documentId': typeof AuthenticatedAccountingSpendDocumentIdRoute
  '/accounting/spend/new': typeof AuthenticatedAccountingSpendNewRoute
  '/accounting/supplier-credits/new': typeof AuthenticatedAccountingSupplierCreditsNewRoute
  '/accounting/supplier-statement/$supplierId': typeof AuthenticatedAccountingSupplierStatementSupplierIdRoute
  '/accounting/transfers/new': typeof AuthenticatedAccountingTransfersNewRoute
  '/customers/$customerId/edit': typeof AuthenticatedCustomersCustomerIdEditRoute
  '/group/reports/balance-sheet': typeof AuthenticatedGroupReportsBalanceSheetRoute
  '/group/reports/profit-and-loss': typeof AuthenticatedGroupReportsProfitAndLossRoute
  '/hr/assets/$assetId': typeof AuthenticatedHrAssetsAssetIdRoute
  '/hr/attendance-corrections/$requestId': typeof AuthenticatedHrAttendanceCorrectionsRequestIdRoute
  '/hr/cash-custody/$custodyId': typeof AuthenticatedHrCashCustodyCustodyIdRoute
  '/hr/employees/$employeeId': typeof AuthenticatedHrEmployeesEmployeeIdRouteWithChildren
  '/hr/employees/new': typeof AuthenticatedHrEmployeesNewRoute
  '/hr/expenses/$claimId': typeof AuthenticatedHrExpensesClaimIdRoute
  '/hr/leave/$requestId': typeof AuthenticatedHrLeaveRequestIdRoute
  '/hr/performance/schedules': typeof AuthenticatedHrPerformanceSchedulesRoute
  '/hr/performance/templates': typeof AuthenticatedHrPerformanceTemplatesRoute
  '/hr/reports/absence-coverage': typeof AuthenticatedHrReportsAbsenceCoverageRoute
  '/hr/reports/absence-detail': typeof AuthenticatedHrReportsAbsenceDetailRoute
  '/hr/reports/analytics': typeof AuthenticatedHrReportsAnalyticsRoute
  '/hr/reports/asset-custody': typeof AuthenticatedHrReportsAssetCustodyRoute
  '/hr/reports/asset-exceptions': typeof AuthenticatedHrReportsAssetExceptionsRoute
  '/hr/reports/attendance-exceptions': typeof AuthenticatedHrReportsAttendanceExceptionsRoute
  '/hr/reports/attendance-sheet': typeof AuthenticatedHrReportsAttendanceSheetRoute
  '/hr/reports/attendance-summary': typeof AuthenticatedHrReportsAttendanceSummaryRoute
  '/hr/reports/birthdays': typeof AuthenticatedHrReportsBirthdaysRoute
  '/hr/reports/breaks-sessions': typeof AuthenticatedHrReportsBreaksSessionsRoute
  '/hr/reports/cash-custody-balances': typeof AuthenticatedHrReportsCashCustodyBalancesRoute
  '/hr/reports/demographics': typeof AuthenticatedHrReportsDemographicsRoute
  '/hr/reports/document-expiry': typeof AuthenticatedHrReportsDocumentExpiryRoute
  '/hr/reports/expense-ageing': typeof AuthenticatedHrReportsExpenseAgeingRoute
  '/hr/reports/expense-claims': typeof AuthenticatedHrReportsExpenseClaimsRoute
  '/hr/reports/headcount': typeof AuthenticatedHrReportsHeadcountRoute
  '/hr/reports/holiday-roll': typeof AuthenticatedHrReportsHolidayRollRoute
  '/hr/reports/joiners-leavers': typeof AuthenticatedHrReportsJoinersLeaversRoute
  '/hr/reports/lateness': typeof AuthenticatedHrReportsLatenessRoute
  '/hr/reports/leave-balances': typeof AuthenticatedHrReportsLeaveBalancesRoute
  '/hr/reports/leave-liability': typeof AuthenticatedHrReportsLeaveLiabilityRoute
  '/hr/reports/leave-taken': typeof AuthenticatedHrReportsLeaveTakenRoute
  '/hr/reports/org-hygiene': typeof AuthenticatedHrReportsOrgHygieneRoute
  '/hr/reports/overtime': typeof AuthenticatedHrReportsOvertimeRoute
  '/hr/reports/payroll-deductions': typeof AuthenticatedHrReportsPayrollDeductionsRoute
  '/hr/reports/payroll-register': typeof AuthenticatedHrReportsPayrollRegisterRoute
  '/hr/reports/payroll-summary': typeof AuthenticatedHrReportsPayrollSummaryRoute
  '/hr/reports/payroll-variance': typeof AuthenticatedHrReportsPayrollVarianceRoute
  '/hr/reports/permission-requests': typeof AuthenticatedHrReportsPermissionRequestsRoute
  '/hr/reports/probation-contract': typeof AuthenticatedHrReportsProbationContractRoute
  '/hr/reports/review-completion': typeof AuthenticatedHrReportsReviewCompletionRoute
  '/hr/reports/roster-bank': typeof AuthenticatedHrReportsRosterBankRoute
  '/hr/reports/roster-compensation': typeof AuthenticatedHrReportsRosterCompensationRoute
  '/hr/reports/roster-contact': typeof AuthenticatedHrReportsRosterContactRoute
  '/hr/reports/roster-emergency': typeof AuthenticatedHrReportsRosterEmergencyRoute
  '/hr/reports/roster-employment': typeof AuthenticatedHrReportsRosterEmploymentRoute
  '/hr/reports/roster-team-member': typeof AuthenticatedHrReportsRosterTeamMemberRoute
  '/hr/reports/score-distribution': typeof AuthenticatedHrReportsScoreDistributionRoute
  '/hr/reports/time-off-review': typeof AuthenticatedHrReportsTimeOffReviewRoute
  '/hr/reports/turnover': typeof AuthenticatedHrReportsTurnoverRoute
  '/hr/reports/violations': typeof AuthenticatedHrReportsViolationsRoute
  '/hr/reports/work-hours': typeof AuthenticatedHrReportsWorkHoursRoute
  '/hr/violations/$violationId': typeof AuthenticatedHrViolationsViolationIdRoute
  '/inventory/lots/$lotId': typeof AuthenticatedInventoryLotsLotIdRoute
  '/inventory/reports/aging': typeof AuthenticatedInventoryReportsAgingRoute
  '/inventory/reports/no-sales': typeof AuthenticatedInventoryReportsNoSalesRoute
  '/inventory/reports/performance': typeof AuthenticatedInventoryReportsPerformanceRoute
  '/inventory/reports/replenishment': typeof AuthenticatedInventoryReportsReplenishmentRoute
  '/inventory/reports/stock-valuation': typeof AuthenticatedInventoryReportsStockValuationRoute
  '/inventory/reports/stock-value': typeof AuthenticatedInventoryReportsStockValueRoute
  '/inventory/serials/$unitId': typeof AuthenticatedInventorySerialsUnitIdRoute
  '/inventory/transfers/$transferId': typeof AuthenticatedInventoryTransfersTransferIdRoute
  '/inventory/transfers/new': typeof AuthenticatedInventoryTransfersNewRoute
  '/payroll/payslips/$payslipId': typeof AuthenticatedPayrollPayslipsPayslipIdRoute
  '/payroll/runs/$runId': typeof AuthenticatedPayrollRunsRunIdRoute
  '/payroll/settlements/$runId': typeof AuthenticatedPayrollSettlementsRunIdRoute
  '/product-categories/$categoryId/edit': typeof AuthenticatedProductCategoriesCategoryIdEditRoute
  '/products/$productId/edit': typeof AuthenticatedProductsProductIdEditRoute
  '/purchasing/landed-costs/new': typeof AuthenticatedPurchasingLandedCostsNewRoute
  '/purchasing/orders/new': typeof AuthenticatedPurchasingOrdersNewRoute
  '/purchasing/reports/goods-received-not-invoiced': typeof AuthenticatedPurchasingReportsGoodsReceivedNotInvoicedRoute
  '/purchasing/reports/landed-costs-pending': typeof AuthenticatedPurchasingReportsLandedCostsPendingRoute
  '/purchasing/reports/three-way-match': typeof AuthenticatedPurchasingReportsThreeWayMatchRoute
  '/purchasing/returns/new': typeof AuthenticatedPurchasingReturnsNewRoute
  '/recruitment/candidates/$candidateId': typeof AuthenticatedRecruitmentCandidatesCandidateIdRoute
  '/recruitment/openings/$openingId': typeof AuthenticatedRecruitmentOpeningsOpeningIdRoute
  '/sales/orders/new': typeof AuthenticatedSalesOrdersNewRoute
  '/sales/reports/trend': typeof AuthenticatedSalesReportsTrendRoute
  '/sales/returns/new': typeof AuthenticatedSalesReturnsNewRoute
  '/suppliers/$supplierId/edit': typeof AuthenticatedSuppliersSupplierIdEditRoute
  '/accounting/bank-accounts/': typeof AuthenticatedAccountingBankAccountsIndexRoute
  '/accounting/deposits/': typeof AuthenticatedAccountingDepositsIndexRoute
  '/accounting/expenses/': typeof AuthenticatedAccountingExpensesIndexRoute
  '/accounting/opening-balances/': typeof AuthenticatedAccountingOpeningBalancesIndexRoute
  '/accounting/reconcile/': typeof AuthenticatedAccountingReconcileIndexRoute
  '/accounting/reports/': typeof AuthenticatedAccountingReportsIndexRoute
  '/accounting/sales/': typeof AuthenticatedAccountingSalesIndexRoute
  '/accounting/spend/': typeof AuthenticatedAccountingSpendIndexRoute
  '/customers/$customerId/': typeof AuthenticatedCustomersCustomerIdIndexRoute
  '/group/reports/': typeof AuthenticatedGroupReportsIndexRoute
  '/hr/employees/': typeof AuthenticatedHrEmployeesIndexRoute
  '/hr/performance/': typeof AuthenticatedHrPerformanceIndexRoute
  '/hr/reports/': typeof AuthenticatedHrReportsIndexRoute
  '/hr/violations/': typeof AuthenticatedHrViolationsIndexRoute
  '/inventory/counts/': typeof AuthenticatedInventoryCountsIndexRoute
  '/inventory/lots/': typeof AuthenticatedInventoryLotsIndexRoute
  '/inventory/reports/': typeof AuthenticatedInventoryReportsIndexRoute
  '/inventory/transfers/': typeof AuthenticatedInventoryTransfersIndexRoute
  '/products/$productId/': typeof AuthenticatedProductsProductIdIndexRoute
  '/suppliers/$supplierId/': typeof AuthenticatedSuppliersSupplierIdIndexRoute
  '/accounting/accounts/$accountId/register': typeof AuthenticatedAccountingAccountsAccountIdRegisterRoute
  '/accounting/bills/$billId/debit-note': typeof AuthenticatedAccountingBillsBillIdDebitNoteRoute
  '/accounting/bills/$billId/edit': typeof AuthenticatedAccountingBillsBillIdEditRoute
  '/accounting/cash-sales/$cashSaleId/edit': typeof AuthenticatedAccountingCashSalesCashSaleIdEditRoute
  '/accounting/invoices/$invoiceId/credit-note': typeof AuthenticatedAccountingInvoicesInvoiceIdCreditNoteRoute
  '/accounting/invoices/$invoiceId/edit': typeof AuthenticatedAccountingInvoicesInvoiceIdEditRoute
  '/accounting/sales-receipts/$cashSaleId/edit': typeof AuthenticatedAccountingSalesReceiptsCashSaleIdEditRoute
  '/hr/employees/$employeeId/edit': typeof AuthenticatedHrEmployeesEmployeeIdEditRoute
  '/hr/employees/$employeeId/onboarding': typeof AuthenticatedHrEmployeesEmployeeIdOnboardingRoute
  '/hr/performance/cycles/$cycleId': typeof AuthenticatedHrPerformanceCyclesCycleIdRoute
  '/hr/performance/reviews/$reviewId': typeof AuthenticatedHrPerformanceReviewsReviewIdRoute
  '/inventory/counts/$sessionId/review': typeof AuthenticatedInventoryCountsSessionIdReviewRoute
  '/inventory/reports/insights/$report': typeof AuthenticatedInventoryReportsInsightsReportRoute
  '/purchasing/orders/$orderId/edit': typeof AuthenticatedPurchasingOrdersOrderIdEditRoute
  '/purchasing/orders/$orderId/receive': typeof AuthenticatedPurchasingOrdersOrderIdReceiveRoute
  '/sales/orders/$orderId/edit': typeof AuthenticatedSalesOrdersOrderIdEditRoute
  '/accounting/bank-accounts/$accountId/': typeof AuthenticatedAccountingBankAccountsAccountIdIndexRoute
  '/accounting/bills/$billId/': typeof AuthenticatedAccountingBillsBillIdIndexRoute
  '/accounting/cash-sales/$cashSaleId/': typeof AuthenticatedAccountingCashSalesCashSaleIdIndexRoute
  '/accounting/cheques/$chequeId/': typeof AuthenticatedAccountingChequesChequeIdIndexRoute
  '/accounting/invoices/$invoiceId/': typeof AuthenticatedAccountingInvoicesInvoiceIdIndexRoute
  '/accounting/sales-receipts/$cashSaleId/': typeof AuthenticatedAccountingSalesReceiptsCashSaleIdIndexRoute
  '/inventory/counts/$sessionId/': typeof AuthenticatedInventoryCountsSessionIdIndexRoute
  '/purchasing/landed-costs/$landedCostId/': typeof AuthenticatedPurchasingLandedCostsLandedCostIdIndexRoute
  '/purchasing/orders/$orderId/': typeof AuthenticatedPurchasingOrdersOrderIdIndexRoute
  '/purchasing/receipts/$receiptId/': typeof AuthenticatedPurchasingReceiptsReceiptIdIndexRoute
  '/purchasing/returns/$returnId/': typeof AuthenticatedPurchasingReturnsReturnIdIndexRoute
  '/sales/orders/$orderId/': typeof AuthenticatedSalesOrdersOrderIdIndexRoute
  '/sales/returns/$returnId/': typeof AuthenticatedSalesReturnsReturnIdIndexRoute
  '/accounting/bank-accounts/$accountId/reconcile/$reconciliationId': typeof AuthenticatedAccountingBankAccountsAccountIdReconcileReconciliationIdRoute
}
export interface FileRoutesByTo {
  '/accept-invitation': typeof AcceptInvitationRoute
  '/activate': typeof ActivateRoute
  '/face-diagnostics': typeof FaceDiagnosticsRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/get-the-app': typeof GetTheAppRoute
  '/kiosk': typeof KioskRoute
  '/login': typeof LoginRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/reset-code': typeof ResetCodeRoute
  '/reset-password': typeof ResetPasswordRoute
  '/two-factor': typeof TwoFactorRoute
  '/$': typeof AuthenticatedSplatRoute
  '/alerts': typeof AuthenticatedAlertsRoute
  '/approvals': typeof AuthenticatedApprovalsRoute
  '/audit': typeof AuthenticatedAuditRoute
  '/branches': typeof AuthenticatedBranchesRoute
  '/collections': typeof AuthenticatedCollectionsRoute
  '/companies': typeof AuthenticatedCompaniesRoute
  '/departments': typeof AuthenticatedDepartmentsRoute
  '/notifications': typeof AuthenticatedNotificationsRoute
  '/payroll': typeof AuthenticatedPayrollRouteWithChildren
  '/positions': typeof AuthenticatedPositionsRoute
  '/product-attributes': typeof AuthenticatedProductAttributesRoute
  '/sequences': typeof AuthenticatedSequencesRoute
  '/two-factor-setup': typeof AuthenticatedTwoFactorSetupRoute
  '/users': typeof AuthenticatedUsersRoute
  '/apply/$token': typeof ApplyTokenRoute
  '/support/ended': typeof SupportEndedRoute
  '/support/enter': typeof SupportEnterRoute
  '/': typeof AuthenticatedIndexRoute
  '/account/notifications': typeof AuthenticatedAccountNotificationsRoute
  '/account/security': typeof AuthenticatedAccountSecurityRoute
  '/accounting/analysis-tags': typeof AuthenticatedAccountingAnalysisTagsRoute
  '/accounting/assets': typeof AuthenticatedAccountingAssetsRouteWithChildren
  '/accounting/bank-rules': typeof AuthenticatedAccountingBankRulesRoute
  '/accounting/bank-transactions': typeof AuthenticatedAccountingBankTransactionsRoute
  '/accounting/bills': typeof AuthenticatedAccountingBillsRouteWithChildren
  '/accounting/budgets': typeof AuthenticatedAccountingBudgetsRouteWithChildren
  '/accounting/cash-sales': typeof AuthenticatedAccountingCashSalesRouteWithChildren
  '/accounting/chart': typeof AuthenticatedAccountingChartRoute
  '/accounting/cheques': typeof AuthenticatedAccountingChequesRouteWithChildren
  '/accounting/close': typeof AuthenticatedAccountingCloseRoute
  '/accounting/cost-centers': typeof AuthenticatedAccountingCostCentersRoute
  '/accounting/credit-notes': typeof AuthenticatedAccountingCreditNotesRouteWithChildren
  '/accounting/invoices': typeof AuthenticatedAccountingInvoicesRouteWithChildren
  '/accounting/journal': typeof AuthenticatedAccountingJournalRouteWithChildren
  '/accounting/journals': typeof AuthenticatedAccountingJournalsRoute
  '/accounting/payment-terms': typeof AuthenticatedAccountingPaymentTermsRoute
  '/accounting/payments': typeof AuthenticatedAccountingPaymentsRouteWithChildren
  '/accounting/periods': typeof AuthenticatedAccountingPeriodsRoute
  '/accounting/posting-intents': typeof AuthenticatedAccountingPostingIntentsRoute
  '/accounting/prepaid': typeof AuthenticatedAccountingPrepaidRoute
  '/accounting/reconciliation': typeof AuthenticatedAccountingReconciliationRouteWithChildren
  '/accounting/recurring': typeof AuthenticatedAccountingRecurringRoute
  '/accounting/sales-receipts': typeof AuthenticatedAccountingSalesReceiptsRouteWithChildren
  '/accounting/settings': typeof AuthenticatedAccountingSettingsRoute
  '/accounting/statements': typeof AuthenticatedAccountingStatementsRoute
  '/accounting/tax': typeof AuthenticatedAccountingTaxRoute
  '/accounting/trial-balance': typeof AuthenticatedAccountingTrialBalanceRoute
  '/accounting/working-capital': typeof AuthenticatedAccountingWorkingCapitalRoute
  '/accounting/payroll-payments': typeof AuthenticatedAccountingPayrollPaymentsRoute
  '/customers/new': typeof AuthenticatedCustomersNewRoute
  '/hr/assets': typeof AuthenticatedHrAssetsRouteWithChildren
  '/hr/attendance': typeof AuthenticatedHrAttendanceRoute
  '/hr/attendance-board': typeof AuthenticatedHrAttendanceBoardRoute
  '/hr/attendance-corrections': typeof AuthenticatedHrAttendanceCorrectionsRouteWithChildren
  '/hr/cash-custody': typeof AuthenticatedHrCashCustodyRouteWithChildren
  '/hr/expenses': typeof AuthenticatedHrExpensesRouteWithChildren
  '/hr/field-settings': typeof AuthenticatedHrFieldSettingsRoute
  '/hr/leave': typeof AuthenticatedHrLeaveRouteWithChildren
  '/hr/org': typeof AuthenticatedHrOrgRoute
  '/hr/settings': typeof AuthenticatedHrSettingsRoute
  '/hr/work-entries': typeof AuthenticatedHrWorkEntriesRoute
  '/hr/work-schedules': typeof AuthenticatedHrWorkSchedulesRoute
  '/inventory/access': typeof AuthenticatedInventoryAccessRoute
  '/inventory/adjustments': typeof AuthenticatedInventoryAdjustmentsRoute
  '/inventory/disposals': typeof AuthenticatedInventoryDisposalsRoute
  '/inventory/locations': typeof AuthenticatedInventoryLocationsRoute
  '/inventory/movements': typeof AuthenticatedInventoryMovementsRoute
  '/inventory/serials': typeof AuthenticatedInventorySerialsRouteWithChildren
  '/inventory/stock': typeof AuthenticatedInventoryStockRoute
  '/inventory/warehouses': typeof AuthenticatedInventoryWarehousesRoute
  '/payroll/advances': typeof AuthenticatedPayrollAdvancesRoute
  '/payroll/bulk-assign': typeof AuthenticatedPayrollBulkAssignRoute
  '/payroll/components': typeof AuthenticatedPayrollComponentsRoute
  '/payroll/payslips': typeof AuthenticatedPayrollPayslipsRouteWithChildren
  '/payroll/runs': typeof AuthenticatedPayrollRunsRouteWithChildren
  '/payroll/settings': typeof AuthenticatedPayrollSettingsRoute
  '/product-categories/new': typeof AuthenticatedProductCategoriesNewRoute
  '/products/new': typeof AuthenticatedProductsNewRoute
  '/products/units-of-measure': typeof AuthenticatedProductsUnitsOfMeasureRoute
  '/purchasing/landed-cost-categories': typeof AuthenticatedPurchasingLandedCostCategoriesRoute
  '/purchasing/landed-costs': typeof AuthenticatedPurchasingLandedCostsRouteWithChildren
  '/purchasing/orders': typeof AuthenticatedPurchasingOrdersRouteWithChildren
  '/purchasing/receipts': typeof AuthenticatedPurchasingReceiptsRouteWithChildren
  '/purchasing/returns': typeof AuthenticatedPurchasingReturnsRouteWithChildren
  '/roles/$roleId': typeof AuthenticatedRolesRoleIdRoute
  '/roles/new': typeof AuthenticatedRolesNewRoute
  '/sales/orders': typeof AuthenticatedSalesOrdersRouteWithChildren
  '/sales/reservations': typeof AuthenticatedSalesReservationsRoute
  '/sales/returns': typeof AuthenticatedSalesReturnsRouteWithChildren
  '/settings/alerts': typeof AuthenticatedSettingsAlertsRoute
  '/settings/data-import': typeof AuthenticatedSettingsDataImportRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/settings/workflows': typeof AuthenticatedSettingsWorkflowsRoute
  '/suppliers/new': typeof AuthenticatedSuppliersNewRoute
  '/account': typeof AuthenticatedAccountIndexRoute
  '/accounting': typeof AuthenticatedAccountingIndexRoute
  '/customers': typeof AuthenticatedCustomersIndexRoute
  '/hr': typeof AuthenticatedHrIndexRoute
  '/inventory': typeof AuthenticatedInventoryIndexRoute
  '/product-categories': typeof AuthenticatedProductCategoriesIndexRoute
  '/products': typeof AuthenticatedProductsIndexRoute
  '/purchasing': typeof AuthenticatedPurchasingIndexRoute
  '/recruitment': typeof AuthenticatedRecruitmentIndexRoute
  '/roles': typeof AuthenticatedRolesIndexRoute
  '/sales': typeof AuthenticatedSalesIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/suppliers': typeof AuthenticatedSuppliersIndexRoute
  '/tags': typeof AuthenticatedTagsIndexRoute
  '/accounting/assets/$assetId': typeof AuthenticatedAccountingAssetsAssetIdRoute
  '/accounting/assets/depreciation': typeof AuthenticatedAccountingAssetsDepreciationRoute
  '/accounting/bills/new': typeof AuthenticatedAccountingBillsNewRoute
  '/accounting/bills/pay': typeof AuthenticatedAccountingBillsPayRoute
  '/accounting/budgets/$budgetId': typeof AuthenticatedAccountingBudgetsBudgetIdRoute
  '/accounting/budgets/new': typeof AuthenticatedAccountingBudgetsNewRoute
  '/accounting/card-credits/new': typeof AuthenticatedAccountingCardCreditsNewRoute
  '/accounting/cash-sales/new': typeof AuthenticatedAccountingCashSalesNewRoute
  '/accounting/cheques/outstanding': typeof AuthenticatedAccountingChequesOutstandingRoute
  '/accounting/credit-notes/new': typeof AuthenticatedAccountingCreditNotesNewRoute
  '/accounting/deposits/$depositId': typeof AuthenticatedAccountingDepositsDepositIdRoute
  '/accounting/deposits/new': typeof AuthenticatedAccountingDepositsNewRoute
  '/accounting/expenses/$documentId': typeof AuthenticatedAccountingExpensesDocumentIdRoute
  '/accounting/expenses/new': typeof AuthenticatedAccountingExpensesNewRoute
  '/accounting/invoices/new': typeof AuthenticatedAccountingInvoicesNewRoute
  '/accounting/journal/$entryId': typeof AuthenticatedAccountingJournalEntryIdRoute
  '/accounting/journal/new': typeof AuthenticatedAccountingJournalNewRoute
  '/accounting/opening-balances/$batchId': typeof AuthenticatedAccountingOpeningBalancesBatchIdRoute
  '/accounting/payments/$paymentId': typeof AuthenticatedAccountingPaymentsPaymentIdRoute
  '/accounting/payments/new': typeof AuthenticatedAccountingPaymentsNewRoute
  '/accounting/reconcile/$reconciliationId': typeof AuthenticatedAccountingReconcileReconciliationIdRoute
  '/accounting/reconciliation/$statementId': typeof AuthenticatedAccountingReconciliationStatementIdRoute
  '/accounting/refunds/new': typeof AuthenticatedAccountingRefundsNewRoute
  '/accounting/reports/$reportToken': typeof AuthenticatedAccountingReportsReportTokenRoute
  '/accounting/reports/aging': typeof AuthenticatedAccountingReportsAgingRoute
  '/accounting/reports/balance-sheet': typeof AuthenticatedAccountingReportsBalanceSheetRoute
  '/accounting/reports/cash-flow': typeof AuthenticatedAccountingReportsCashFlowRoute
  '/accounting/reports/cash-position': typeof AuthenticatedAccountingReportsCashPositionRoute
  '/accounting/reports/cost-by-name': typeof AuthenticatedAccountingReportsCostByNameRoute
  '/accounting/reports/general-ledger': typeof AuthenticatedAccountingReportsGeneralLedgerRoute
  '/accounting/reports/monthly-statements': typeof AuthenticatedAccountingReportsMonthlyStatementsRoute
  '/accounting/reports/profit-and-loss': typeof AuthenticatedAccountingReportsProfitAndLossRoute
  '/accounting/reports/tax': typeof AuthenticatedAccountingReportsTaxRoute
  '/accounting/sales-receipts/new': typeof AuthenticatedAccountingSalesReceiptsNewRoute
  '/accounting/spend/$documentId': typeof AuthenticatedAccountingSpendDocumentIdRoute
  '/accounting/spend/new': typeof AuthenticatedAccountingSpendNewRoute
  '/accounting/supplier-credits/new': typeof AuthenticatedAccountingSupplierCreditsNewRoute
  '/accounting/supplier-statement/$supplierId': typeof AuthenticatedAccountingSupplierStatementSupplierIdRoute
  '/accounting/transfers/new': typeof AuthenticatedAccountingTransfersNewRoute
  '/customers/$customerId/edit': typeof AuthenticatedCustomersCustomerIdEditRoute
  '/group/reports/balance-sheet': typeof AuthenticatedGroupReportsBalanceSheetRoute
  '/group/reports/profit-and-loss': typeof AuthenticatedGroupReportsProfitAndLossRoute
  '/hr/assets/$assetId': typeof AuthenticatedHrAssetsAssetIdRoute
  '/hr/attendance-corrections/$requestId': typeof AuthenticatedHrAttendanceCorrectionsRequestIdRoute
  '/hr/cash-custody/$custodyId': typeof AuthenticatedHrCashCustodyCustodyIdRoute
  '/hr/employees/$employeeId': typeof AuthenticatedHrEmployeesEmployeeIdRouteWithChildren
  '/hr/employees/new': typeof AuthenticatedHrEmployeesNewRoute
  '/hr/expenses/$claimId': typeof AuthenticatedHrExpensesClaimIdRoute
  '/hr/leave/$requestId': typeof AuthenticatedHrLeaveRequestIdRoute
  '/hr/performance/schedules': typeof AuthenticatedHrPerformanceSchedulesRoute
  '/hr/performance/templates': typeof AuthenticatedHrPerformanceTemplatesRoute
  '/hr/reports/absence-coverage': typeof AuthenticatedHrReportsAbsenceCoverageRoute
  '/hr/reports/absence-detail': typeof AuthenticatedHrReportsAbsenceDetailRoute
  '/hr/reports/analytics': typeof AuthenticatedHrReportsAnalyticsRoute
  '/hr/reports/asset-custody': typeof AuthenticatedHrReportsAssetCustodyRoute
  '/hr/reports/asset-exceptions': typeof AuthenticatedHrReportsAssetExceptionsRoute
  '/hr/reports/attendance-exceptions': typeof AuthenticatedHrReportsAttendanceExceptionsRoute
  '/hr/reports/attendance-sheet': typeof AuthenticatedHrReportsAttendanceSheetRoute
  '/hr/reports/attendance-summary': typeof AuthenticatedHrReportsAttendanceSummaryRoute
  '/hr/reports/birthdays': typeof AuthenticatedHrReportsBirthdaysRoute
  '/hr/reports/breaks-sessions': typeof AuthenticatedHrReportsBreaksSessionsRoute
  '/hr/reports/cash-custody-balances': typeof AuthenticatedHrReportsCashCustodyBalancesRoute
  '/hr/reports/demographics': typeof AuthenticatedHrReportsDemographicsRoute
  '/hr/reports/document-expiry': typeof AuthenticatedHrReportsDocumentExpiryRoute
  '/hr/reports/expense-ageing': typeof AuthenticatedHrReportsExpenseAgeingRoute
  '/hr/reports/expense-claims': typeof AuthenticatedHrReportsExpenseClaimsRoute
  '/hr/reports/headcount': typeof AuthenticatedHrReportsHeadcountRoute
  '/hr/reports/holiday-roll': typeof AuthenticatedHrReportsHolidayRollRoute
  '/hr/reports/joiners-leavers': typeof AuthenticatedHrReportsJoinersLeaversRoute
  '/hr/reports/lateness': typeof AuthenticatedHrReportsLatenessRoute
  '/hr/reports/leave-balances': typeof AuthenticatedHrReportsLeaveBalancesRoute
  '/hr/reports/leave-liability': typeof AuthenticatedHrReportsLeaveLiabilityRoute
  '/hr/reports/leave-taken': typeof AuthenticatedHrReportsLeaveTakenRoute
  '/hr/reports/org-hygiene': typeof AuthenticatedHrReportsOrgHygieneRoute
  '/hr/reports/overtime': typeof AuthenticatedHrReportsOvertimeRoute
  '/hr/reports/payroll-deductions': typeof AuthenticatedHrReportsPayrollDeductionsRoute
  '/hr/reports/payroll-register': typeof AuthenticatedHrReportsPayrollRegisterRoute
  '/hr/reports/payroll-summary': typeof AuthenticatedHrReportsPayrollSummaryRoute
  '/hr/reports/payroll-variance': typeof AuthenticatedHrReportsPayrollVarianceRoute
  '/hr/reports/permission-requests': typeof AuthenticatedHrReportsPermissionRequestsRoute
  '/hr/reports/probation-contract': typeof AuthenticatedHrReportsProbationContractRoute
  '/hr/reports/review-completion': typeof AuthenticatedHrReportsReviewCompletionRoute
  '/hr/reports/roster-bank': typeof AuthenticatedHrReportsRosterBankRoute
  '/hr/reports/roster-compensation': typeof AuthenticatedHrReportsRosterCompensationRoute
  '/hr/reports/roster-contact': typeof AuthenticatedHrReportsRosterContactRoute
  '/hr/reports/roster-emergency': typeof AuthenticatedHrReportsRosterEmergencyRoute
  '/hr/reports/roster-employment': typeof AuthenticatedHrReportsRosterEmploymentRoute
  '/hr/reports/roster-team-member': typeof AuthenticatedHrReportsRosterTeamMemberRoute
  '/hr/reports/score-distribution': typeof AuthenticatedHrReportsScoreDistributionRoute
  '/hr/reports/time-off-review': typeof AuthenticatedHrReportsTimeOffReviewRoute
  '/hr/reports/turnover': typeof AuthenticatedHrReportsTurnoverRoute
  '/hr/reports/violations': typeof AuthenticatedHrReportsViolationsRoute
  '/hr/reports/work-hours': typeof AuthenticatedHrReportsWorkHoursRoute
  '/hr/violations/$violationId': typeof AuthenticatedHrViolationsViolationIdRoute
  '/inventory/lots/$lotId': typeof AuthenticatedInventoryLotsLotIdRoute
  '/inventory/reports/aging': typeof AuthenticatedInventoryReportsAgingRoute
  '/inventory/reports/no-sales': typeof AuthenticatedInventoryReportsNoSalesRoute
  '/inventory/reports/performance': typeof AuthenticatedInventoryReportsPerformanceRoute
  '/inventory/reports/replenishment': typeof AuthenticatedInventoryReportsReplenishmentRoute
  '/inventory/reports/stock-valuation': typeof AuthenticatedInventoryReportsStockValuationRoute
  '/inventory/reports/stock-value': typeof AuthenticatedInventoryReportsStockValueRoute
  '/inventory/serials/$unitId': typeof AuthenticatedInventorySerialsUnitIdRoute
  '/inventory/transfers/$transferId': typeof AuthenticatedInventoryTransfersTransferIdRoute
  '/inventory/transfers/new': typeof AuthenticatedInventoryTransfersNewRoute
  '/payroll/payslips/$payslipId': typeof AuthenticatedPayrollPayslipsPayslipIdRoute
  '/payroll/runs/$runId': typeof AuthenticatedPayrollRunsRunIdRoute
  '/payroll/settlements/$runId': typeof AuthenticatedPayrollSettlementsRunIdRoute
  '/product-categories/$categoryId/edit': typeof AuthenticatedProductCategoriesCategoryIdEditRoute
  '/products/$productId/edit': typeof AuthenticatedProductsProductIdEditRoute
  '/purchasing/landed-costs/new': typeof AuthenticatedPurchasingLandedCostsNewRoute
  '/purchasing/orders/new': typeof AuthenticatedPurchasingOrdersNewRoute
  '/purchasing/reports/goods-received-not-invoiced': typeof AuthenticatedPurchasingReportsGoodsReceivedNotInvoicedRoute
  '/purchasing/reports/landed-costs-pending': typeof AuthenticatedPurchasingReportsLandedCostsPendingRoute
  '/purchasing/reports/three-way-match': typeof AuthenticatedPurchasingReportsThreeWayMatchRoute
  '/purchasing/returns/new': typeof AuthenticatedPurchasingReturnsNewRoute
  '/recruitment/candidates/$candidateId': typeof AuthenticatedRecruitmentCandidatesCandidateIdRoute
  '/recruitment/openings/$openingId': typeof AuthenticatedRecruitmentOpeningsOpeningIdRoute
  '/sales/orders/new': typeof AuthenticatedSalesOrdersNewRoute
  '/sales/reports/trend': typeof AuthenticatedSalesReportsTrendRoute
  '/sales/returns/new': typeof AuthenticatedSalesReturnsNewRoute
  '/suppliers/$supplierId/edit': typeof AuthenticatedSuppliersSupplierIdEditRoute
  '/accounting/bank-accounts': typeof AuthenticatedAccountingBankAccountsIndexRoute
  '/accounting/deposits': typeof AuthenticatedAccountingDepositsIndexRoute
  '/accounting/expenses': typeof AuthenticatedAccountingExpensesIndexRoute
  '/accounting/opening-balances': typeof AuthenticatedAccountingOpeningBalancesIndexRoute
  '/accounting/reconcile': typeof AuthenticatedAccountingReconcileIndexRoute
  '/accounting/reports': typeof AuthenticatedAccountingReportsIndexRoute
  '/accounting/sales': typeof AuthenticatedAccountingSalesIndexRoute
  '/accounting/spend': typeof AuthenticatedAccountingSpendIndexRoute
  '/customers/$customerId': typeof AuthenticatedCustomersCustomerIdIndexRoute
  '/group/reports': typeof AuthenticatedGroupReportsIndexRoute
  '/hr/employees': typeof AuthenticatedHrEmployeesIndexRoute
  '/hr/performance': typeof AuthenticatedHrPerformanceIndexRoute
  '/hr/reports': typeof AuthenticatedHrReportsIndexRoute
  '/hr/violations': typeof AuthenticatedHrViolationsIndexRoute
  '/inventory/counts': typeof AuthenticatedInventoryCountsIndexRoute
  '/inventory/lots': typeof AuthenticatedInventoryLotsIndexRoute
  '/inventory/reports': typeof AuthenticatedInventoryReportsIndexRoute
  '/inventory/transfers': typeof AuthenticatedInventoryTransfersIndexRoute
  '/products/$productId': typeof AuthenticatedProductsProductIdIndexRoute
  '/suppliers/$supplierId': typeof AuthenticatedSuppliersSupplierIdIndexRoute
  '/accounting/accounts/$accountId/register': typeof AuthenticatedAccountingAccountsAccountIdRegisterRoute
  '/accounting/bills/$billId/debit-note': typeof AuthenticatedAccountingBillsBillIdDebitNoteRoute
  '/accounting/bills/$billId/edit': typeof AuthenticatedAccountingBillsBillIdEditRoute
  '/accounting/cash-sales/$cashSaleId/edit': typeof AuthenticatedAccountingCashSalesCashSaleIdEditRoute
  '/accounting/invoices/$invoiceId/credit-note': typeof AuthenticatedAccountingInvoicesInvoiceIdCreditNoteRoute
  '/accounting/invoices/$invoiceId/edit': typeof AuthenticatedAccountingInvoicesInvoiceIdEditRoute
  '/accounting/sales-receipts/$cashSaleId/edit': typeof AuthenticatedAccountingSalesReceiptsCashSaleIdEditRoute
  '/hr/employees/$employeeId/edit': typeof AuthenticatedHrEmployeesEmployeeIdEditRoute
  '/hr/employees/$employeeId/onboarding': typeof AuthenticatedHrEmployeesEmployeeIdOnboardingRoute
  '/hr/performance/cycles/$cycleId': typeof AuthenticatedHrPerformanceCyclesCycleIdRoute
  '/hr/performance/reviews/$reviewId': typeof AuthenticatedHrPerformanceReviewsReviewIdRoute
  '/inventory/counts/$sessionId/review': typeof AuthenticatedInventoryCountsSessionIdReviewRoute
  '/inventory/reports/insights/$report': typeof AuthenticatedInventoryReportsInsightsReportRoute
  '/purchasing/orders/$orderId/edit': typeof AuthenticatedPurchasingOrdersOrderIdEditRoute
  '/purchasing/orders/$orderId/receive': typeof AuthenticatedPurchasingOrdersOrderIdReceiveRoute
  '/sales/orders/$orderId/edit': typeof AuthenticatedSalesOrdersOrderIdEditRoute
  '/accounting/bank-accounts/$accountId': typeof AuthenticatedAccountingBankAccountsAccountIdIndexRoute
  '/accounting/bills/$billId': typeof AuthenticatedAccountingBillsBillIdIndexRoute
  '/accounting/cash-sales/$cashSaleId': typeof AuthenticatedAccountingCashSalesCashSaleIdIndexRoute
  '/accounting/cheques/$chequeId': typeof AuthenticatedAccountingChequesChequeIdIndexRoute
  '/accounting/invoices/$invoiceId': typeof AuthenticatedAccountingInvoicesInvoiceIdIndexRoute
  '/accounting/sales-receipts/$cashSaleId': typeof AuthenticatedAccountingSalesReceiptsCashSaleIdIndexRoute
  '/inventory/counts/$sessionId': typeof AuthenticatedInventoryCountsSessionIdIndexRoute
  '/purchasing/landed-costs/$landedCostId': typeof AuthenticatedPurchasingLandedCostsLandedCostIdIndexRoute
  '/purchasing/orders/$orderId': typeof AuthenticatedPurchasingOrdersOrderIdIndexRoute
  '/purchasing/receipts/$receiptId': typeof AuthenticatedPurchasingReceiptsReceiptIdIndexRoute
  '/purchasing/returns/$returnId': typeof AuthenticatedPurchasingReturnsReturnIdIndexRoute
  '/sales/orders/$orderId': typeof AuthenticatedSalesOrdersOrderIdIndexRoute
  '/sales/returns/$returnId': typeof AuthenticatedSalesReturnsReturnIdIndexRoute
  '/accounting/bank-accounts/$accountId/reconcile/$reconciliationId': typeof AuthenticatedAccountingBankAccountsAccountIdReconcileReconciliationIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/accept-invitation': typeof AcceptInvitationRoute
  '/activate': typeof ActivateRoute
  '/face-diagnostics': typeof FaceDiagnosticsRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/get-the-app': typeof GetTheAppRoute
  '/kiosk': typeof KioskRoute
  '/login': typeof LoginRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/reset-code': typeof ResetCodeRoute
  '/reset-password': typeof ResetPasswordRoute
  '/two-factor': typeof TwoFactorRoute
  '/_authenticated/$': typeof AuthenticatedSplatRoute
  '/_authenticated/account': typeof AuthenticatedAccountRouteWithChildren
  '/_authenticated/accounting': typeof AuthenticatedAccountingRouteWithChildren
  '/_authenticated/alerts': typeof AuthenticatedAlertsRoute
  '/_authenticated/approvals': typeof AuthenticatedApprovalsRoute
  '/_authenticated/audit': typeof AuthenticatedAuditRoute
  '/_authenticated/branches': typeof AuthenticatedBranchesRoute
  '/_authenticated/collections': typeof AuthenticatedCollectionsRoute
  '/_authenticated/companies': typeof AuthenticatedCompaniesRoute
  '/_authenticated/departments': typeof AuthenticatedDepartmentsRoute
  '/_authenticated/notifications': typeof AuthenticatedNotificationsRoute
  '/_authenticated/payroll': typeof AuthenticatedPayrollRouteWithChildren
  '/_authenticated/positions': typeof AuthenticatedPositionsRoute
  '/_authenticated/product-attributes': typeof AuthenticatedProductAttributesRoute
  '/_authenticated/roles': typeof AuthenticatedRolesRouteWithChildren
  '/_authenticated/sequences': typeof AuthenticatedSequencesRoute
  '/_authenticated/two-factor-setup': typeof AuthenticatedTwoFactorSetupRoute
  '/_authenticated/users': typeof AuthenticatedUsersRoute
  '/apply/$token': typeof ApplyTokenRoute
  '/support/ended': typeof SupportEndedRoute
  '/support/enter': typeof SupportEnterRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/account/notifications': typeof AuthenticatedAccountNotificationsRoute
  '/_authenticated/account/security': typeof AuthenticatedAccountSecurityRoute
  '/_authenticated/accounting/analysis-tags': typeof AuthenticatedAccountingAnalysisTagsRoute
  '/_authenticated/accounting/assets': typeof AuthenticatedAccountingAssetsRouteWithChildren
  '/_authenticated/accounting/bank-rules': typeof AuthenticatedAccountingBankRulesRoute
  '/_authenticated/accounting/bank-transactions': typeof AuthenticatedAccountingBankTransactionsRoute
  '/_authenticated/accounting/bills': typeof AuthenticatedAccountingBillsRouteWithChildren
  '/_authenticated/accounting/budgets': typeof AuthenticatedAccountingBudgetsRouteWithChildren
  '/_authenticated/accounting/cash-sales': typeof AuthenticatedAccountingCashSalesRouteWithChildren
  '/_authenticated/accounting/chart': typeof AuthenticatedAccountingChartRoute
  '/_authenticated/accounting/cheques': typeof AuthenticatedAccountingChequesRouteWithChildren
  '/_authenticated/accounting/close': typeof AuthenticatedAccountingCloseRoute
  '/_authenticated/accounting/cost-centers': typeof AuthenticatedAccountingCostCentersRoute
  '/_authenticated/accounting/credit-notes': typeof AuthenticatedAccountingCreditNotesRouteWithChildren
  '/_authenticated/accounting/invoices': typeof AuthenticatedAccountingInvoicesRouteWithChildren
  '/_authenticated/accounting/journal': typeof AuthenticatedAccountingJournalRouteWithChildren
  '/_authenticated/accounting/journals': typeof AuthenticatedAccountingJournalsRoute
  '/_authenticated/accounting/payment-terms': typeof AuthenticatedAccountingPaymentTermsRoute
  '/_authenticated/accounting/payments': typeof AuthenticatedAccountingPaymentsRouteWithChildren
  '/_authenticated/accounting/periods': typeof AuthenticatedAccountingPeriodsRoute
  '/_authenticated/accounting/posting-intents': typeof AuthenticatedAccountingPostingIntentsRoute
  '/_authenticated/accounting/prepaid': typeof AuthenticatedAccountingPrepaidRoute
  '/_authenticated/accounting/reconciliation': typeof AuthenticatedAccountingReconciliationRouteWithChildren
  '/_authenticated/accounting/recurring': typeof AuthenticatedAccountingRecurringRoute
  '/_authenticated/accounting/sales-receipts': typeof AuthenticatedAccountingSalesReceiptsRouteWithChildren
  '/_authenticated/accounting/settings': typeof AuthenticatedAccountingSettingsRoute
  '/_authenticated/accounting/statements': typeof AuthenticatedAccountingStatementsRoute
  '/_authenticated/accounting/tax': typeof AuthenticatedAccountingTaxRoute
  '/_authenticated/accounting/trial-balance': typeof AuthenticatedAccountingTrialBalanceRoute
  '/_authenticated/accounting/working-capital': typeof AuthenticatedAccountingWorkingCapitalRoute
  '/_authenticated/accounting_/payroll-payments': typeof AuthenticatedAccountingPayrollPaymentsRoute
  '/_authenticated/customers/new': typeof AuthenticatedCustomersNewRoute
  '/_authenticated/hr/assets': typeof AuthenticatedHrAssetsRouteWithChildren
  '/_authenticated/hr/attendance': typeof AuthenticatedHrAttendanceRoute
  '/_authenticated/hr/attendance-board': typeof AuthenticatedHrAttendanceBoardRoute
  '/_authenticated/hr/attendance-corrections': typeof AuthenticatedHrAttendanceCorrectionsRouteWithChildren
  '/_authenticated/hr/cash-custody': typeof AuthenticatedHrCashCustodyRouteWithChildren
  '/_authenticated/hr/expenses': typeof AuthenticatedHrExpensesRouteWithChildren
  '/_authenticated/hr/field-settings': typeof AuthenticatedHrFieldSettingsRoute
  '/_authenticated/hr/leave': typeof AuthenticatedHrLeaveRouteWithChildren
  '/_authenticated/hr/org': typeof AuthenticatedHrOrgRoute
  '/_authenticated/hr/settings': typeof AuthenticatedHrSettingsRoute
  '/_authenticated/hr/work-entries': typeof AuthenticatedHrWorkEntriesRoute
  '/_authenticated/hr/work-schedules': typeof AuthenticatedHrWorkSchedulesRoute
  '/_authenticated/inventory/access': typeof AuthenticatedInventoryAccessRoute
  '/_authenticated/inventory/adjustments': typeof AuthenticatedInventoryAdjustmentsRoute
  '/_authenticated/inventory/disposals': typeof AuthenticatedInventoryDisposalsRoute
  '/_authenticated/inventory/locations': typeof AuthenticatedInventoryLocationsRoute
  '/_authenticated/inventory/movements': typeof AuthenticatedInventoryMovementsRoute
  '/_authenticated/inventory/serials': typeof AuthenticatedInventorySerialsRouteWithChildren
  '/_authenticated/inventory/stock': typeof AuthenticatedInventoryStockRoute
  '/_authenticated/inventory/warehouses': typeof AuthenticatedInventoryWarehousesRoute
  '/_authenticated/payroll/advances': typeof AuthenticatedPayrollAdvancesRoute
  '/_authenticated/payroll/bulk-assign': typeof AuthenticatedPayrollBulkAssignRoute
  '/_authenticated/payroll/components': typeof AuthenticatedPayrollComponentsRoute
  '/_authenticated/payroll/payslips': typeof AuthenticatedPayrollPayslipsRouteWithChildren
  '/_authenticated/payroll/runs': typeof AuthenticatedPayrollRunsRouteWithChildren
  '/_authenticated/payroll/settings': typeof AuthenticatedPayrollSettingsRoute
  '/_authenticated/product-categories/new': typeof AuthenticatedProductCategoriesNewRoute
  '/_authenticated/products/new': typeof AuthenticatedProductsNewRoute
  '/_authenticated/products/units-of-measure': typeof AuthenticatedProductsUnitsOfMeasureRoute
  '/_authenticated/purchasing/landed-cost-categories': typeof AuthenticatedPurchasingLandedCostCategoriesRoute
  '/_authenticated/purchasing/landed-costs': typeof AuthenticatedPurchasingLandedCostsRouteWithChildren
  '/_authenticated/purchasing/orders': typeof AuthenticatedPurchasingOrdersRouteWithChildren
  '/_authenticated/purchasing/receipts': typeof AuthenticatedPurchasingReceiptsRouteWithChildren
  '/_authenticated/purchasing/returns': typeof AuthenticatedPurchasingReturnsRouteWithChildren
  '/_authenticated/roles/$roleId': typeof AuthenticatedRolesRoleIdRoute
  '/_authenticated/roles/new': typeof AuthenticatedRolesNewRoute
  '/_authenticated/sales/orders': typeof AuthenticatedSalesOrdersRouteWithChildren
  '/_authenticated/sales/reservations': typeof AuthenticatedSalesReservationsRoute
  '/_authenticated/sales/returns': typeof AuthenticatedSalesReturnsRouteWithChildren
  '/_authenticated/settings/alerts': typeof AuthenticatedSettingsAlertsRoute
  '/_authenticated/settings/data-import': typeof AuthenticatedSettingsDataImportRoute
  '/_authenticated/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/_authenticated/settings/workflows': typeof AuthenticatedSettingsWorkflowsRoute
  '/_authenticated/suppliers/new': typeof AuthenticatedSuppliersNewRoute
  '/_authenticated/account/': typeof AuthenticatedAccountIndexRoute
  '/_authenticated/accounting/': typeof AuthenticatedAccountingIndexRoute
  '/_authenticated/customers/': typeof AuthenticatedCustomersIndexRoute
  '/_authenticated/hr/': typeof AuthenticatedHrIndexRoute
  '/_authenticated/inventory/': typeof AuthenticatedInventoryIndexRoute
  '/_authenticated/product-categories/': typeof AuthenticatedProductCategoriesIndexRoute
  '/_authenticated/products/': typeof AuthenticatedProductsIndexRoute
  '/_authenticated/purchasing/': typeof AuthenticatedPurchasingIndexRoute
  '/_authenticated/recruitment/': typeof AuthenticatedRecruitmentIndexRoute
  '/_authenticated/roles/': typeof AuthenticatedRolesIndexRoute
  '/_authenticated/sales/': typeof AuthenticatedSalesIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/suppliers/': typeof AuthenticatedSuppliersIndexRoute
  '/_authenticated/tags/': typeof AuthenticatedTagsIndexRoute
  '/_authenticated/accounting/assets/$assetId': typeof AuthenticatedAccountingAssetsAssetIdRoute
  '/_authenticated/accounting/assets/depreciation': typeof AuthenticatedAccountingAssetsDepreciationRoute
  '/_authenticated/accounting/bills/new': typeof AuthenticatedAccountingBillsNewRoute
  '/_authenticated/accounting/bills/pay': typeof AuthenticatedAccountingBillsPayRoute
  '/_authenticated/accounting/budgets/$budgetId': typeof AuthenticatedAccountingBudgetsBudgetIdRoute
  '/_authenticated/accounting/budgets/new': typeof AuthenticatedAccountingBudgetsNewRoute
  '/_authenticated/accounting/card-credits/new': typeof AuthenticatedAccountingCardCreditsNewRoute
  '/_authenticated/accounting/cash-sales/new': typeof AuthenticatedAccountingCashSalesNewRoute
  '/_authenticated/accounting/cheques/outstanding': typeof AuthenticatedAccountingChequesOutstandingRoute
  '/_authenticated/accounting/credit-notes/new': typeof AuthenticatedAccountingCreditNotesNewRoute
  '/_authenticated/accounting/deposits/$depositId': typeof AuthenticatedAccountingDepositsDepositIdRoute
  '/_authenticated/accounting/deposits/new': typeof AuthenticatedAccountingDepositsNewRoute
  '/_authenticated/accounting/expenses/$documentId': typeof AuthenticatedAccountingExpensesDocumentIdRoute
  '/_authenticated/accounting/expenses/new': typeof AuthenticatedAccountingExpensesNewRoute
  '/_authenticated/accounting/invoices/new': typeof AuthenticatedAccountingInvoicesNewRoute
  '/_authenticated/accounting/journal/$entryId': typeof AuthenticatedAccountingJournalEntryIdRoute
  '/_authenticated/accounting/journal/new': typeof AuthenticatedAccountingJournalNewRoute
  '/_authenticated/accounting/opening-balances/$batchId': typeof AuthenticatedAccountingOpeningBalancesBatchIdRoute
  '/_authenticated/accounting/payments/$paymentId': typeof AuthenticatedAccountingPaymentsPaymentIdRoute
  '/_authenticated/accounting/payments/new': typeof AuthenticatedAccountingPaymentsNewRoute
  '/_authenticated/accounting/reconcile/$reconciliationId': typeof AuthenticatedAccountingReconcileReconciliationIdRoute
  '/_authenticated/accounting/reconciliation/$statementId': typeof AuthenticatedAccountingReconciliationStatementIdRoute
  '/_authenticated/accounting/refunds/new': typeof AuthenticatedAccountingRefundsNewRoute
  '/_authenticated/accounting/reports/$reportToken': typeof AuthenticatedAccountingReportsReportTokenRoute
  '/_authenticated/accounting/reports/aging': typeof AuthenticatedAccountingReportsAgingRoute
  '/_authenticated/accounting/reports/balance-sheet': typeof AuthenticatedAccountingReportsBalanceSheetRoute
  '/_authenticated/accounting/reports/cash-flow': typeof AuthenticatedAccountingReportsCashFlowRoute
  '/_authenticated/accounting/reports/cash-position': typeof AuthenticatedAccountingReportsCashPositionRoute
  '/_authenticated/accounting/reports/cost-by-name': typeof AuthenticatedAccountingReportsCostByNameRoute
  '/_authenticated/accounting/reports/general-ledger': typeof AuthenticatedAccountingReportsGeneralLedgerRoute
  '/_authenticated/accounting/reports/monthly-statements': typeof AuthenticatedAccountingReportsMonthlyStatementsRoute
  '/_authenticated/accounting/reports/profit-and-loss': typeof AuthenticatedAccountingReportsProfitAndLossRoute
  '/_authenticated/accounting/reports/tax': typeof AuthenticatedAccountingReportsTaxRoute
  '/_authenticated/accounting/sales-receipts/new': typeof AuthenticatedAccountingSalesReceiptsNewRoute
  '/_authenticated/accounting/spend/$documentId': typeof AuthenticatedAccountingSpendDocumentIdRoute
  '/_authenticated/accounting/spend/new': typeof AuthenticatedAccountingSpendNewRoute
  '/_authenticated/accounting/supplier-credits/new': typeof AuthenticatedAccountingSupplierCreditsNewRoute
  '/_authenticated/accounting/supplier-statement/$supplierId': typeof AuthenticatedAccountingSupplierStatementSupplierIdRoute
  '/_authenticated/accounting/transfers/new': typeof AuthenticatedAccountingTransfersNewRoute
  '/_authenticated/customers/$customerId/edit': typeof AuthenticatedCustomersCustomerIdEditRoute
  '/_authenticated/group/reports/balance-sheet': typeof AuthenticatedGroupReportsBalanceSheetRoute
  '/_authenticated/group/reports/profit-and-loss': typeof AuthenticatedGroupReportsProfitAndLossRoute
  '/_authenticated/hr/assets/$assetId': typeof AuthenticatedHrAssetsAssetIdRoute
  '/_authenticated/hr/attendance-corrections/$requestId': typeof AuthenticatedHrAttendanceCorrectionsRequestIdRoute
  '/_authenticated/hr/cash-custody/$custodyId': typeof AuthenticatedHrCashCustodyCustodyIdRoute
  '/_authenticated/hr/employees/$employeeId': typeof AuthenticatedHrEmployeesEmployeeIdRouteWithChildren
  '/_authenticated/hr/employees/new': typeof AuthenticatedHrEmployeesNewRoute
  '/_authenticated/hr/expenses/$claimId': typeof AuthenticatedHrExpensesClaimIdRoute
  '/_authenticated/hr/leave/$requestId': typeof AuthenticatedHrLeaveRequestIdRoute
  '/_authenticated/hr/performance/schedules': typeof AuthenticatedHrPerformanceSchedulesRoute
  '/_authenticated/hr/performance/templates': typeof AuthenticatedHrPerformanceTemplatesRoute
  '/_authenticated/hr/reports/absence-coverage': typeof AuthenticatedHrReportsAbsenceCoverageRoute
  '/_authenticated/hr/reports/absence-detail': typeof AuthenticatedHrReportsAbsenceDetailRoute
  '/_authenticated/hr/reports/analytics': typeof AuthenticatedHrReportsAnalyticsRoute
  '/_authenticated/hr/reports/asset-custody': typeof AuthenticatedHrReportsAssetCustodyRoute
  '/_authenticated/hr/reports/asset-exceptions': typeof AuthenticatedHrReportsAssetExceptionsRoute
  '/_authenticated/hr/reports/attendance-exceptions': typeof AuthenticatedHrReportsAttendanceExceptionsRoute
  '/_authenticated/hr/reports/attendance-sheet': typeof AuthenticatedHrReportsAttendanceSheetRoute
  '/_authenticated/hr/reports/attendance-summary': typeof AuthenticatedHrReportsAttendanceSummaryRoute
  '/_authenticated/hr/reports/birthdays': typeof AuthenticatedHrReportsBirthdaysRoute
  '/_authenticated/hr/reports/breaks-sessions': typeof AuthenticatedHrReportsBreaksSessionsRoute
  '/_authenticated/hr/reports/cash-custody-balances': typeof AuthenticatedHrReportsCashCustodyBalancesRoute
  '/_authenticated/hr/reports/demographics': typeof AuthenticatedHrReportsDemographicsRoute
  '/_authenticated/hr/reports/document-expiry': typeof AuthenticatedHrReportsDocumentExpiryRoute
  '/_authenticated/hr/reports/expense-ageing': typeof AuthenticatedHrReportsExpenseAgeingRoute
  '/_authenticated/hr/reports/expense-claims': typeof AuthenticatedHrReportsExpenseClaimsRoute
  '/_authenticated/hr/reports/headcount': typeof AuthenticatedHrReportsHeadcountRoute
  '/_authenticated/hr/reports/holiday-roll': typeof AuthenticatedHrReportsHolidayRollRoute
  '/_authenticated/hr/reports/joiners-leavers': typeof AuthenticatedHrReportsJoinersLeaversRoute
  '/_authenticated/hr/reports/lateness': typeof AuthenticatedHrReportsLatenessRoute
  '/_authenticated/hr/reports/leave-balances': typeof AuthenticatedHrReportsLeaveBalancesRoute
  '/_authenticated/hr/reports/leave-liability': typeof AuthenticatedHrReportsLeaveLiabilityRoute
  '/_authenticated/hr/reports/leave-taken': typeof AuthenticatedHrReportsLeaveTakenRoute
  '/_authenticated/hr/reports/org-hygiene': typeof AuthenticatedHrReportsOrgHygieneRoute
  '/_authenticated/hr/reports/overtime': typeof AuthenticatedHrReportsOvertimeRoute
  '/_authenticated/hr/reports/payroll-deductions': typeof AuthenticatedHrReportsPayrollDeductionsRoute
  '/_authenticated/hr/reports/payroll-register': typeof AuthenticatedHrReportsPayrollRegisterRoute
  '/_authenticated/hr/reports/payroll-summary': typeof AuthenticatedHrReportsPayrollSummaryRoute
  '/_authenticated/hr/reports/payroll-variance': typeof AuthenticatedHrReportsPayrollVarianceRoute
  '/_authenticated/hr/reports/permission-requests': typeof AuthenticatedHrReportsPermissionRequestsRoute
  '/_authenticated/hr/reports/probation-contract': typeof AuthenticatedHrReportsProbationContractRoute
  '/_authenticated/hr/reports/review-completion': typeof AuthenticatedHrReportsReviewCompletionRoute
  '/_authenticated/hr/reports/roster-bank': typeof AuthenticatedHrReportsRosterBankRoute
  '/_authenticated/hr/reports/roster-compensation': typeof AuthenticatedHrReportsRosterCompensationRoute
  '/_authenticated/hr/reports/roster-contact': typeof AuthenticatedHrReportsRosterContactRoute
  '/_authenticated/hr/reports/roster-emergency': typeof AuthenticatedHrReportsRosterEmergencyRoute
  '/_authenticated/hr/reports/roster-employment': typeof AuthenticatedHrReportsRosterEmploymentRoute
  '/_authenticated/hr/reports/roster-team-member': typeof AuthenticatedHrReportsRosterTeamMemberRoute
  '/_authenticated/hr/reports/score-distribution': typeof AuthenticatedHrReportsScoreDistributionRoute
  '/_authenticated/hr/reports/time-off-review': typeof AuthenticatedHrReportsTimeOffReviewRoute
  '/_authenticated/hr/reports/turnover': typeof AuthenticatedHrReportsTurnoverRoute
  '/_authenticated/hr/reports/violations': typeof AuthenticatedHrReportsViolationsRoute
  '/_authenticated/hr/reports/work-hours': typeof AuthenticatedHrReportsWorkHoursRoute
  '/_authenticated/hr/violations/$violationId': typeof AuthenticatedHrViolationsViolationIdRoute
  '/_authenticated/inventory/lots/$lotId': typeof AuthenticatedInventoryLotsLotIdRoute
  '/_authenticated/inventory/reports/aging': typeof AuthenticatedInventoryReportsAgingRoute
  '/_authenticated/inventory/reports/no-sales': typeof AuthenticatedInventoryReportsNoSalesRoute
  '/_authenticated/inventory/reports/performance': typeof AuthenticatedInventoryReportsPerformanceRoute
  '/_authenticated/inventory/reports/replenishment': typeof AuthenticatedInventoryReportsReplenishmentRoute
  '/_authenticated/inventory/reports/stock-valuation': typeof AuthenticatedInventoryReportsStockValuationRoute
  '/_authenticated/inventory/reports/stock-value': typeof AuthenticatedInventoryReportsStockValueRoute
  '/_authenticated/inventory/serials/$unitId': typeof AuthenticatedInventorySerialsUnitIdRoute
  '/_authenticated/inventory/transfers/$transferId': typeof AuthenticatedInventoryTransfersTransferIdRoute
  '/_authenticated/inventory/transfers/new': typeof AuthenticatedInventoryTransfersNewRoute
  '/_authenticated/payroll/payslips/$payslipId': typeof AuthenticatedPayrollPayslipsPayslipIdRoute
  '/_authenticated/payroll/runs/$runId': typeof AuthenticatedPayrollRunsRunIdRoute
  '/_authenticated/payroll/settlements/$runId': typeof AuthenticatedPayrollSettlementsRunIdRoute
  '/_authenticated/product-categories/$categoryId/edit': typeof AuthenticatedProductCategoriesCategoryIdEditRoute
  '/_authenticated/products/$productId/edit': typeof AuthenticatedProductsProductIdEditRoute
  '/_authenticated/purchasing/landed-costs/new': typeof AuthenticatedPurchasingLandedCostsNewRoute
  '/_authenticated/purchasing/orders/new': typeof AuthenticatedPurchasingOrdersNewRoute
  '/_authenticated/purchasing/reports/goods-received-not-invoiced': typeof AuthenticatedPurchasingReportsGoodsReceivedNotInvoicedRoute
  '/_authenticated/purchasing/reports/landed-costs-pending': typeof AuthenticatedPurchasingReportsLandedCostsPendingRoute
  '/_authenticated/purchasing/reports/three-way-match': typeof AuthenticatedPurchasingReportsThreeWayMatchRoute
  '/_authenticated/purchasing/returns/new': typeof AuthenticatedPurchasingReturnsNewRoute
  '/_authenticated/recruitment/candidates/$candidateId': typeof AuthenticatedRecruitmentCandidatesCandidateIdRoute
  '/_authenticated/recruitment/openings/$openingId': typeof AuthenticatedRecruitmentOpeningsOpeningIdRoute
  '/_authenticated/sales/orders/new': typeof AuthenticatedSalesOrdersNewRoute
  '/_authenticated/sales/reports/trend': typeof AuthenticatedSalesReportsTrendRoute
  '/_authenticated/sales/returns/new': typeof AuthenticatedSalesReturnsNewRoute
  '/_authenticated/suppliers/$supplierId/edit': typeof AuthenticatedSuppliersSupplierIdEditRoute
  '/_authenticated/accounting/bank-accounts/': typeof AuthenticatedAccountingBankAccountsIndexRoute
  '/_authenticated/accounting/deposits/': typeof AuthenticatedAccountingDepositsIndexRoute
  '/_authenticated/accounting/expenses/': typeof AuthenticatedAccountingExpensesIndexRoute
  '/_authenticated/accounting/opening-balances/': typeof AuthenticatedAccountingOpeningBalancesIndexRoute
  '/_authenticated/accounting/reconcile/': typeof AuthenticatedAccountingReconcileIndexRoute
  '/_authenticated/accounting/reports/': typeof AuthenticatedAccountingReportsIndexRoute
  '/_authenticated/accounting/sales/': typeof AuthenticatedAccountingSalesIndexRoute
  '/_authenticated/accounting/spend/': typeof AuthenticatedAccountingSpendIndexRoute
  '/_authenticated/customers/$customerId/': typeof AuthenticatedCustomersCustomerIdIndexRoute
  '/_authenticated/group/reports/': typeof AuthenticatedGroupReportsIndexRoute
  '/_authenticated/hr/employees/': typeof AuthenticatedHrEmployeesIndexRoute
  '/_authenticated/hr/performance/': typeof AuthenticatedHrPerformanceIndexRoute
  '/_authenticated/hr/reports/': typeof AuthenticatedHrReportsIndexRoute
  '/_authenticated/hr/violations/': typeof AuthenticatedHrViolationsIndexRoute
  '/_authenticated/inventory/counts/': typeof AuthenticatedInventoryCountsIndexRoute
  '/_authenticated/inventory/lots/': typeof AuthenticatedInventoryLotsIndexRoute
  '/_authenticated/inventory/reports/': typeof AuthenticatedInventoryReportsIndexRoute
  '/_authenticated/inventory/transfers/': typeof AuthenticatedInventoryTransfersIndexRoute
  '/_authenticated/products/$productId/': typeof AuthenticatedProductsProductIdIndexRoute
  '/_authenticated/suppliers/$supplierId/': typeof AuthenticatedSuppliersSupplierIdIndexRoute
  '/_authenticated/accounting/accounts/$accountId/register': typeof AuthenticatedAccountingAccountsAccountIdRegisterRoute
  '/_authenticated/accounting/bills/$billId/debit-note': typeof AuthenticatedAccountingBillsBillIdDebitNoteRoute
  '/_authenticated/accounting/bills/$billId/edit': typeof AuthenticatedAccountingBillsBillIdEditRoute
  '/_authenticated/accounting/cash-sales/$cashSaleId/edit': typeof AuthenticatedAccountingCashSalesCashSaleIdEditRoute
  '/_authenticated/accounting/invoices/$invoiceId/credit-note': typeof AuthenticatedAccountingInvoicesInvoiceIdCreditNoteRoute
  '/_authenticated/accounting/invoices/$invoiceId/edit': typeof AuthenticatedAccountingInvoicesInvoiceIdEditRoute
  '/_authenticated/accounting/sales-receipts/$cashSaleId/edit': typeof AuthenticatedAccountingSalesReceiptsCashSaleIdEditRoute
  '/_authenticated/hr/employees/$employeeId/edit': typeof AuthenticatedHrEmployeesEmployeeIdEditRoute
  '/_authenticated/hr/employees/$employeeId/onboarding': typeof AuthenticatedHrEmployeesEmployeeIdOnboardingRoute
  '/_authenticated/hr/performance/cycles/$cycleId': typeof AuthenticatedHrPerformanceCyclesCycleIdRoute
  '/_authenticated/hr/performance/reviews/$reviewId': typeof AuthenticatedHrPerformanceReviewsReviewIdRoute
  '/_authenticated/inventory/counts/$sessionId/review': typeof AuthenticatedInventoryCountsSessionIdReviewRoute
  '/_authenticated/inventory/reports/insights/$report': typeof AuthenticatedInventoryReportsInsightsReportRoute
  '/_authenticated/purchasing/orders/$orderId/edit': typeof AuthenticatedPurchasingOrdersOrderIdEditRoute
  '/_authenticated/purchasing/orders/$orderId/receive': typeof AuthenticatedPurchasingOrdersOrderIdReceiveRoute
  '/_authenticated/sales/orders/$orderId/edit': typeof AuthenticatedSalesOrdersOrderIdEditRoute
  '/_authenticated/accounting/bank-accounts/$accountId/': typeof AuthenticatedAccountingBankAccountsAccountIdIndexRoute
  '/_authenticated/accounting/bills/$billId/': typeof AuthenticatedAccountingBillsBillIdIndexRoute
  '/_authenticated/accounting/cash-sales/$cashSaleId/': typeof AuthenticatedAccountingCashSalesCashSaleIdIndexRoute
  '/_authenticated/accounting/cheques/$chequeId/': typeof AuthenticatedAccountingChequesChequeIdIndexRoute
  '/_authenticated/accounting/invoices/$invoiceId/': typeof AuthenticatedAccountingInvoicesInvoiceIdIndexRoute
  '/_authenticated/accounting/sales-receipts/$cashSaleId/': typeof AuthenticatedAccountingSalesReceiptsCashSaleIdIndexRoute
  '/_authenticated/inventory/counts/$sessionId/': typeof AuthenticatedInventoryCountsSessionIdIndexRoute
  '/_authenticated/purchasing/landed-costs/$landedCostId/': typeof AuthenticatedPurchasingLandedCostsLandedCostIdIndexRoute
  '/_authenticated/purchasing/orders/$orderId/': typeof AuthenticatedPurchasingOrdersOrderIdIndexRoute
  '/_authenticated/purchasing/receipts/$receiptId/': typeof AuthenticatedPurchasingReceiptsReceiptIdIndexRoute
  '/_authenticated/purchasing/returns/$returnId/': typeof AuthenticatedPurchasingReturnsReturnIdIndexRoute
  '/_authenticated/sales/orders/$orderId/': typeof AuthenticatedSalesOrdersOrderIdIndexRoute
  '/_authenticated/sales/returns/$returnId/': typeof AuthenticatedSalesReturnsReturnIdIndexRoute
  '/_authenticated/accounting/bank-accounts/$accountId/reconcile/$reconciliationId': typeof AuthenticatedAccountingBankAccountsAccountIdReconcileReconciliationIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accept-invitation'
    | '/activate'
    | '/face-diagnostics'
    | '/forgot-password'
    | '/get-the-app'
    | '/kiosk'
    | '/login'
    | '/privacy-policy'
    | '/reset-code'
    | '/reset-password'
    | '/two-factor'
    | '/$'
    | '/account'
    | '/accounting'
    | '/alerts'
    | '/approvals'
    | '/audit'
    | '/branches'
    | '/collections'
    | '/companies'
    | '/departments'
    | '/notifications'
    | '/payroll'
    | '/positions'
    | '/product-attributes'
    | '/roles'
    | '/sequences'
    | '/two-factor-setup'
    | '/users'
    | '/apply/$token'
    | '/support/ended'
    | '/support/enter'
    | '/account/notifications'
    | '/account/security'
    | '/accounting/analysis-tags'
    | '/accounting/assets'
    | '/accounting/bank-rules'
    | '/accounting/bank-transactions'
    | '/accounting/bills'
    | '/accounting/budgets'
    | '/accounting/cash-sales'
    | '/accounting/chart'
    | '/accounting/cheques'
    | '/accounting/close'
    | '/accounting/cost-centers'
    | '/accounting/credit-notes'
    | '/accounting/invoices'
    | '/accounting/journal'
    | '/accounting/journals'
    | '/accounting/payment-terms'
    | '/accounting/payments'
    | '/accounting/periods'
    | '/accounting/posting-intents'
    | '/accounting/prepaid'
    | '/accounting/reconciliation'
    | '/accounting/recurring'
    | '/accounting/sales-receipts'
    | '/accounting/settings'
    | '/accounting/statements'
    | '/accounting/tax'
    | '/accounting/trial-balance'
    | '/accounting/working-capital'
    | '/accounting/payroll-payments'
    | '/customers/new'
    | '/hr/assets'
    | '/hr/attendance'
    | '/hr/attendance-board'
    | '/hr/attendance-corrections'
    | '/hr/cash-custody'
    | '/hr/expenses'
    | '/hr/field-settings'
    | '/hr/leave'
    | '/hr/org'
    | '/hr/settings'
    | '/hr/work-entries'
    | '/hr/work-schedules'
    | '/inventory/access'
    | '/inventory/adjustments'
    | '/inventory/disposals'
    | '/inventory/locations'
    | '/inventory/movements'
    | '/inventory/serials'
    | '/inventory/stock'
    | '/inventory/warehouses'
    | '/payroll/advances'
    | '/payroll/bulk-assign'
    | '/payroll/components'
    | '/payroll/payslips'
    | '/payroll/runs'
    | '/payroll/settings'
    | '/product-categories/new'
    | '/products/new'
    | '/products/units-of-measure'
    | '/purchasing/landed-cost-categories'
    | '/purchasing/landed-costs'
    | '/purchasing/orders'
    | '/purchasing/receipts'
    | '/purchasing/returns'
    | '/roles/$roleId'
    | '/roles/new'
    | '/sales/orders'
    | '/sales/reservations'
    | '/sales/returns'
    | '/settings/alerts'
    | '/settings/data-import'
    | '/settings/notifications'
    | '/settings/workflows'
    | '/suppliers/new'
    | '/account/'
    | '/accounting/'
    | '/customers/'
    | '/hr/'
    | '/inventory/'
    | '/product-categories/'
    | '/products/'
    | '/purchasing/'
    | '/recruitment/'
    | '/roles/'
    | '/sales/'
    | '/settings/'
    | '/suppliers/'
    | '/tags/'
    | '/accounting/assets/$assetId'
    | '/accounting/assets/depreciation'
    | '/accounting/bills/new'
    | '/accounting/bills/pay'
    | '/accounting/budgets/$budgetId'
    | '/accounting/budgets/new'
    | '/accounting/card-credits/new'
    | '/accounting/cash-sales/new'
    | '/accounting/cheques/outstanding'
    | '/accounting/credit-notes/new'
    | '/accounting/deposits/$depositId'
    | '/accounting/deposits/new'
    | '/accounting/expenses/$documentId'
    | '/accounting/expenses/new'
    | '/accounting/invoices/new'
    | '/accounting/journal/$entryId'
    | '/accounting/journal/new'
    | '/accounting/opening-balances/$batchId'
    | '/accounting/payments/$paymentId'
    | '/accounting/payments/new'
    | '/accounting/reconcile/$reconciliationId'
    | '/accounting/reconciliation/$statementId'
    | '/accounting/refunds/new'
    | '/accounting/reports/$reportToken'
    | '/accounting/reports/aging'
    | '/accounting/reports/balance-sheet'
    | '/accounting/reports/cash-flow'
    | '/accounting/reports/cash-position'
    | '/accounting/reports/cost-by-name'
    | '/accounting/reports/general-ledger'
    | '/accounting/reports/monthly-statements'
    | '/accounting/reports/profit-and-loss'
    | '/accounting/reports/tax'
    | '/accounting/sales-receipts/new'
    | '/accounting/spend/$documentId'
    | '/accounting/spend/new'
    | '/accounting/supplier-credits/new'
    | '/accounting/supplier-statement/$supplierId'
    | '/accounting/transfers/new'
    | '/customers/$customerId/edit'
    | '/group/reports/balance-sheet'
    | '/group/reports/profit-and-loss'
    | '/hr/assets/$assetId'
    | '/hr/attendance-corrections/$requestId'
    | '/hr/cash-custody/$custodyId'
    | '/hr/employees/$employeeId'
    | '/hr/employees/new'
    | '/hr/expenses/$claimId'
    | '/hr/leave/$requestId'
    | '/hr/performance/schedules'
    | '/hr/performance/templates'
    | '/hr/reports/absence-coverage'
    | '/hr/reports/absence-detail'
    | '/hr/reports/analytics'
    | '/hr/reports/asset-custody'
    | '/hr/reports/asset-exceptions'
    | '/hr/reports/attendance-exceptions'
    | '/hr/reports/attendance-sheet'
    | '/hr/reports/attendance-summary'
    | '/hr/reports/birthdays'
    | '/hr/reports/breaks-sessions'
    | '/hr/reports/cash-custody-balances'
    | '/hr/reports/demographics'
    | '/hr/reports/document-expiry'
    | '/hr/reports/expense-ageing'
    | '/hr/reports/expense-claims'
    | '/hr/reports/headcount'
    | '/hr/reports/holiday-roll'
    | '/hr/reports/joiners-leavers'
    | '/hr/reports/lateness'
    | '/hr/reports/leave-balances'
    | '/hr/reports/leave-liability'
    | '/hr/reports/leave-taken'
    | '/hr/reports/org-hygiene'
    | '/hr/reports/overtime'
    | '/hr/reports/payroll-deductions'
    | '/hr/reports/payroll-register'
    | '/hr/reports/payroll-summary'
    | '/hr/reports/payroll-variance'
    | '/hr/reports/permission-requests'
    | '/hr/reports/probation-contract'
    | '/hr/reports/review-completion'
    | '/hr/reports/roster-bank'
    | '/hr/reports/roster-compensation'
    | '/hr/reports/roster-contact'
    | '/hr/reports/roster-emergency'
    | '/hr/reports/roster-employment'
    | '/hr/reports/roster-team-member'
    | '/hr/reports/score-distribution'
    | '/hr/reports/time-off-review'
    | '/hr/reports/turnover'
    | '/hr/reports/violations'
    | '/hr/reports/work-hours'
    | '/hr/violations/$violationId'
    | '/inventory/lots/$lotId'
    | '/inventory/reports/aging'
    | '/inventory/reports/no-sales'
    | '/inventory/reports/performance'
    | '/inventory/reports/replenishment'
    | '/inventory/reports/stock-valuation'
    | '/inventory/reports/stock-value'
    | '/inventory/serials/$unitId'
    | '/inventory/transfers/$transferId'
    | '/inventory/transfers/new'
    | '/payroll/payslips/$payslipId'
    | '/payroll/runs/$runId'
    | '/payroll/settlements/$runId'
    | '/product-categories/$categoryId/edit'
    | '/products/$productId/edit'
    | '/purchasing/landed-costs/new'
    | '/purchasing/orders/new'
    | '/purchasing/reports/goods-received-not-invoiced'
    | '/purchasing/reports/landed-costs-pending'
    | '/purchasing/reports/three-way-match'
    | '/purchasing/returns/new'
    | '/recruitment/candidates/$candidateId'
    | '/recruitment/openings/$openingId'
    | '/sales/orders/new'
    | '/sales/reports/trend'
    | '/sales/returns/new'
    | '/suppliers/$supplierId/edit'
    | '/accounting/bank-accounts/'
    | '/accounting/deposits/'
    | '/accounting/expenses/'
    | '/accounting/opening-balances/'
    | '/accounting/reconcile/'
    | '/accounting/reports/'
    | '/accounting/sales/'
    | '/accounting/spend/'
    | '/customers/$customerId/'
    | '/group/reports/'
    | '/hr/employees/'
    | '/hr/performance/'
    | '/hr/reports/'
    | '/hr/violations/'
    | '/inventory/counts/'
    | '/inventory/lots/'
    | '/inventory/reports/'
    | '/inventory/transfers/'
    | '/products/$productId/'
    | '/suppliers/$supplierId/'
    | '/accounting/accounts/$accountId/register'
    | '/accounting/bills/$billId/debit-note'
    | '/accounting/bills/$billId/edit'
    | '/accounting/cash-sales/$cashSaleId/edit'
    | '/accounting/invoices/$invoiceId/credit-note'
    | '/accounting/invoices/$invoiceId/edit'
    | '/accounting/sales-receipts/$cashSaleId/edit'
    | '/hr/employees/$employeeId/edit'
    | '/hr/employees/$employeeId/onboarding'
    | '/hr/performance/cycles/$cycleId'
    | '/hr/performance/reviews/$reviewId'
    | '/inventory/counts/$sessionId/review'
    | '/inventory/reports/insights/$report'
    | '/purchasing/orders/$orderId/edit'
    | '/purchasing/orders/$orderId/receive'
    | '/sales/orders/$orderId/edit'
    | '/accounting/bank-accounts/$accountId/'
    | '/accounting/bills/$billId/'
    | '/accounting/cash-sales/$cashSaleId/'
    | '/accounting/cheques/$chequeId/'
    | '/accounting/invoices/$invoiceId/'
    | '/accounting/sales-receipts/$cashSaleId/'
    | '/inventory/counts/$sessionId/'
    | '/purchasing/landed-costs/$landedCostId/'
    | '/purchasing/orders/$orderId/'
    | '/purchasing/receipts/$receiptId/'
    | '/purchasing/returns/$returnId/'
    | '/sales/orders/$orderId/'
    | '/sales/returns/$returnId/'
    | '/accounting/bank-accounts/$accountId/reconcile/$reconciliationId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/accept-invitation'
    | '/activate'
    | '/face-diagnostics'
    | '/forgot-password'
    | '/get-the-app'
    | '/kiosk'
    | '/login'
    | '/privacy-policy'
    | '/reset-code'
    | '/reset-password'
    | '/two-factor'
    | '/$'
    | '/alerts'
    | '/approvals'
    | '/audit'
    | '/branches'
    | '/collections'
    | '/companies'
    | '/departments'
    | '/notifications'
    | '/payroll'
    | '/positions'
    | '/product-attributes'
    | '/sequences'
    | '/two-factor-setup'
    | '/users'
    | '/apply/$token'
    | '/support/ended'
    | '/support/enter'
    | '/'
    | '/account/notifications'
    | '/account/security'
    | '/accounting/analysis-tags'
    | '/accounting/assets'
    | '/accounting/bank-rules'
    | '/accounting/bank-transactions'
    | '/accounting/bills'
    | '/accounting/budgets'
    | '/accounting/cash-sales'
    | '/accounting/chart'
    | '/accounting/cheques'
    | '/accounting/close'
    | '/accounting/cost-centers'
    | '/accounting/credit-notes'
    | '/accounting/invoices'
    | '/accounting/journal'
    | '/accounting/journals'
    | '/accounting/payment-terms'
    | '/accounting/payments'
    | '/accounting/periods'
    | '/accounting/posting-intents'
    | '/accounting/prepaid'
    | '/accounting/reconciliation'
    | '/accounting/recurring'
    | '/accounting/sales-receipts'
    | '/accounting/settings'
    | '/accounting/statements'
    | '/accounting/tax'
    | '/accounting/trial-balance'
    | '/accounting/working-capital'
    | '/accounting/payroll-payments'
    | '/customers/new'
    | '/hr/assets'
    | '/hr/attendance'
    | '/hr/attendance-board'
    | '/hr/attendance-corrections'
    | '/hr/cash-custody'
    | '/hr/expenses'
    | '/hr/field-settings'
    | '/hr/leave'
    | '/hr/org'
    | '/hr/settings'
    | '/hr/work-entries'
    | '/hr/work-schedules'
    | '/inventory/access'
    | '/inventory/adjustments'
    | '/inventory/disposals'
    | '/inventory/locations'
    | '/inventory/movements'
    | '/inventory/serials'
    | '/inventory/stock'
    | '/inventory/warehouses'
    | '/payroll/advances'
    | '/payroll/bulk-assign'
    | '/payroll/components'
    | '/payroll/payslips'
    | '/payroll/runs'
    | '/payroll/settings'
    | '/product-categories/new'
    | '/products/new'
    | '/products/units-of-measure'
    | '/purchasing/landed-cost-categories'
    | '/purchasing/landed-costs'
    | '/purchasing/orders'
    | '/purchasing/receipts'
    | '/purchasing/returns'
    | '/roles/$roleId'
    | '/roles/new'
    | '/sales/orders'
    | '/sales/reservations'
    | '/sales/returns'
    | '/settings/alerts'
    | '/settings/data-import'
    | '/settings/notifications'
    | '/settings/workflows'
    | '/suppliers/new'
    | '/account'
    | '/accounting'
    | '/customers'
    | '/hr'
    | '/inventory'
    | '/product-categories'
    | '/products'
    | '/purchasing'
    | '/recruitment'
    | '/roles'
    | '/sales'
    | '/settings'
    | '/suppliers'
    | '/tags'
    | '/accounting/assets/$assetId'
    | '/accounting/assets/depreciation'
    | '/accounting/bills/new'
    | '/accounting/bills/pay'
    | '/accounting/budgets/$budgetId'
    | '/accounting/budgets/new'
    | '/accounting/card-credits/new'
    | '/accounting/cash-sales/new'
    | '/accounting/cheques/outstanding'
    | '/accounting/credit-notes/new'
    | '/accounting/deposits/$depositId'
    | '/accounting/deposits/new'
    | '/accounting/expenses/$documentId'
    | '/accounting/expenses/new'
    | '/accounting/invoices/new'
    | '/accounting/journal/$entryId'
    | '/accounting/journal/new'
    | '/accounting/opening-balances/$batchId'
    | '/accounting/payments/$paymentId'
    | '/accounting/payments/new'
    | '/accounting/reconcile/$reconciliationId'
    | '/accounting/reconciliation/$statementId'
    | '/accounting/refunds/new'
    | '/accounting/reports/$reportToken'
    | '/accounting/reports/aging'
    | '/accounting/reports/balance-sheet'
    | '/accounting/reports/cash-flow'
    | '/accounting/reports/cash-position'
    | '/accounting/reports/cost-by-name'
    | '/accounting/reports/general-ledger'
    | '/accounting/reports/monthly-statements'
    | '/accounting/reports/profit-and-loss'
    | '/accounting/reports/tax'
    | '/accounting/sales-receipts/new'
    | '/accounting/spend/$documentId'
    | '/accounting/spend/new'
    | '/accounting/supplier-credits/new'
    | '/accounting/supplier-statement/$supplierId'
    | '/accounting/transfers/new'
    | '/customers/$customerId/edit'
    | '/group/reports/balance-sheet'
    | '/group/reports/profit-and-loss'
    | '/hr/assets/$assetId'
    | '/hr/attendance-corrections/$requestId'
    | '/hr/cash-custody/$custodyId'
    | '/hr/employees/$employeeId'
    | '/hr/employees/new'
    | '/hr/expenses/$claimId'
    | '/hr/leave/$requestId'
    | '/hr/performance/schedules'
    | '/hr/performance/templates'
    | '/hr/reports/absence-coverage'
    | '/hr/reports/absence-detail'
    | '/hr/reports/analytics'
    | '/hr/reports/asset-custody'
    | '/hr/reports/asset-exceptions'
    | '/hr/reports/attendance-exceptions'
    | '/hr/reports/attendance-sheet'
    | '/hr/reports/attendance-summary'
    | '/hr/reports/birthdays'
    | '/hr/reports/breaks-sessions'
    | '/hr/reports/cash-custody-balances'
    | '/hr/reports/demographics'
    | '/hr/reports/document-expiry'
    | '/hr/reports/expense-ageing'
    | '/hr/reports/expense-claims'
    | '/hr/reports/headcount'
    | '/hr/reports/holiday-roll'
    | '/hr/reports/joiners-leavers'
    | '/hr/reports/lateness'
    | '/hr/reports/leave-balances'
    | '/hr/reports/leave-liability'
    | '/hr/reports/leave-taken'
    | '/hr/reports/org-hygiene'
    | '/hr/reports/overtime'
    | '/hr/reports/payroll-deductions'
    | '/hr/reports/payroll-register'
    | '/hr/reports/payroll-summary'
    | '/hr/reports/payroll-variance'
    | '/hr/reports/permission-requests'
    | '/hr/reports/probation-contract'
    | '/hr/reports/review-completion'
    | '/hr/reports/roster-bank'
    | '/hr/reports/roster-compensation'
    | '/hr/reports/roster-contact'
    | '/hr/reports/roster-emergency'
    | '/hr/reports/roster-employment'
    | '/hr/reports/roster-team-member'
    | '/hr/reports/score-distribution'
    | '/hr/reports/time-off-review'
    | '/hr/reports/turnover'
    | '/hr/reports/violations'
    | '/hr/reports/work-hours'
    | '/hr/violations/$violationId'
    | '/inventory/lots/$lotId'
    | '/inventory/reports/aging'
    | '/inventory/reports/no-sales'
    | '/inventory/reports/performance'
    | '/inventory/reports/replenishment'
    | '/inventory/reports/stock-valuation'
    | '/inventory/reports/stock-value'
    | '/inventory/serials/$unitId'
    | '/inventory/transfers/$transferId'
    | '/inventory/transfers/new'
    | '/payroll/payslips/$payslipId'
    | '/payroll/runs/$runId'
    | '/payroll/settlements/$runId'
    | '/product-categories/$categoryId/edit'
    | '/products/$productId/edit'
    | '/purchasing/landed-costs/new'
    | '/purchasing/orders/new'
    | '/purchasing/reports/goods-received-not-invoiced'
    | '/purchasing/reports/landed-costs-pending'
    | '/purchasing/reports/three-way-match'
    | '/purchasing/returns/new'
    | '/recruitment/candidates/$candidateId'
    | '/recruitment/openings/$openingId'
    | '/sales/orders/new'
    | '/sales/reports/trend'
    | '/sales/returns/new'
    | '/suppliers/$supplierId/edit'
    | '/accounting/bank-accounts'
    | '/accounting/deposits'
    | '/accounting/expenses'
    | '/accounting/opening-balances'
    | '/accounting/reconcile'
    | '/accounting/reports'
    | '/accounting/sales'
    | '/accounting/spend'
    | '/customers/$customerId'
    | '/group/reports'
    | '/hr/employees'
    | '/hr/performance'
    | '/hr/reports'
    | '/hr/violations'
    | '/inventory/counts'
    | '/inventory/lots'
    | '/inventory/reports'
    | '/inventory/transfers'
    | '/products/$productId'
    | '/suppliers/$supplierId'
    | '/accounting/accounts/$accountId/register'
    | '/accounting/bills/$billId/debit-note'
    | '/accounting/bills/$billId/edit'
    | '/accounting/cash-sales/$cashSaleId/edit'
    | '/accounting/invoices/$invoiceId/credit-note'
    | '/accounting/invoices/$invoiceId/edit'
    | '/accounting/sales-receipts/$cashSaleId/edit'
    | '/hr/employees/$employeeId/edit'
    | '/hr/employees/$employeeId/onboarding'
    | '/hr/performance/cycles/$cycleId'
    | '/hr/performance/reviews/$reviewId'
    | '/inventory/counts/$sessionId/review'
    | '/inventory/reports/insights/$report'
    | '/purchasing/orders/$orderId/edit'
    | '/purchasing/orders/$orderId/receive'
    | '/sales/orders/$orderId/edit'
    | '/accounting/bank-accounts/$accountId'
    | '/accounting/bills/$billId'
    | '/accounting/cash-sales/$cashSaleId'
    | '/accounting/cheques/$chequeId'
    | '/accounting/invoices/$invoiceId'
    | '/accounting/sales-receipts/$cashSaleId'
    | '/inventory/counts/$sessionId'
    | '/purchasing/landed-costs/$landedCostId'
    | '/purchasing/orders/$orderId'
    | '/purchasing/receipts/$receiptId'
    | '/purchasing/returns/$returnId'
    | '/sales/orders/$orderId'
    | '/sales/returns/$returnId'
    | '/accounting/bank-accounts/$accountId/reconcile/$reconciliationId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/accept-invitation'
    | '/activate'
    | '/face-diagnostics'
    | '/forgot-password'
    | '/get-the-app'
    | '/kiosk'
    | '/login'
    | '/privacy-policy'
    | '/reset-code'
    | '/reset-password'
    | '/two-factor'
    | '/_authenticated/$'
    | '/_authenticated/account'
    | '/_authenticated/accounting'
    | '/_authenticated/alerts'
    | '/_authenticated/approvals'
    | '/_authenticated/audit'
    | '/_authenticated/branches'
    | '/_authenticated/collections'
    | '/_authenticated/companies'
    | '/_authenticated/departments'
    | '/_authenticated/notifications'
    | '/_authenticated/payroll'
    | '/_authenticated/positions'
    | '/_authenticated/product-attributes'
    | '/_authenticated/roles'
    | '/_authenticated/sequences'
    | '/_authenticated/two-factor-setup'
    | '/_authenticated/users'
    | '/apply/$token'
    | '/support/ended'
    | '/support/enter'
    | '/_authenticated/'
    | '/_authenticated/account/notifications'
    | '/_authenticated/account/security'
    | '/_authenticated/accounting/analysis-tags'
    | '/_authenticated/accounting/assets'
    | '/_authenticated/accounting/bank-rules'
    | '/_authenticated/accounting/bank-transactions'
    | '/_authenticated/accounting/bills'
    | '/_authenticated/accounting/budgets'
    | '/_authenticated/accounting/cash-sales'
    | '/_authenticated/accounting/chart'
    | '/_authenticated/accounting/cheques'
    | '/_authenticated/accounting/close'
    | '/_authenticated/accounting/cost-centers'
    | '/_authenticated/accounting/credit-notes'
    | '/_authenticated/accounting/invoices'
    | '/_authenticated/accounting/journal'
    | '/_authenticated/accounting/journals'
    | '/_authenticated/accounting/payment-terms'
    | '/_authenticated/accounting/payments'
    | '/_authenticated/accounting/periods'
    | '/_authenticated/accounting/posting-intents'
    | '/_authenticated/accounting/prepaid'
    | '/_authenticated/accounting/reconciliation'
    | '/_authenticated/accounting/recurring'
    | '/_authenticated/accounting/sales-receipts'
    | '/_authenticated/accounting/settings'
    | '/_authenticated/accounting/statements'
    | '/_authenticated/accounting/tax'
    | '/_authenticated/accounting/trial-balance'
    | '/_authenticated/accounting/working-capital'
    | '/_authenticated/accounting_/payroll-payments'
    | '/_authenticated/customers/new'
    | '/_authenticated/hr/assets'
    | '/_authenticated/hr/attendance'
    | '/_authenticated/hr/attendance-board'
    | '/_authenticated/hr/attendance-corrections'
    | '/_authenticated/hr/cash-custody'
    | '/_authenticated/hr/expenses'
    | '/_authenticated/hr/field-settings'
    | '/_authenticated/hr/leave'
    | '/_authenticated/hr/org'
    | '/_authenticated/hr/settings'
    | '/_authenticated/hr/work-entries'
    | '/_authenticated/hr/work-schedules'
    | '/_authenticated/inventory/access'
    | '/_authenticated/inventory/adjustments'
    | '/_authenticated/inventory/disposals'
    | '/_authenticated/inventory/locations'
    | '/_authenticated/inventory/movements'
    | '/_authenticated/inventory/serials'
    | '/_authenticated/inventory/stock'
    | '/_authenticated/inventory/warehouses'
    | '/_authenticated/payroll/advances'
    | '/_authenticated/payroll/bulk-assign'
    | '/_authenticated/payroll/components'
    | '/_authenticated/payroll/payslips'
    | '/_authenticated/payroll/runs'
    | '/_authenticated/payroll/settings'
    | '/_authenticated/product-categories/new'
    | '/_authenticated/products/new'
    | '/_authenticated/products/units-of-measure'
    | '/_authenticated/purchasing/landed-cost-categories'
    | '/_authenticated/purchasing/landed-costs'
    | '/_authenticated/purchasing/orders'
    | '/_authenticated/purchasing/receipts'
    | '/_authenticated/purchasing/returns'
    | '/_authenticated/roles/$roleId'
    | '/_authenticated/roles/new'
    | '/_authenticated/sales/orders'
    | '/_authenticated/sales/reservations'
    | '/_authenticated/sales/returns'
    | '/_authenticated/settings/alerts'
    | '/_authenticated/settings/data-import'
    | '/_authenticated/settings/notifications'
    | '/_authenticated/settings/workflows'
    | '/_authenticated/suppliers/new'
    | '/_authenticated/account/'
    | '/_authenticated/accounting/'
    | '/_authenticated/customers/'
    | '/_authenticated/hr/'
    | '/_authenticated/inventory/'
    | '/_authenticated/product-categories/'
    | '/_authenticated/products/'
    | '/_authenticated/purchasing/'
    | '/_authenticated/recruitment/'
    | '/_authenticated/roles/'
    | '/_authenticated/sales/'
    | '/_authenticated/settings/'
    | '/_authenticated/suppliers/'
    | '/_authenticated/tags/'
    | '/_authenticated/accounting/assets/$assetId'
    | '/_authenticated/accounting/assets/depreciation'
    | '/_authenticated/accounting/bills/new'
    | '/_authenticated/accounting/bills/pay'
    | '/_authenticated/accounting/budgets/$budgetId'
    | '/_authenticated/accounting/budgets/new'
    | '/_authenticated/accounting/card-credits/new'
    | '/_authenticated/accounting/cash-sales/new'
    | '/_authenticated/accounting/cheques/outstanding'
    | '/_authenticated/accounting/credit-notes/new'
    | '/_authenticated/accounting/deposits/$depositId'
    | '/_authenticated/accounting/deposits/new'
    | '/_authenticated/accounting/expenses/$documentId'
    | '/_authenticated/accounting/expenses/new'
    | '/_authenticated/accounting/invoices/new'
    | '/_authenticated/accounting/journal/$entryId'
    | '/_authenticated/accounting/journal/new'
    | '/_authenticated/accounting/opening-balances/$batchId'
    | '/_authenticated/accounting/payments/$paymentId'
    | '/_authenticated/accounting/payments/new'
    | '/_authenticated/accounting/reconcile/$reconciliationId'
    | '/_authenticated/accounting/reconciliation/$statementId'
    | '/_authenticated/accounting/refunds/new'
    | '/_authenticated/accounting/reports/$reportToken'
    | '/_authenticated/accounting/reports/aging'
    | '/_authenticated/accounting/reports/balance-sheet'
    | '/_authenticated/accounting/reports/cash-flow'
    | '/_authenticated/accounting/reports/cash-position'
    | '/_authenticated/accounting/reports/cost-by-name'
    | '/_authenticated/accounting/reports/general-ledger'
    | '/_authenticated/accounting/reports/monthly-statements'
    | '/_authenticated/accounting/reports/profit-and-loss'
    | '/_authenticated/accounting/reports/tax'
    | '/_authenticated/accounting/sales-receipts/new'
    | '/_authenticated/accounting/spend/$documentId'
    | '/_authenticated/accounting/spend/new'
    | '/_authenticated/accounting/supplier-credits/new'
    | '/_authenticated/accounting/supplier-statement/$supplierId'
    | '/_authenticated/accounting/transfers/new'
    | '/_authenticated/customers/$customerId/edit'
    | '/_authenticated/group/reports/balance-sheet'
    | '/_authenticated/group/reports/profit-and-loss'
    | '/_authenticated/hr/assets/$assetId'
    | '/_authenticated/hr/attendance-corrections/$requestId'
    | '/_authenticated/hr/cash-custody/$custodyId'
    | '/_authenticated/hr/employees/$employeeId'
    | '/_authenticated/hr/employees/new'
    | '/_authenticated/hr/expenses/$claimId'
    | '/_authenticated/hr/leave/$requestId'
    | '/_authenticated/hr/performance/schedules'
    | '/_authenticated/hr/performance/templates'
    | '/_authenticated/hr/reports/absence-coverage'
    | '/_authenticated/hr/reports/absence-detail'
    | '/_authenticated/hr/reports/analytics'
    | '/_authenticated/hr/reports/asset-custody'
    | '/_authenticated/hr/reports/asset-exceptions'
    | '/_authenticated/hr/reports/attendance-exceptions'
    | '/_authenticated/hr/reports/attendance-sheet'
    | '/_authenticated/hr/reports/attendance-summary'
    | '/_authenticated/hr/reports/birthdays'
    | '/_authenticated/hr/reports/breaks-sessions'
    | '/_authenticated/hr/reports/cash-custody-balances'
    | '/_authenticated/hr/reports/demographics'
    | '/_authenticated/hr/reports/document-expiry'
    | '/_authenticated/hr/reports/expense-ageing'
    | '/_authenticated/hr/reports/expense-claims'
    | '/_authenticated/hr/reports/headcount'
    | '/_authenticated/hr/reports/holiday-roll'
    | '/_authenticated/hr/reports/joiners-leavers'
    | '/_authenticated/hr/reports/lateness'
    | '/_authenticated/hr/reports/leave-balances'
    | '/_authenticated/hr/reports/leave-liability'
    | '/_authenticated/hr/reports/leave-taken'
    | '/_authenticated/hr/reports/org-hygiene'
    | '/_authenticated/hr/reports/overtime'
    | '/_authenticated/hr/reports/payroll-deductions'
    | '/_authenticated/hr/reports/payroll-register'
    | '/_authenticated/hr/reports/payroll-summary'
    | '/_authenticated/hr/reports/payroll-variance'
    | '/_authenticated/hr/reports/permission-requests'
    | '/_authenticated/hr/reports/probation-contract'
    | '/_authenticated/hr/reports/review-completion'
    | '/_authenticated/hr/reports/roster-bank'
    | '/_authenticated/hr/reports/roster-compensation'
    | '/_authenticated/hr/reports/roster-contact'
    | '/_authenticated/hr/reports/roster-emergency'
    | '/_authenticated/hr/reports/roster-employment'
    | '/_authenticated/hr/reports/roster-team-member'
    | '/_authenticated/hr/reports/score-distribution'
    | '/_authenticated/hr/reports/time-off-review'
    | '/_authenticated/hr/reports/turnover'
    | '/_authenticated/hr/reports/violations'
    | '/_authenticated/hr/reports/work-hours'
    | '/_authenticated/hr/violations/$violationId'
    | '/_authenticated/inventory/lots/$lotId'
    | '/_authenticated/inventory/reports/aging'
    | '/_authenticated/inventory/reports/no-sales'
    | '/_authenticated/inventory/reports/performance'
    | '/_authenticated/inventory/reports/replenishment'
    | '/_authenticated/inventory/reports/stock-valuation'
    | '/_authenticated/inventory/reports/stock-value'
    | '/_authenticated/inventory/serials/$unitId'
    | '/_authenticated/inventory/transfers/$transferId'
    | '/_authenticated/inventory/transfers/new'
    | '/_authenticated/payroll/payslips/$payslipId'
    | '/_authenticated/payroll/runs/$runId'
    | '/_authenticated/payroll/settlements/$runId'
    | '/_authenticated/product-categories/$categoryId/edit'
    | '/_authenticated/products/$productId/edit'
    | '/_authenticated/purchasing/landed-costs/new'
    | '/_authenticated/purchasing/orders/new'
    | '/_authenticated/purchasing/reports/goods-received-not-invoiced'
    | '/_authenticated/purchasing/reports/landed-costs-pending'
    | '/_authenticated/purchasing/reports/three-way-match'
    | '/_authenticated/purchasing/returns/new'
    | '/_authenticated/recruitment/candidates/$candidateId'
    | '/_authenticated/recruitment/openings/$openingId'
    | '/_authenticated/sales/orders/new'
    | '/_authenticated/sales/reports/trend'
    | '/_authenticated/sales/returns/new'
    | '/_authenticated/suppliers/$supplierId/edit'
    | '/_authenticated/accounting/bank-accounts/'
    | '/_authenticated/accounting/deposits/'
    | '/_authenticated/accounting/expenses/'
    | '/_authenticated/accounting/opening-balances/'
    | '/_authenticated/accounting/reconcile/'
    | '/_authenticated/accounting/reports/'
    | '/_authenticated/accounting/sales/'
    | '/_authenticated/accounting/spend/'
    | '/_authenticated/customers/$customerId/'
    | '/_authenticated/group/reports/'
    | '/_authenticated/hr/employees/'
    | '/_authenticated/hr/performance/'
    | '/_authenticated/hr/reports/'
    | '/_authenticated/hr/violations/'
    | '/_authenticated/inventory/counts/'
    | '/_authenticated/inventory/lots/'
    | '/_authenticated/inventory/reports/'
    | '/_authenticated/inventory/transfers/'
    | '/_authenticated/products/$productId/'
    | '/_authenticated/suppliers/$supplierId/'
    | '/_authenticated/accounting/accounts/$accountId/register'
    | '/_authenticated/accounting/bills/$billId/debit-note'
    | '/_authenticated/accounting/bills/$billId/edit'
    | '/_authenticated/accounting/cash-sales/$cashSaleId/edit'
    | '/_authenticated/accounting/invoices/$invoiceId/credit-note'
    | '/_authenticated/accounting/invoices/$invoiceId/edit'
    | '/_authenticated/accounting/sales-receipts/$cashSaleId/edit'
    | '/_authenticated/hr/employees/$employeeId/edit'
    | '/_authenticated/hr/employees/$employeeId/onboarding'
    | '/_authenticated/hr/performance/cycles/$cycleId'
    | '/_authenticated/hr/performance/reviews/$reviewId'
    | '/_authenticated/inventory/counts/$sessionId/review'
    | '/_authenticated/inventory/reports/insights/$report'
    | '/_authenticated/purchasing/orders/$orderId/edit'
    | '/_authenticated/purchasing/orders/$orderId/receive'
    | '/_authenticated/sales/orders/$orderId/edit'
    | '/_authenticated/accounting/bank-accounts/$accountId/'
    | '/_authenticated/accounting/bills/$billId/'
    | '/_authenticated/accounting/cash-sales/$cashSaleId/'
    | '/_authenticated/accounting/cheques/$chequeId/'
    | '/_authenticated/accounting/invoices/$invoiceId/'
    | '/_authenticated/accounting/sales-receipts/$cashSaleId/'
    | '/_authenticated/inventory/counts/$sessionId/'
    | '/_authenticated/purchasing/landed-costs/$landedCostId/'
    | '/_authenticated/purchasing/orders/$orderId/'
    | '/_authenticated/purchasing/receipts/$receiptId/'
    | '/_authenticated/purchasing/returns/$returnId/'
    | '/_authenticated/sales/orders/$orderId/'
    | '/_authenticated/sales/returns/$returnId/'
    | '/_authenticated/accounting/bank-accounts/$accountId/reconcile/$reconciliationId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  AcceptInvitationRoute: typeof AcceptInvitationRoute
  ActivateRoute: typeof ActivateRoute
  FaceDiagnosticsRoute: typeof FaceDiagnosticsRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  GetTheAppRoute: typeof GetTheAppRoute
  KioskRoute: typeof KioskRoute
  LoginRoute: typeof LoginRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  ResetCodeRoute: typeof ResetCodeRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  TwoFactorRoute: typeof TwoFactorRoute
  ApplyTokenRoute: typeof ApplyTokenRoute
  SupportEndedRoute: typeof SupportEndedRoute
  SupportEnterRoute: typeof SupportEnterRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invitation': {
      id: '/accept-invitation'
      path: '/accept-invitation'
      fullPath: '/accept-invitation'
      preLoaderRoute: typeof AcceptInvitationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activate': {
      id: '/activate'
      path: '/activate'
      fullPath: '/activate'
      preLoaderRoute: typeof ActivateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/face-diagnostics': {
      id: '/face-diagnostics'
      path: '/face-diagnostics'
      fullPath: '/face-diagnostics'
      preLoaderRoute: typeof FaceDiagnosticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/get-the-app': {
      id: '/get-the-app'
      path: '/get-the-app'
      fullPath: '/get-the-app'
      preLoaderRoute: typeof GetTheAppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kiosk': {
      id: '/kiosk'
      path: '/kiosk'
      fullPath: '/kiosk'
      preLoaderRoute: typeof KioskRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-code': {
      id: '/reset-code'
      path: '/reset-code'
      fullPath: '/reset-code'
      preLoaderRoute: typeof ResetCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/two-factor': {
      id: '/two-factor'
      path: '/two-factor'
      fullPath: '/two-factor'
      preLoaderRoute: typeof TwoFactorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/$': {
      id: '/_authenticated/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof AuthenticatedSplatRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account': {
      id: '/_authenticated/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthenticatedAccountRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/accounting': {
      id: '/_authenticated/accounting'
      path: '/accounting'
      fullPath: '/accounting'
      preLoaderRoute: typeof AuthenticatedAccountingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/alerts': {
      id: '/_authenticated/alerts'
      path: '/alerts'
      fullPath: '/alerts'
      preLoaderRoute: typeof AuthenticatedAlertsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/approvals': {
      id: '/_authenticated/approvals'
      path: '/approvals'
      fullPath: '/approvals'
      preLoaderRoute: typeof AuthenticatedApprovalsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/audit': {
      id: '/_authenticated/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuthenticatedAuditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/branches': {
      id: '/_authenticated/branches'
      path: '/branches'
      fullPath: '/branches'
      preLoaderRoute: typeof AuthenticatedBranchesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/collections': {
      id: '/_authenticated/collections'
      path: '/collections'
      fullPath: '/collections'
      preLoaderRoute: typeof AuthenticatedCollectionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/companies': {
      id: '/_authenticated/companies'
      path: '/companies'
      fullPath: '/companies'
      preLoaderRoute: typeof AuthenticatedCompaniesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/departments': {
      id: '/_authenticated/departments'
      path: '/departments'
      fullPath: '/departments'
      preLoaderRoute: typeof AuthenticatedDepartmentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/notifications': {
      id: '/_authenticated/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthenticatedNotificationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/payroll': {
      id: '/_authenticated/payroll'
      path: '/payroll'
      fullPath: '/payroll'
      preLoaderRoute: typeof AuthenticatedPayrollRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/positions': {
      id: '/_authenticated/positions'
      path: '/positions'
      fullPath: '/positions'
      preLoaderRoute: typeof AuthenticatedPositionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/product-attributes': {
      id: '/_authenticated/product-attributes'
      path: '/product-attributes'
      fullPath: '/product-attributes'
      preLoaderRoute: typeof AuthenticatedProductAttributesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/roles': {
      id: '/_authenticated/roles'
      path: '/roles'
      fullPath: '/roles'
      preLoaderRoute: typeof AuthenticatedRolesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sequences': {
      id: '/_authenticated/sequences'
      path: '/sequences'
      fullPath: '/sequences'
      preLoaderRoute: typeof AuthenticatedSequencesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/two-factor-setup': {
      id: '/_authenticated/two-factor-setup'
      path: '/two-factor-setup'
      fullPath: '/two-factor-setup'
      preLoaderRoute: typeof AuthenticatedTwoFactorSetupRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users': {
      id: '/_authenticated/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthenticatedUsersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/apply/$token': {
      id: '/apply/$token'
      path: '/apply/$token'
      fullPath: '/apply/$token'
      preLoaderRoute: typeof ApplyTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support/ended': {
      id: '/support/ended'
      path: '/support/ended'
      fullPath: '/support/ended'
      preLoaderRoute: typeof SupportEndedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support/enter': {
      id: '/support/enter'
      path: '/support/enter'
      fullPath: '/support/enter'
      preLoaderRoute: typeof SupportEnterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/account/': {
      id: '/_authenticated/account/'
      path: '/'
      fullPath: '/account/'
      preLoaderRoute: typeof AuthenticatedAccountIndexRouteImport
      parentRoute: typeof AuthenticatedAccountRoute
    }
    '/_authenticated/account/notifications': {
      id: '/_authenticated/account/notifications'
      path: '/notifications'
      fullPath: '/account/notifications'
      preLoaderRoute: typeof AuthenticatedAccountNotificationsRouteImport
      parentRoute: typeof AuthenticatedAccountRoute
    }
    '/_authenticated/account/security': {
      id: '/_authenticated/account/security'
      path: '/security'
      fullPath: '/account/security'
      preLoaderRoute: typeof AuthenticatedAccountSecurityRouteImport
      parentRoute: typeof AuthenticatedAccountRoute
    }
    '/_authenticated/accounting/': {
      id: '/_authenticated/accounting/'
      path: '/'
      fullPath: '/accounting/'
      preLoaderRoute: typeof AuthenticatedAccountingIndexRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/analysis-tags': {
      id: '/_authenticated/accounting/analysis-tags'
      path: '/analysis-tags'
      fullPath: '/accounting/analysis-tags'
      preLoaderRoute: typeof AuthenticatedAccountingAnalysisTagsRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/assets': {
      id: '/_authenticated/accounting/assets'
      path: '/assets'
      fullPath: '/accounting/assets'
      preLoaderRoute: typeof AuthenticatedAccountingAssetsRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/bank-rules': {
      id: '/_authenticated/accounting/bank-rules'
      path: '/bank-rules'
      fullPath: '/accounting/bank-rules'
      preLoaderRoute: typeof AuthenticatedAccountingBankRulesRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/bank-transactions': {
      id: '/_authenticated/accounting/bank-transactions'
      path: '/bank-transactions'
      fullPath: '/accounting/bank-transactions'
      preLoaderRoute: typeof AuthenticatedAccountingBankTransactionsRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/bills': {
      id: '/_authenticated/accounting/bills'
      path: '/bills'
      fullPath: '/accounting/bills'
      preLoaderRoute: typeof AuthenticatedAccountingBillsRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/budgets': {
      id: '/_authenticated/accounting/budgets'
      path: '/budgets'
      fullPath: '/accounting/budgets'
      preLoaderRoute: typeof AuthenticatedAccountingBudgetsRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/cash-sales': {
      id: '/_authenticated/accounting/cash-sales'
      path: '/cash-sales'
      fullPath: '/accounting/cash-sales'
      preLoaderRoute: typeof AuthenticatedAccountingCashSalesRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/chart': {
      id: '/_authenticated/accounting/chart'
      path: '/chart'
      fullPath: '/accounting/chart'
      preLoaderRoute: typeof AuthenticatedAccountingChartRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/cheques': {
      id: '/_authenticated/accounting/cheques'
      path: '/cheques'
      fullPath: '/accounting/cheques'
      preLoaderRoute: typeof AuthenticatedAccountingChequesRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/close': {
      id: '/_authenticated/accounting/close'
      path: '/close'
      fullPath: '/accounting/close'
      preLoaderRoute: typeof AuthenticatedAccountingCloseRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/cost-centers': {
      id: '/_authenticated/accounting/cost-centers'
      path: '/cost-centers'
      fullPath: '/accounting/cost-centers'
      preLoaderRoute: typeof AuthenticatedAccountingCostCentersRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/credit-notes': {
      id: '/_authenticated/accounting/credit-notes'
      path: '/credit-notes'
      fullPath: '/accounting/credit-notes'
      preLoaderRoute: typeof AuthenticatedAccountingCreditNotesRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/invoices': {
      id: '/_authenticated/accounting/invoices'
      path: '/invoices'
      fullPath: '/accounting/invoices'
      preLoaderRoute: typeof AuthenticatedAccountingInvoicesRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/journal': {
      id: '/_authenticated/accounting/journal'
      path: '/journal'
      fullPath: '/accounting/journal'
      preLoaderRoute: typeof AuthenticatedAccountingJournalRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/journals': {
      id: '/_authenticated/accounting/journals'
      path: '/journals'
      fullPath: '/accounting/journals'
      preLoaderRoute: typeof AuthenticatedAccountingJournalsRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/payment-terms': {
      id: '/_authenticated/accounting/payment-terms'
      path: '/payment-terms'
      fullPath: '/accounting/payment-terms'
      preLoaderRoute: typeof AuthenticatedAccountingPaymentTermsRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/payments': {
      id: '/_authenticated/accounting/payments'
      path: '/payments'
      fullPath: '/accounting/payments'
      preLoaderRoute: typeof AuthenticatedAccountingPaymentsRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/periods': {
      id: '/_authenticated/accounting/periods'
      path: '/periods'
      fullPath: '/accounting/periods'
      preLoaderRoute: typeof AuthenticatedAccountingPeriodsRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/posting-intents': {
      id: '/_authenticated/accounting/posting-intents'
      path: '/posting-intents'
      fullPath: '/accounting/posting-intents'
      preLoaderRoute: typeof AuthenticatedAccountingPostingIntentsRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/prepaid': {
      id: '/_authenticated/accounting/prepaid'
      path: '/prepaid'
      fullPath: '/accounting/prepaid'
      preLoaderRoute: typeof AuthenticatedAccountingPrepaidRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/reconciliation': {
      id: '/_authenticated/accounting/reconciliation'
      path: '/reconciliation'
      fullPath: '/accounting/reconciliation'
      preLoaderRoute: typeof AuthenticatedAccountingReconciliationRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/recurring': {
      id: '/_authenticated/accounting/recurring'
      path: '/recurring'
      fullPath: '/accounting/recurring'
      preLoaderRoute: typeof AuthenticatedAccountingRecurringRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/sales-receipts': {
      id: '/_authenticated/accounting/sales-receipts'
      path: '/sales-receipts'
      fullPath: '/accounting/sales-receipts'
      preLoaderRoute: typeof AuthenticatedAccountingSalesReceiptsRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/settings': {
      id: '/_authenticated/accounting/settings'
      path: '/settings'
      fullPath: '/accounting/settings'
      preLoaderRoute: typeof AuthenticatedAccountingSettingsRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/statements': {
      id: '/_authenticated/accounting/statements'
      path: '/statements'
      fullPath: '/accounting/statements'
      preLoaderRoute: typeof AuthenticatedAccountingStatementsRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/tax': {
      id: '/_authenticated/accounting/tax'
      path: '/tax'
      fullPath: '/accounting/tax'
      preLoaderRoute: typeof AuthenticatedAccountingTaxRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/trial-balance': {
      id: '/_authenticated/accounting/trial-balance'
      path: '/trial-balance'
      fullPath: '/accounting/trial-balance'
      preLoaderRoute: typeof AuthenticatedAccountingTrialBalanceRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/working-capital': {
      id: '/_authenticated/accounting/working-capital'
      path: '/working-capital'
      fullPath: '/accounting/working-capital'
      preLoaderRoute: typeof AuthenticatedAccountingWorkingCapitalRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting_/payroll-payments': {
      id: '/_authenticated/accounting_/payroll-payments'
      path: '/accounting/payroll-payments'
      fullPath: '/accounting/payroll-payments'
      preLoaderRoute: typeof AuthenticatedAccountingPayrollPaymentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/customers/': {
      id: '/_authenticated/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof AuthenticatedCustomersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/customers/new': {
      id: '/_authenticated/customers/new'
      path: '/customers/new'
      fullPath: '/customers/new'
      preLoaderRoute: typeof AuthenticatedCustomersNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/': {
      id: '/_authenticated/hr/'
      path: '/hr'
      fullPath: '/hr/'
      preLoaderRoute: typeof AuthenticatedHrIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/assets': {
      id: '/_authenticated/hr/assets'
      path: '/hr/assets'
      fullPath: '/hr/assets'
      preLoaderRoute: typeof AuthenticatedHrAssetsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/attendance': {
      id: '/_authenticated/hr/attendance'
      path: '/hr/attendance'
      fullPath: '/hr/attendance'
      preLoaderRoute: typeof AuthenticatedHrAttendanceRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/attendance-board': {
      id: '/_authenticated/hr/attendance-board'
      path: '/hr/attendance-board'
      fullPath: '/hr/attendance-board'
      preLoaderRoute: typeof AuthenticatedHrAttendanceBoardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/attendance-corrections': {
      id: '/_authenticated/hr/attendance-corrections'
      path: '/hr/attendance-corrections'
      fullPath: '/hr/attendance-corrections'
      preLoaderRoute: typeof AuthenticatedHrAttendanceCorrectionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/cash-custody': {
      id: '/_authenticated/hr/cash-custody'
      path: '/hr/cash-custody'
      fullPath: '/hr/cash-custody'
      preLoaderRoute: typeof AuthenticatedHrCashCustodyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/expenses': {
      id: '/_authenticated/hr/expenses'
      path: '/hr/expenses'
      fullPath: '/hr/expenses'
      preLoaderRoute: typeof AuthenticatedHrExpensesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/field-settings': {
      id: '/_authenticated/hr/field-settings'
      path: '/hr/field-settings'
      fullPath: '/hr/field-settings'
      preLoaderRoute: typeof AuthenticatedHrFieldSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/leave': {
      id: '/_authenticated/hr/leave'
      path: '/hr/leave'
      fullPath: '/hr/leave'
      preLoaderRoute: typeof AuthenticatedHrLeaveRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/org': {
      id: '/_authenticated/hr/org'
      path: '/hr/org'
      fullPath: '/hr/org'
      preLoaderRoute: typeof AuthenticatedHrOrgRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/settings': {
      id: '/_authenticated/hr/settings'
      path: '/hr/settings'
      fullPath: '/hr/settings'
      preLoaderRoute: typeof AuthenticatedHrSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/work-entries': {
      id: '/_authenticated/hr/work-entries'
      path: '/hr/work-entries'
      fullPath: '/hr/work-entries'
      preLoaderRoute: typeof AuthenticatedHrWorkEntriesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/work-schedules': {
      id: '/_authenticated/hr/work-schedules'
      path: '/hr/work-schedules'
      fullPath: '/hr/work-schedules'
      preLoaderRoute: typeof AuthenticatedHrWorkSchedulesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inventory/': {
      id: '/_authenticated/inventory/'
      path: '/inventory'
      fullPath: '/inventory/'
      preLoaderRoute: typeof AuthenticatedInventoryIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inventory/access': {
      id: '/_authenticated/inventory/access'
      path: '/inventory/access'
      fullPath: '/inventory/access'
      preLoaderRoute: typeof AuthenticatedInventoryAccessRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inventory/adjustments': {
      id: '/_authenticated/inventory/adjustments'
      path: '/inventory/adjustments'
      fullPath: '/inventory/adjustments'
      preLoaderRoute: typeof AuthenticatedInventoryAdjustmentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inventory/disposals': {
      id: '/_authenticated/inventory/disposals'
      path: '/inventory/disposals'
      fullPath: '/inventory/disposals'
      preLoaderRoute: typeof AuthenticatedInventoryDisposalsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inventory/locations': {
      id: '/_authenticated/inventory/locations'
      path: '/inventory/locations'
      fullPath: '/inventory/locations'
      preLoaderRoute: typeof AuthenticatedInventoryLocationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inventory/movements': {
      id: '/_authenticated/inventory/movements'
      path: '/inventory/movements'
      fullPath: '/inventory/movements'
      preLoaderRoute: typeof AuthenticatedInventoryMovementsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inventory/serials': {
      id: '/_authenticated/inventory/serials'
      path: '/inventory/serials'
      fullPath: '/inventory/serials'
      preLoaderRoute: typeof AuthenticatedInventorySerialsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inventory/stock': {
      id: '/_authenticated/inventory/stock'
      path: '/inventory/stock'
      fullPath: '/inventory/stock'
      preLoaderRoute: typeof AuthenticatedInventoryStockRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inventory/warehouses': {
      id: '/_authenticated/inventory/warehouses'
      path: '/inventory/warehouses'
      fullPath: '/inventory/warehouses'
      preLoaderRoute: typeof AuthenticatedInventoryWarehousesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/payroll/advances': {
      id: '/_authenticated/payroll/advances'
      path: '/advances'
      fullPath: '/payroll/advances'
      preLoaderRoute: typeof AuthenticatedPayrollAdvancesRouteImport
      parentRoute: typeof AuthenticatedPayrollRoute
    }
    '/_authenticated/payroll/bulk-assign': {
      id: '/_authenticated/payroll/bulk-assign'
      path: '/bulk-assign'
      fullPath: '/payroll/bulk-assign'
      preLoaderRoute: typeof AuthenticatedPayrollBulkAssignRouteImport
      parentRoute: typeof AuthenticatedPayrollRoute
    }
    '/_authenticated/payroll/components': {
      id: '/_authenticated/payroll/components'
      path: '/components'
      fullPath: '/payroll/components'
      preLoaderRoute: typeof AuthenticatedPayrollComponentsRouteImport
      parentRoute: typeof AuthenticatedPayrollRoute
    }
    '/_authenticated/payroll/payslips': {
      id: '/_authenticated/payroll/payslips'
      path: '/payslips'
      fullPath: '/payroll/payslips'
      preLoaderRoute: typeof AuthenticatedPayrollPayslipsRouteImport
      parentRoute: typeof AuthenticatedPayrollRoute
    }
    '/_authenticated/payroll/runs': {
      id: '/_authenticated/payroll/runs'
      path: '/runs'
      fullPath: '/payroll/runs'
      preLoaderRoute: typeof AuthenticatedPayrollRunsRouteImport
      parentRoute: typeof AuthenticatedPayrollRoute
    }
    '/_authenticated/payroll/settings': {
      id: '/_authenticated/payroll/settings'
      path: '/settings'
      fullPath: '/payroll/settings'
      preLoaderRoute: typeof AuthenticatedPayrollSettingsRouteImport
      parentRoute: typeof AuthenticatedPayrollRoute
    }
    '/_authenticated/product-categories/': {
      id: '/_authenticated/product-categories/'
      path: '/product-categories'
      fullPath: '/product-categories/'
      preLoaderRoute: typeof AuthenticatedProductCategoriesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/product-categories/new': {
      id: '/_authenticated/product-categories/new'
      path: '/product-categories/new'
      fullPath: '/product-categories/new'
      preLoaderRoute: typeof AuthenticatedProductCategoriesNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/products/': {
      id: '/_authenticated/products/'
      path: '/products'
      fullPath: '/products/'
      preLoaderRoute: typeof AuthenticatedProductsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/products/new': {
      id: '/_authenticated/products/new'
      path: '/products/new'
      fullPath: '/products/new'
      preLoaderRoute: typeof AuthenticatedProductsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/products/units-of-measure': {
      id: '/_authenticated/products/units-of-measure'
      path: '/products/units-of-measure'
      fullPath: '/products/units-of-measure'
      preLoaderRoute: typeof AuthenticatedProductsUnitsOfMeasureRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/purchasing/': {
      id: '/_authenticated/purchasing/'
      path: '/purchasing'
      fullPath: '/purchasing/'
      preLoaderRoute: typeof AuthenticatedPurchasingIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/purchasing/landed-cost-categories': {
      id: '/_authenticated/purchasing/landed-cost-categories'
      path: '/purchasing/landed-cost-categories'
      fullPath: '/purchasing/landed-cost-categories'
      preLoaderRoute: typeof AuthenticatedPurchasingLandedCostCategoriesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/purchasing/landed-costs': {
      id: '/_authenticated/purchasing/landed-costs'
      path: '/purchasing/landed-costs'
      fullPath: '/purchasing/landed-costs'
      preLoaderRoute: typeof AuthenticatedPurchasingLandedCostsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/purchasing/orders': {
      id: '/_authenticated/purchasing/orders'
      path: '/purchasing/orders'
      fullPath: '/purchasing/orders'
      preLoaderRoute: typeof AuthenticatedPurchasingOrdersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/purchasing/receipts': {
      id: '/_authenticated/purchasing/receipts'
      path: '/purchasing/receipts'
      fullPath: '/purchasing/receipts'
      preLoaderRoute: typeof AuthenticatedPurchasingReceiptsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/purchasing/returns': {
      id: '/_authenticated/purchasing/returns'
      path: '/purchasing/returns'
      fullPath: '/purchasing/returns'
      preLoaderRoute: typeof AuthenticatedPurchasingReturnsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/recruitment/': {
      id: '/_authenticated/recruitment/'
      path: '/recruitment'
      fullPath: '/recruitment/'
      preLoaderRoute: typeof AuthenticatedRecruitmentIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/roles/': {
      id: '/_authenticated/roles/'
      path: '/'
      fullPath: '/roles/'
      preLoaderRoute: typeof AuthenticatedRolesIndexRouteImport
      parentRoute: typeof AuthenticatedRolesRoute
    }
    '/_authenticated/roles/$roleId': {
      id: '/_authenticated/roles/$roleId'
      path: '/$roleId'
      fullPath: '/roles/$roleId'
      preLoaderRoute: typeof AuthenticatedRolesRoleIdRouteImport
      parentRoute: typeof AuthenticatedRolesRoute
    }
    '/_authenticated/roles/new': {
      id: '/_authenticated/roles/new'
      path: '/new'
      fullPath: '/roles/new'
      preLoaderRoute: typeof AuthenticatedRolesNewRouteImport
      parentRoute: typeof AuthenticatedRolesRoute
    }
    '/_authenticated/sales/': {
      id: '/_authenticated/sales/'
      path: '/sales'
      fullPath: '/sales/'
      preLoaderRoute: typeof AuthenticatedSalesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sales/orders': {
      id: '/_authenticated/sales/orders'
      path: '/sales/orders'
      fullPath: '/sales/orders'
      preLoaderRoute: typeof AuthenticatedSalesOrdersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sales/reservations': {
      id: '/_authenticated/sales/reservations'
      path: '/sales/reservations'
      fullPath: '/sales/reservations'
      preLoaderRoute: typeof AuthenticatedSalesReservationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sales/returns': {
      id: '/_authenticated/sales/returns'
      path: '/sales/returns'
      fullPath: '/sales/returns'
      preLoaderRoute: typeof AuthenticatedSalesReturnsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/alerts': {
      id: '/_authenticated/settings/alerts'
      path: '/settings/alerts'
      fullPath: '/settings/alerts'
      preLoaderRoute: typeof AuthenticatedSettingsAlertsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/data-import': {
      id: '/_authenticated/settings/data-import'
      path: '/settings/data-import'
      fullPath: '/settings/data-import'
      preLoaderRoute: typeof AuthenticatedSettingsDataImportRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/notifications': {
      id: '/_authenticated/settings/notifications'
      path: '/settings/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthenticatedSettingsNotificationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/workflows': {
      id: '/_authenticated/settings/workflows'
      path: '/settings/workflows'
      fullPath: '/settings/workflows'
      preLoaderRoute: typeof AuthenticatedSettingsWorkflowsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/suppliers/': {
      id: '/_authenticated/suppliers/'
      path: '/suppliers'
      fullPath: '/suppliers/'
      preLoaderRoute: typeof AuthenticatedSuppliersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/suppliers/new': {
      id: '/_authenticated/suppliers/new'
      path: '/suppliers/new'
      fullPath: '/suppliers/new'
      preLoaderRoute: typeof AuthenticatedSuppliersNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tags/': {
      id: '/_authenticated/tags/'
      path: '/tags'
      fullPath: '/tags/'
      preLoaderRoute: typeof AuthenticatedTagsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/accounting/assets/$assetId': {
      id: '/_authenticated/accounting/assets/$assetId'
      path: '/$assetId'
      fullPath: '/accounting/assets/$assetId'
      preLoaderRoute: typeof AuthenticatedAccountingAssetsAssetIdRouteImport
      parentRoute: typeof AuthenticatedAccountingAssetsRoute
    }
    '/_authenticated/accounting/assets/depreciation': {
      id: '/_authenticated/accounting/assets/depreciation'
      path: '/depreciation'
      fullPath: '/accounting/assets/depreciation'
      preLoaderRoute: typeof AuthenticatedAccountingAssetsDepreciationRouteImport
      parentRoute: typeof AuthenticatedAccountingAssetsRoute
    }
    '/_authenticated/accounting/bank-accounts/': {
      id: '/_authenticated/accounting/bank-accounts/'
      path: '/bank-accounts'
      fullPath: '/accounting/bank-accounts/'
      preLoaderRoute: typeof AuthenticatedAccountingBankAccountsIndexRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/bills/new': {
      id: '/_authenticated/accounting/bills/new'
      path: '/new'
      fullPath: '/accounting/bills/new'
      preLoaderRoute: typeof AuthenticatedAccountingBillsNewRouteImport
      parentRoute: typeof AuthenticatedAccountingBillsRoute
    }
    '/_authenticated/accounting/bills/pay': {
      id: '/_authenticated/accounting/bills/pay'
      path: '/pay'
      fullPath: '/accounting/bills/pay'
      preLoaderRoute: typeof AuthenticatedAccountingBillsPayRouteImport
      parentRoute: typeof AuthenticatedAccountingBillsRoute
    }
    '/_authenticated/accounting/budgets/$budgetId': {
      id: '/_authenticated/accounting/budgets/$budgetId'
      path: '/$budgetId'
      fullPath: '/accounting/budgets/$budgetId'
      preLoaderRoute: typeof AuthenticatedAccountingBudgetsBudgetIdRouteImport
      parentRoute: typeof AuthenticatedAccountingBudgetsRoute
    }
    '/_authenticated/accounting/budgets/new': {
      id: '/_authenticated/accounting/budgets/new'
      path: '/new'
      fullPath: '/accounting/budgets/new'
      preLoaderRoute: typeof AuthenticatedAccountingBudgetsNewRouteImport
      parentRoute: typeof AuthenticatedAccountingBudgetsRoute
    }
    '/_authenticated/accounting/card-credits/new': {
      id: '/_authenticated/accounting/card-credits/new'
      path: '/card-credits/new'
      fullPath: '/accounting/card-credits/new'
      preLoaderRoute: typeof AuthenticatedAccountingCardCreditsNewRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/cash-sales/new': {
      id: '/_authenticated/accounting/cash-sales/new'
      path: '/new'
      fullPath: '/accounting/cash-sales/new'
      preLoaderRoute: typeof AuthenticatedAccountingCashSalesNewRouteImport
      parentRoute: typeof AuthenticatedAccountingCashSalesRoute
    }
    '/_authenticated/accounting/cheques/outstanding': {
      id: '/_authenticated/accounting/cheques/outstanding'
      path: '/outstanding'
      fullPath: '/accounting/cheques/outstanding'
      preLoaderRoute: typeof AuthenticatedAccountingChequesOutstandingRouteImport
      parentRoute: typeof AuthenticatedAccountingChequesRoute
    }
    '/_authenticated/accounting/credit-notes/new': {
      id: '/_authenticated/accounting/credit-notes/new'
      path: '/new'
      fullPath: '/accounting/credit-notes/new'
      preLoaderRoute: typeof AuthenticatedAccountingCreditNotesNewRouteImport
      parentRoute: typeof AuthenticatedAccountingCreditNotesRoute
    }
    '/_authenticated/accounting/deposits/': {
      id: '/_authenticated/accounting/deposits/'
      path: '/deposits'
      fullPath: '/accounting/deposits/'
      preLoaderRoute: typeof AuthenticatedAccountingDepositsIndexRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/deposits/$depositId': {
      id: '/_authenticated/accounting/deposits/$depositId'
      path: '/deposits/$depositId'
      fullPath: '/accounting/deposits/$depositId'
      preLoaderRoute: typeof AuthenticatedAccountingDepositsDepositIdRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/deposits/new': {
      id: '/_authenticated/accounting/deposits/new'
      path: '/deposits/new'
      fullPath: '/accounting/deposits/new'
      preLoaderRoute: typeof AuthenticatedAccountingDepositsNewRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/expenses/': {
      id: '/_authenticated/accounting/expenses/'
      path: '/expenses'
      fullPath: '/accounting/expenses/'
      preLoaderRoute: typeof AuthenticatedAccountingExpensesIndexRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/expenses/$documentId': {
      id: '/_authenticated/accounting/expenses/$documentId'
      path: '/expenses/$documentId'
      fullPath: '/accounting/expenses/$documentId'
      preLoaderRoute: typeof AuthenticatedAccountingExpensesDocumentIdRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/expenses/new': {
      id: '/_authenticated/accounting/expenses/new'
      path: '/expenses/new'
      fullPath: '/accounting/expenses/new'
      preLoaderRoute: typeof AuthenticatedAccountingExpensesNewRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/invoices/new': {
      id: '/_authenticated/accounting/invoices/new'
      path: '/new'
      fullPath: '/accounting/invoices/new'
      preLoaderRoute: typeof AuthenticatedAccountingInvoicesNewRouteImport
      parentRoute: typeof AuthenticatedAccountingInvoicesRoute
    }
    '/_authenticated/accounting/journal/$entryId': {
      id: '/_authenticated/accounting/journal/$entryId'
      path: '/$entryId'
      fullPath: '/accounting/journal/$entryId'
      preLoaderRoute: typeof AuthenticatedAccountingJournalEntryIdRouteImport
      parentRoute: typeof AuthenticatedAccountingJournalRoute
    }
    '/_authenticated/accounting/journal/new': {
      id: '/_authenticated/accounting/journal/new'
      path: '/new'
      fullPath: '/accounting/journal/new'
      preLoaderRoute: typeof AuthenticatedAccountingJournalNewRouteImport
      parentRoute: typeof AuthenticatedAccountingJournalRoute
    }
    '/_authenticated/accounting/opening-balances/': {
      id: '/_authenticated/accounting/opening-balances/'
      path: '/opening-balances'
      fullPath: '/accounting/opening-balances/'
      preLoaderRoute: typeof AuthenticatedAccountingOpeningBalancesIndexRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/opening-balances/$batchId': {
      id: '/_authenticated/accounting/opening-balances/$batchId'
      path: '/opening-balances/$batchId'
      fullPath: '/accounting/opening-balances/$batchId'
      preLoaderRoute: typeof AuthenticatedAccountingOpeningBalancesBatchIdRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/payments/$paymentId': {
      id: '/_authenticated/accounting/payments/$paymentId'
      path: '/$paymentId'
      fullPath: '/accounting/payments/$paymentId'
      preLoaderRoute: typeof AuthenticatedAccountingPaymentsPaymentIdRouteImport
      parentRoute: typeof AuthenticatedAccountingPaymentsRoute
    }
    '/_authenticated/accounting/payments/new': {
      id: '/_authenticated/accounting/payments/new'
      path: '/new'
      fullPath: '/accounting/payments/new'
      preLoaderRoute: typeof AuthenticatedAccountingPaymentsNewRouteImport
      parentRoute: typeof AuthenticatedAccountingPaymentsRoute
    }
    '/_authenticated/accounting/reconcile/': {
      id: '/_authenticated/accounting/reconcile/'
      path: '/reconcile'
      fullPath: '/accounting/reconcile/'
      preLoaderRoute: typeof AuthenticatedAccountingReconcileIndexRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/reconcile/$reconciliationId': {
      id: '/_authenticated/accounting/reconcile/$reconciliationId'
      path: '/reconcile/$reconciliationId'
      fullPath: '/accounting/reconcile/$reconciliationId'
      preLoaderRoute: typeof AuthenticatedAccountingReconcileReconciliationIdRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/reconciliation/$statementId': {
      id: '/_authenticated/accounting/reconciliation/$statementId'
      path: '/$statementId'
      fullPath: '/accounting/reconciliation/$statementId'
      preLoaderRoute: typeof AuthenticatedAccountingReconciliationStatementIdRouteImport
      parentRoute: typeof AuthenticatedAccountingReconciliationRoute
    }
    '/_authenticated/accounting/refunds/new': {
      id: '/_authenticated/accounting/refunds/new'
      path: '/refunds/new'
      fullPath: '/accounting/refunds/new'
      preLoaderRoute: typeof AuthenticatedAccountingRefundsNewRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/reports/': {
      id: '/_authenticated/accounting/reports/'
      path: '/reports'
      fullPath: '/accounting/reports/'
      preLoaderRoute: typeof AuthenticatedAccountingReportsIndexRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/reports/$reportToken': {
      id: '/_authenticated/accounting/reports/$reportToken'
      path: '/reports/$reportToken'
      fullPath: '/accounting/reports/$reportToken'
      preLoaderRoute: typeof AuthenticatedAccountingReportsReportTokenRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/reports/aging': {
      id: '/_authenticated/accounting/reports/aging'
      path: '/reports/aging'
      fullPath: '/accounting/reports/aging'
      preLoaderRoute: typeof AuthenticatedAccountingReportsAgingRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/reports/balance-sheet': {
      id: '/_authenticated/accounting/reports/balance-sheet'
      path: '/reports/balance-sheet'
      fullPath: '/accounting/reports/balance-sheet'
      preLoaderRoute: typeof AuthenticatedAccountingReportsBalanceSheetRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/reports/cash-flow': {
      id: '/_authenticated/accounting/reports/cash-flow'
      path: '/reports/cash-flow'
      fullPath: '/accounting/reports/cash-flow'
      preLoaderRoute: typeof AuthenticatedAccountingReportsCashFlowRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/reports/cash-position': {
      id: '/_authenticated/accounting/reports/cash-position'
      path: '/reports/cash-position'
      fullPath: '/accounting/reports/cash-position'
      preLoaderRoute: typeof AuthenticatedAccountingReportsCashPositionRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/reports/cost-by-name': {
      id: '/_authenticated/accounting/reports/cost-by-name'
      path: '/reports/cost-by-name'
      fullPath: '/accounting/reports/cost-by-name'
      preLoaderRoute: typeof AuthenticatedAccountingReportsCostByNameRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/reports/general-ledger': {
      id: '/_authenticated/accounting/reports/general-ledger'
      path: '/reports/general-ledger'
      fullPath: '/accounting/reports/general-ledger'
      preLoaderRoute: typeof AuthenticatedAccountingReportsGeneralLedgerRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/reports/monthly-statements': {
      id: '/_authenticated/accounting/reports/monthly-statements'
      path: '/reports/monthly-statements'
      fullPath: '/accounting/reports/monthly-statements'
      preLoaderRoute: typeof AuthenticatedAccountingReportsMonthlyStatementsRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/reports/profit-and-loss': {
      id: '/_authenticated/accounting/reports/profit-and-loss'
      path: '/reports/profit-and-loss'
      fullPath: '/accounting/reports/profit-and-loss'
      preLoaderRoute: typeof AuthenticatedAccountingReportsProfitAndLossRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/reports/tax': {
      id: '/_authenticated/accounting/reports/tax'
      path: '/reports/tax'
      fullPath: '/accounting/reports/tax'
      preLoaderRoute: typeof AuthenticatedAccountingReportsTaxRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/sales-receipts/new': {
      id: '/_authenticated/accounting/sales-receipts/new'
      path: '/new'
      fullPath: '/accounting/sales-receipts/new'
      preLoaderRoute: typeof AuthenticatedAccountingSalesReceiptsNewRouteImport
      parentRoute: typeof AuthenticatedAccountingSalesReceiptsRoute
    }
    '/_authenticated/accounting/sales/': {
      id: '/_authenticated/accounting/sales/'
      path: '/sales'
      fullPath: '/accounting/sales/'
      preLoaderRoute: typeof AuthenticatedAccountingSalesIndexRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/spend/': {
      id: '/_authenticated/accounting/spend/'
      path: '/spend'
      fullPath: '/accounting/spend/'
      preLoaderRoute: typeof AuthenticatedAccountingSpendIndexRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/spend/$documentId': {
      id: '/_authenticated/accounting/spend/$documentId'
      path: '/spend/$documentId'
      fullPath: '/accounting/spend/$documentId'
      preLoaderRoute: typeof AuthenticatedAccountingSpendDocumentIdRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/spend/new': {
      id: '/_authenticated/accounting/spend/new'
      path: '/spend/new'
      fullPath: '/accounting/spend/new'
      preLoaderRoute: typeof AuthenticatedAccountingSpendNewRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/supplier-credits/new': {
      id: '/_authenticated/accounting/supplier-credits/new'
      path: '/supplier-credits/new'
      fullPath: '/accounting/supplier-credits/new'
      preLoaderRoute: typeof AuthenticatedAccountingSupplierCreditsNewRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/supplier-statement/$supplierId': {
      id: '/_authenticated/accounting/supplier-statement/$supplierId'
      path: '/supplier-statement/$supplierId'
      fullPath: '/accounting/supplier-statement/$supplierId'
      preLoaderRoute: typeof AuthenticatedAccountingSupplierStatementSupplierIdRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/transfers/new': {
      id: '/_authenticated/accounting/transfers/new'
      path: '/transfers/new'
      fullPath: '/accounting/transfers/new'
      preLoaderRoute: typeof AuthenticatedAccountingTransfersNewRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/customers/$customerId/': {
      id: '/_authenticated/customers/$customerId/'
      path: '/customers/$customerId'
      fullPath: '/customers/$customerId/'
      preLoaderRoute: typeof AuthenticatedCustomersCustomerIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/customers/$customerId/edit': {
      id: '/_authenticated/customers/$customerId/edit'
      path: '/customers/$customerId/edit'
      fullPath: '/customers/$customerId/edit'
      preLoaderRoute: typeof AuthenticatedCustomersCustomerIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/group/reports/': {
      id: '/_authenticated/group/reports/'
      path: '/group/reports'
      fullPath: '/group/reports/'
      preLoaderRoute: typeof AuthenticatedGroupReportsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/group/reports/balance-sheet': {
      id: '/_authenticated/group/reports/balance-sheet'
      path: '/group/reports/balance-sheet'
      fullPath: '/group/reports/balance-sheet'
      preLoaderRoute: typeof AuthenticatedGroupReportsBalanceSheetRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/group/reports/profit-and-loss': {
      id: '/_authenticated/group/reports/profit-and-loss'
      path: '/group/reports/profit-and-loss'
      fullPath: '/group/reports/profit-and-loss'
      preLoaderRoute: typeof AuthenticatedGroupReportsProfitAndLossRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/assets/$assetId': {
      id: '/_authenticated/hr/assets/$assetId'
      path: '/$assetId'
      fullPath: '/hr/assets/$assetId'
      preLoaderRoute: typeof AuthenticatedHrAssetsAssetIdRouteImport
      parentRoute: typeof AuthenticatedHrAssetsRoute
    }
    '/_authenticated/hr/attendance-corrections/$requestId': {
      id: '/_authenticated/hr/attendance-corrections/$requestId'
      path: '/$requestId'
      fullPath: '/hr/attendance-corrections/$requestId'
      preLoaderRoute: typeof AuthenticatedHrAttendanceCorrectionsRequestIdRouteImport
      parentRoute: typeof AuthenticatedHrAttendanceCorrectionsRoute
    }
    '/_authenticated/hr/cash-custody/$custodyId': {
      id: '/_authenticated/hr/cash-custody/$custodyId'
      path: '/$custodyId'
      fullPath: '/hr/cash-custody/$custodyId'
      preLoaderRoute: typeof AuthenticatedHrCashCustodyCustodyIdRouteImport
      parentRoute: typeof AuthenticatedHrCashCustodyRoute
    }
    '/_authenticated/hr/employees/': {
      id: '/_authenticated/hr/employees/'
      path: '/hr/employees'
      fullPath: '/hr/employees/'
      preLoaderRoute: typeof AuthenticatedHrEmployeesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/employees/$employeeId': {
      id: '/_authenticated/hr/employees/$employeeId'
      path: '/hr/employees/$employeeId'
      fullPath: '/hr/employees/$employeeId'
      preLoaderRoute: typeof AuthenticatedHrEmployeesEmployeeIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/employees/new': {
      id: '/_authenticated/hr/employees/new'
      path: '/hr/employees/new'
      fullPath: '/hr/employees/new'
      preLoaderRoute: typeof AuthenticatedHrEmployeesNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/expenses/$claimId': {
      id: '/_authenticated/hr/expenses/$claimId'
      path: '/$claimId'
      fullPath: '/hr/expenses/$claimId'
      preLoaderRoute: typeof AuthenticatedHrExpensesClaimIdRouteImport
      parentRoute: typeof AuthenticatedHrExpensesRoute
    }
    '/_authenticated/hr/leave/$requestId': {
      id: '/_authenticated/hr/leave/$requestId'
      path: '/$requestId'
      fullPath: '/hr/leave/$requestId'
      preLoaderRoute: typeof AuthenticatedHrLeaveRequestIdRouteImport
      parentRoute: typeof AuthenticatedHrLeaveRoute
    }
    '/_authenticated/hr/performance/': {
      id: '/_authenticated/hr/performance/'
      path: '/hr/performance'
      fullPath: '/hr/performance/'
      preLoaderRoute: typeof AuthenticatedHrPerformanceIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/performance/schedules': {
      id: '/_authenticated/hr/performance/schedules'
      path: '/hr/performance/schedules'
      fullPath: '/hr/performance/schedules'
      preLoaderRoute: typeof AuthenticatedHrPerformanceSchedulesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/performance/templates': {
      id: '/_authenticated/hr/performance/templates'
      path: '/hr/performance/templates'
      fullPath: '/hr/performance/templates'
      preLoaderRoute: typeof AuthenticatedHrPerformanceTemplatesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/': {
      id: '/_authenticated/hr/reports/'
      path: '/hr/reports'
      fullPath: '/hr/reports/'
      preLoaderRoute: typeof AuthenticatedHrReportsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/absence-coverage': {
      id: '/_authenticated/hr/reports/absence-coverage'
      path: '/hr/reports/absence-coverage'
      fullPath: '/hr/reports/absence-coverage'
      preLoaderRoute: typeof AuthenticatedHrReportsAbsenceCoverageRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/absence-detail': {
      id: '/_authenticated/hr/reports/absence-detail'
      path: '/hr/reports/absence-detail'
      fullPath: '/hr/reports/absence-detail'
      preLoaderRoute: typeof AuthenticatedHrReportsAbsenceDetailRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/analytics': {
      id: '/_authenticated/hr/reports/analytics'
      path: '/hr/reports/analytics'
      fullPath: '/hr/reports/analytics'
      preLoaderRoute: typeof AuthenticatedHrReportsAnalyticsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/asset-custody': {
      id: '/_authenticated/hr/reports/asset-custody'
      path: '/hr/reports/asset-custody'
      fullPath: '/hr/reports/asset-custody'
      preLoaderRoute: typeof AuthenticatedHrReportsAssetCustodyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/asset-exceptions': {
      id: '/_authenticated/hr/reports/asset-exceptions'
      path: '/hr/reports/asset-exceptions'
      fullPath: '/hr/reports/asset-exceptions'
      preLoaderRoute: typeof AuthenticatedHrReportsAssetExceptionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/attendance-exceptions': {
      id: '/_authenticated/hr/reports/attendance-exceptions'
      path: '/hr/reports/attendance-exceptions'
      fullPath: '/hr/reports/attendance-exceptions'
      preLoaderRoute: typeof AuthenticatedHrReportsAttendanceExceptionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/attendance-sheet': {
      id: '/_authenticated/hr/reports/attendance-sheet'
      path: '/hr/reports/attendance-sheet'
      fullPath: '/hr/reports/attendance-sheet'
      preLoaderRoute: typeof AuthenticatedHrReportsAttendanceSheetRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/attendance-summary': {
      id: '/_authenticated/hr/reports/attendance-summary'
      path: '/hr/reports/attendance-summary'
      fullPath: '/hr/reports/attendance-summary'
      preLoaderRoute: typeof AuthenticatedHrReportsAttendanceSummaryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/birthdays': {
      id: '/_authenticated/hr/reports/birthdays'
      path: '/hr/reports/birthdays'
      fullPath: '/hr/reports/birthdays'
      preLoaderRoute: typeof AuthenticatedHrReportsBirthdaysRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/breaks-sessions': {
      id: '/_authenticated/hr/reports/breaks-sessions'
      path: '/hr/reports/breaks-sessions'
      fullPath: '/hr/reports/breaks-sessions'
      preLoaderRoute: typeof AuthenticatedHrReportsBreaksSessionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/cash-custody-balances': {
      id: '/_authenticated/hr/reports/cash-custody-balances'
      path: '/hr/reports/cash-custody-balances'
      fullPath: '/hr/reports/cash-custody-balances'
      preLoaderRoute: typeof AuthenticatedHrReportsCashCustodyBalancesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/demographics': {
      id: '/_authenticated/hr/reports/demographics'
      path: '/hr/reports/demographics'
      fullPath: '/hr/reports/demographics'
      preLoaderRoute: typeof AuthenticatedHrReportsDemographicsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/document-expiry': {
      id: '/_authenticated/hr/reports/document-expiry'
      path: '/hr/reports/document-expiry'
      fullPath: '/hr/reports/document-expiry'
      preLoaderRoute: typeof AuthenticatedHrReportsDocumentExpiryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/expense-ageing': {
      id: '/_authenticated/hr/reports/expense-ageing'
      path: '/hr/reports/expense-ageing'
      fullPath: '/hr/reports/expense-ageing'
      preLoaderRoute: typeof AuthenticatedHrReportsExpenseAgeingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/expense-claims': {
      id: '/_authenticated/hr/reports/expense-claims'
      path: '/hr/reports/expense-claims'
      fullPath: '/hr/reports/expense-claims'
      preLoaderRoute: typeof AuthenticatedHrReportsExpenseClaimsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/headcount': {
      id: '/_authenticated/hr/reports/headcount'
      path: '/hr/reports/headcount'
      fullPath: '/hr/reports/headcount'
      preLoaderRoute: typeof AuthenticatedHrReportsHeadcountRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/holiday-roll': {
      id: '/_authenticated/hr/reports/holiday-roll'
      path: '/hr/reports/holiday-roll'
      fullPath: '/hr/reports/holiday-roll'
      preLoaderRoute: typeof AuthenticatedHrReportsHolidayRollRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/joiners-leavers': {
      id: '/_authenticated/hr/reports/joiners-leavers'
      path: '/hr/reports/joiners-leavers'
      fullPath: '/hr/reports/joiners-leavers'
      preLoaderRoute: typeof AuthenticatedHrReportsJoinersLeaversRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/lateness': {
      id: '/_authenticated/hr/reports/lateness'
      path: '/hr/reports/lateness'
      fullPath: '/hr/reports/lateness'
      preLoaderRoute: typeof AuthenticatedHrReportsLatenessRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/leave-balances': {
      id: '/_authenticated/hr/reports/leave-balances'
      path: '/hr/reports/leave-balances'
      fullPath: '/hr/reports/leave-balances'
      preLoaderRoute: typeof AuthenticatedHrReportsLeaveBalancesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/leave-liability': {
      id: '/_authenticated/hr/reports/leave-liability'
      path: '/hr/reports/leave-liability'
      fullPath: '/hr/reports/leave-liability'
      preLoaderRoute: typeof AuthenticatedHrReportsLeaveLiabilityRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/leave-taken': {
      id: '/_authenticated/hr/reports/leave-taken'
      path: '/hr/reports/leave-taken'
      fullPath: '/hr/reports/leave-taken'
      preLoaderRoute: typeof AuthenticatedHrReportsLeaveTakenRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/org-hygiene': {
      id: '/_authenticated/hr/reports/org-hygiene'
      path: '/hr/reports/org-hygiene'
      fullPath: '/hr/reports/org-hygiene'
      preLoaderRoute: typeof AuthenticatedHrReportsOrgHygieneRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/overtime': {
      id: '/_authenticated/hr/reports/overtime'
      path: '/hr/reports/overtime'
      fullPath: '/hr/reports/overtime'
      preLoaderRoute: typeof AuthenticatedHrReportsOvertimeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/payroll-deductions': {
      id: '/_authenticated/hr/reports/payroll-deductions'
      path: '/hr/reports/payroll-deductions'
      fullPath: '/hr/reports/payroll-deductions'
      preLoaderRoute: typeof AuthenticatedHrReportsPayrollDeductionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/payroll-register': {
      id: '/_authenticated/hr/reports/payroll-register'
      path: '/hr/reports/payroll-register'
      fullPath: '/hr/reports/payroll-register'
      preLoaderRoute: typeof AuthenticatedHrReportsPayrollRegisterRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/payroll-summary': {
      id: '/_authenticated/hr/reports/payroll-summary'
      path: '/hr/reports/payroll-summary'
      fullPath: '/hr/reports/payroll-summary'
      preLoaderRoute: typeof AuthenticatedHrReportsPayrollSummaryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/payroll-variance': {
      id: '/_authenticated/hr/reports/payroll-variance'
      path: '/hr/reports/payroll-variance'
      fullPath: '/hr/reports/payroll-variance'
      preLoaderRoute: typeof AuthenticatedHrReportsPayrollVarianceRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/permission-requests': {
      id: '/_authenticated/hr/reports/permission-requests'
      path: '/hr/reports/permission-requests'
      fullPath: '/hr/reports/permission-requests'
      preLoaderRoute: typeof AuthenticatedHrReportsPermissionRequestsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/probation-contract': {
      id: '/_authenticated/hr/reports/probation-contract'
      path: '/hr/reports/probation-contract'
      fullPath: '/hr/reports/probation-contract'
      preLoaderRoute: typeof AuthenticatedHrReportsProbationContractRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/review-completion': {
      id: '/_authenticated/hr/reports/review-completion'
      path: '/hr/reports/review-completion'
      fullPath: '/hr/reports/review-completion'
      preLoaderRoute: typeof AuthenticatedHrReportsReviewCompletionRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/roster-bank': {
      id: '/_authenticated/hr/reports/roster-bank'
      path: '/hr/reports/roster-bank'
      fullPath: '/hr/reports/roster-bank'
      preLoaderRoute: typeof AuthenticatedHrReportsRosterBankRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/roster-compensation': {
      id: '/_authenticated/hr/reports/roster-compensation'
      path: '/hr/reports/roster-compensation'
      fullPath: '/hr/reports/roster-compensation'
      preLoaderRoute: typeof AuthenticatedHrReportsRosterCompensationRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/roster-contact': {
      id: '/_authenticated/hr/reports/roster-contact'
      path: '/hr/reports/roster-contact'
      fullPath: '/hr/reports/roster-contact'
      preLoaderRoute: typeof AuthenticatedHrReportsRosterContactRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/roster-emergency': {
      id: '/_authenticated/hr/reports/roster-emergency'
      path: '/hr/reports/roster-emergency'
      fullPath: '/hr/reports/roster-emergency'
      preLoaderRoute: typeof AuthenticatedHrReportsRosterEmergencyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/roster-employment': {
      id: '/_authenticated/hr/reports/roster-employment'
      path: '/hr/reports/roster-employment'
      fullPath: '/hr/reports/roster-employment'
      preLoaderRoute: typeof AuthenticatedHrReportsRosterEmploymentRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/roster-team-member': {
      id: '/_authenticated/hr/reports/roster-team-member'
      path: '/hr/reports/roster-team-member'
      fullPath: '/hr/reports/roster-team-member'
      preLoaderRoute: typeof AuthenticatedHrReportsRosterTeamMemberRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/score-distribution': {
      id: '/_authenticated/hr/reports/score-distribution'
      path: '/hr/reports/score-distribution'
      fullPath: '/hr/reports/score-distribution'
      preLoaderRoute: typeof AuthenticatedHrReportsScoreDistributionRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/time-off-review': {
      id: '/_authenticated/hr/reports/time-off-review'
      path: '/hr/reports/time-off-review'
      fullPath: '/hr/reports/time-off-review'
      preLoaderRoute: typeof AuthenticatedHrReportsTimeOffReviewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/turnover': {
      id: '/_authenticated/hr/reports/turnover'
      path: '/hr/reports/turnover'
      fullPath: '/hr/reports/turnover'
      preLoaderRoute: typeof AuthenticatedHrReportsTurnoverRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/violations': {
      id: '/_authenticated/hr/reports/violations'
      path: '/hr/reports/violations'
      fullPath: '/hr/reports/violations'
      preLoaderRoute: typeof AuthenticatedHrReportsViolationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/reports/work-hours': {
      id: '/_authenticated/hr/reports/work-hours'
      path: '/hr/reports/work-hours'
      fullPath: '/hr/reports/work-hours'
      preLoaderRoute: typeof AuthenticatedHrReportsWorkHoursRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/violations/': {
      id: '/_authenticated/hr/violations/'
      path: '/hr/violations'
      fullPath: '/hr/violations/'
      preLoaderRoute: typeof AuthenticatedHrViolationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/violations/$violationId': {
      id: '/_authenticated/hr/violations/$violationId'
      path: '/hr/violations/$violationId'
      fullPath: '/hr/violations/$violationId'
      preLoaderRoute: typeof AuthenticatedHrViolationsViolationIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inventory/counts/': {
      id: '/_authenticated/inventory/counts/'
      path: '/inventory/counts'
      fullPath: '/inventory/counts/'
      preLoaderRoute: typeof AuthenticatedInventoryCountsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inventory/lots/': {
      id: '/_authenticated/inventory/lots/'
      path: '/inventory/lots'
      fullPath: '/inventory/lots/'
      preLoaderRoute: typeof AuthenticatedInventoryLotsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inventory/lots/$lotId': {
      id: '/_authenticated/inventory/lots/$lotId'
      path: '/inventory/lots/$lotId'
      fullPath: '/inventory/lots/$lotId'
      preLoaderRoute: typeof AuthenticatedInventoryLotsLotIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inventory/reports/': {
      id: '/_authenticated/inventory/reports/'
      path: '/inventory/reports'
      fullPath: '/inventory/reports/'
      preLoaderRoute: typeof AuthenticatedInventoryReportsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inventory/reports/aging': {
      id: '/_authenticated/inventory/reports/aging'
      path: '/inventory/reports/aging'
      fullPath: '/inventory/reports/aging'
      preLoaderRoute: typeof AuthenticatedInventoryReportsAgingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inventory/reports/no-sales': {
      id: '/_authenticated/inventory/reports/no-sales'
      path: '/inventory/reports/no-sales'
      fullPath: '/inventory/reports/no-sales'
      preLoaderRoute: typeof AuthenticatedInventoryReportsNoSalesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inventory/reports/performance': {
      id: '/_authenticated/inventory/reports/performance'
      path: '/inventory/reports/performance'
      fullPath: '/inventory/reports/performance'
      preLoaderRoute: typeof AuthenticatedInventoryReportsPerformanceRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inventory/reports/replenishment': {
      id: '/_authenticated/inventory/reports/replenishment'
      path: '/inventory/reports/replenishment'
      fullPath: '/inventory/reports/replenishment'
      preLoaderRoute: typeof AuthenticatedInventoryReportsReplenishmentRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inventory/reports/stock-valuation': {
      id: '/_authenticated/inventory/reports/stock-valuation'
      path: '/inventory/reports/stock-valuation'
      fullPath: '/inventory/reports/stock-valuation'
      preLoaderRoute: typeof AuthenticatedInventoryReportsStockValuationRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inventory/reports/stock-value': {
      id: '/_authenticated/inventory/reports/stock-value'
      path: '/inventory/reports/stock-value'
      fullPath: '/inventory/reports/stock-value'
      preLoaderRoute: typeof AuthenticatedInventoryReportsStockValueRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inventory/serials/$unitId': {
      id: '/_authenticated/inventory/serials/$unitId'
      path: '/$unitId'
      fullPath: '/inventory/serials/$unitId'
      preLoaderRoute: typeof AuthenticatedInventorySerialsUnitIdRouteImport
      parentRoute: typeof AuthenticatedInventorySerialsRoute
    }
    '/_authenticated/inventory/transfers/': {
      id: '/_authenticated/inventory/transfers/'
      path: '/inventory/transfers'
      fullPath: '/inventory/transfers/'
      preLoaderRoute: typeof AuthenticatedInventoryTransfersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inventory/transfers/$transferId': {
      id: '/_authenticated/inventory/transfers/$transferId'
      path: '/inventory/transfers/$transferId'
      fullPath: '/inventory/transfers/$transferId'
      preLoaderRoute: typeof AuthenticatedInventoryTransfersTransferIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inventory/transfers/new': {
      id: '/_authenticated/inventory/transfers/new'
      path: '/inventory/transfers/new'
      fullPath: '/inventory/transfers/new'
      preLoaderRoute: typeof AuthenticatedInventoryTransfersNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/payroll/payslips/$payslipId': {
      id: '/_authenticated/payroll/payslips/$payslipId'
      path: '/$payslipId'
      fullPath: '/payroll/payslips/$payslipId'
      preLoaderRoute: typeof AuthenticatedPayrollPayslipsPayslipIdRouteImport
      parentRoute: typeof AuthenticatedPayrollPayslipsRoute
    }
    '/_authenticated/payroll/runs/$runId': {
      id: '/_authenticated/payroll/runs/$runId'
      path: '/$runId'
      fullPath: '/payroll/runs/$runId'
      preLoaderRoute: typeof AuthenticatedPayrollRunsRunIdRouteImport
      parentRoute: typeof AuthenticatedPayrollRunsRoute
    }
    '/_authenticated/payroll/settlements/$runId': {
      id: '/_authenticated/payroll/settlements/$runId'
      path: '/settlements/$runId'
      fullPath: '/payroll/settlements/$runId'
      preLoaderRoute: typeof AuthenticatedPayrollSettlementsRunIdRouteImport
      parentRoute: typeof AuthenticatedPayrollRoute
    }
    '/_authenticated/product-categories/$categoryId/edit': {
      id: '/_authenticated/product-categories/$categoryId/edit'
      path: '/product-categories/$categoryId/edit'
      fullPath: '/product-categories/$categoryId/edit'
      preLoaderRoute: typeof AuthenticatedProductCategoriesCategoryIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/products/$productId/': {
      id: '/_authenticated/products/$productId/'
      path: '/products/$productId'
      fullPath: '/products/$productId/'
      preLoaderRoute: typeof AuthenticatedProductsProductIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/products/$productId/edit': {
      id: '/_authenticated/products/$productId/edit'
      path: '/products/$productId/edit'
      fullPath: '/products/$productId/edit'
      preLoaderRoute: typeof AuthenticatedProductsProductIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/purchasing/landed-costs/new': {
      id: '/_authenticated/purchasing/landed-costs/new'
      path: '/new'
      fullPath: '/purchasing/landed-costs/new'
      preLoaderRoute: typeof AuthenticatedPurchasingLandedCostsNewRouteImport
      parentRoute: typeof AuthenticatedPurchasingLandedCostsRoute
    }
    '/_authenticated/purchasing/orders/new': {
      id: '/_authenticated/purchasing/orders/new'
      path: '/new'
      fullPath: '/purchasing/orders/new'
      preLoaderRoute: typeof AuthenticatedPurchasingOrdersNewRouteImport
      parentRoute: typeof AuthenticatedPurchasingOrdersRoute
    }
    '/_authenticated/purchasing/reports/goods-received-not-invoiced': {
      id: '/_authenticated/purchasing/reports/goods-received-not-invoiced'
      path: '/purchasing/reports/goods-received-not-invoiced'
      fullPath: '/purchasing/reports/goods-received-not-invoiced'
      preLoaderRoute: typeof AuthenticatedPurchasingReportsGoodsReceivedNotInvoicedRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/purchasing/reports/landed-costs-pending': {
      id: '/_authenticated/purchasing/reports/landed-costs-pending'
      path: '/purchasing/reports/landed-costs-pending'
      fullPath: '/purchasing/reports/landed-costs-pending'
      preLoaderRoute: typeof AuthenticatedPurchasingReportsLandedCostsPendingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/purchasing/reports/three-way-match': {
      id: '/_authenticated/purchasing/reports/three-way-match'
      path: '/purchasing/reports/three-way-match'
      fullPath: '/purchasing/reports/three-way-match'
      preLoaderRoute: typeof AuthenticatedPurchasingReportsThreeWayMatchRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/purchasing/returns/new': {
      id: '/_authenticated/purchasing/returns/new'
      path: '/new'
      fullPath: '/purchasing/returns/new'
      preLoaderRoute: typeof AuthenticatedPurchasingReturnsNewRouteImport
      parentRoute: typeof AuthenticatedPurchasingReturnsRoute
    }
    '/_authenticated/recruitment/candidates/$candidateId': {
      id: '/_authenticated/recruitment/candidates/$candidateId'
      path: '/recruitment/candidates/$candidateId'
      fullPath: '/recruitment/candidates/$candidateId'
      preLoaderRoute: typeof AuthenticatedRecruitmentCandidatesCandidateIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/recruitment/openings/$openingId': {
      id: '/_authenticated/recruitment/openings/$openingId'
      path: '/recruitment/openings/$openingId'
      fullPath: '/recruitment/openings/$openingId'
      preLoaderRoute: typeof AuthenticatedRecruitmentOpeningsOpeningIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sales/orders/new': {
      id: '/_authenticated/sales/orders/new'
      path: '/new'
      fullPath: '/sales/orders/new'
      preLoaderRoute: typeof AuthenticatedSalesOrdersNewRouteImport
      parentRoute: typeof AuthenticatedSalesOrdersRoute
    }
    '/_authenticated/sales/reports/trend': {
      id: '/_authenticated/sales/reports/trend'
      path: '/sales/reports/trend'
      fullPath: '/sales/reports/trend'
      preLoaderRoute: typeof AuthenticatedSalesReportsTrendRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sales/returns/new': {
      id: '/_authenticated/sales/returns/new'
      path: '/new'
      fullPath: '/sales/returns/new'
      preLoaderRoute: typeof AuthenticatedSalesReturnsNewRouteImport
      parentRoute: typeof AuthenticatedSalesReturnsRoute
    }
    '/_authenticated/suppliers/$supplierId/': {
      id: '/_authenticated/suppliers/$supplierId/'
      path: '/suppliers/$supplierId'
      fullPath: '/suppliers/$supplierId/'
      preLoaderRoute: typeof AuthenticatedSuppliersSupplierIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/suppliers/$supplierId/edit': {
      id: '/_authenticated/suppliers/$supplierId/edit'
      path: '/suppliers/$supplierId/edit'
      fullPath: '/suppliers/$supplierId/edit'
      preLoaderRoute: typeof AuthenticatedSuppliersSupplierIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/accounting/accounts/$accountId/register': {
      id: '/_authenticated/accounting/accounts/$accountId/register'
      path: '/accounts/$accountId/register'
      fullPath: '/accounting/accounts/$accountId/register'
      preLoaderRoute: typeof AuthenticatedAccountingAccountsAccountIdRegisterRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/bank-accounts/$accountId/': {
      id: '/_authenticated/accounting/bank-accounts/$accountId/'
      path: '/bank-accounts/$accountId'
      fullPath: '/accounting/bank-accounts/$accountId/'
      preLoaderRoute: typeof AuthenticatedAccountingBankAccountsAccountIdIndexRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
    '/_authenticated/accounting/bills/$billId/': {
      id: '/_authenticated/accounting/bills/$billId/'
      path: '/$billId'
      fullPath: '/accounting/bills/$billId/'
      preLoaderRoute: typeof AuthenticatedAccountingBillsBillIdIndexRouteImport
      parentRoute: typeof AuthenticatedAccountingBillsRoute
    }
    '/_authenticated/accounting/bills/$billId/debit-note': {
      id: '/_authenticated/accounting/bills/$billId/debit-note'
      path: '/$billId/debit-note'
      fullPath: '/accounting/bills/$billId/debit-note'
      preLoaderRoute: typeof AuthenticatedAccountingBillsBillIdDebitNoteRouteImport
      parentRoute: typeof AuthenticatedAccountingBillsRoute
    }
    '/_authenticated/accounting/bills/$billId/edit': {
      id: '/_authenticated/accounting/bills/$billId/edit'
      path: '/$billId/edit'
      fullPath: '/accounting/bills/$billId/edit'
      preLoaderRoute: typeof AuthenticatedAccountingBillsBillIdEditRouteImport
      parentRoute: typeof AuthenticatedAccountingBillsRoute
    }
    '/_authenticated/accounting/cash-sales/$cashSaleId/': {
      id: '/_authenticated/accounting/cash-sales/$cashSaleId/'
      path: '/$cashSaleId'
      fullPath: '/accounting/cash-sales/$cashSaleId/'
      preLoaderRoute: typeof AuthenticatedAccountingCashSalesCashSaleIdIndexRouteImport
      parentRoute: typeof AuthenticatedAccountingCashSalesRoute
    }
    '/_authenticated/accounting/cash-sales/$cashSaleId/edit': {
      id: '/_authenticated/accounting/cash-sales/$cashSaleId/edit'
      path: '/$cashSaleId/edit'
      fullPath: '/accounting/cash-sales/$cashSaleId/edit'
      preLoaderRoute: typeof AuthenticatedAccountingCashSalesCashSaleIdEditRouteImport
      parentRoute: typeof AuthenticatedAccountingCashSalesRoute
    }
    '/_authenticated/accounting/cheques/$chequeId/': {
      id: '/_authenticated/accounting/cheques/$chequeId/'
      path: '/$chequeId'
      fullPath: '/accounting/cheques/$chequeId/'
      preLoaderRoute: typeof AuthenticatedAccountingChequesChequeIdIndexRouteImport
      parentRoute: typeof AuthenticatedAccountingChequesRoute
    }
    '/_authenticated/accounting/invoices/$invoiceId/': {
      id: '/_authenticated/accounting/invoices/$invoiceId/'
      path: '/$invoiceId'
      fullPath: '/accounting/invoices/$invoiceId/'
      preLoaderRoute: typeof AuthenticatedAccountingInvoicesInvoiceIdIndexRouteImport
      parentRoute: typeof AuthenticatedAccountingInvoicesRoute
    }
    '/_authenticated/accounting/invoices/$invoiceId/credit-note': {
      id: '/_authenticated/accounting/invoices/$invoiceId/credit-note'
      path: '/$invoiceId/credit-note'
      fullPath: '/accounting/invoices/$invoiceId/credit-note'
      preLoaderRoute: typeof AuthenticatedAccountingInvoicesInvoiceIdCreditNoteRouteImport
      parentRoute: typeof AuthenticatedAccountingInvoicesRoute
    }
    '/_authenticated/accounting/invoices/$invoiceId/edit': {
      id: '/_authenticated/accounting/invoices/$invoiceId/edit'
      path: '/$invoiceId/edit'
      fullPath: '/accounting/invoices/$invoiceId/edit'
      preLoaderRoute: typeof AuthenticatedAccountingInvoicesInvoiceIdEditRouteImport
      parentRoute: typeof AuthenticatedAccountingInvoicesRoute
    }
    '/_authenticated/accounting/sales-receipts/$cashSaleId/': {
      id: '/_authenticated/accounting/sales-receipts/$cashSaleId/'
      path: '/$cashSaleId'
      fullPath: '/accounting/sales-receipts/$cashSaleId/'
      preLoaderRoute: typeof AuthenticatedAccountingSalesReceiptsCashSaleIdIndexRouteImport
      parentRoute: typeof AuthenticatedAccountingSalesReceiptsRoute
    }
    '/_authenticated/accounting/sales-receipts/$cashSaleId/edit': {
      id: '/_authenticated/accounting/sales-receipts/$cashSaleId/edit'
      path: '/$cashSaleId/edit'
      fullPath: '/accounting/sales-receipts/$cashSaleId/edit'
      preLoaderRoute: typeof AuthenticatedAccountingSalesReceiptsCashSaleIdEditRouteImport
      parentRoute: typeof AuthenticatedAccountingSalesReceiptsRoute
    }
    '/_authenticated/hr/employees/$employeeId/edit': {
      id: '/_authenticated/hr/employees/$employeeId/edit'
      path: '/edit'
      fullPath: '/hr/employees/$employeeId/edit'
      preLoaderRoute: typeof AuthenticatedHrEmployeesEmployeeIdEditRouteImport
      parentRoute: typeof AuthenticatedHrEmployeesEmployeeIdRoute
    }
    '/_authenticated/hr/employees/$employeeId/onboarding': {
      id: '/_authenticated/hr/employees/$employeeId/onboarding'
      path: '/onboarding'
      fullPath: '/hr/employees/$employeeId/onboarding'
      preLoaderRoute: typeof AuthenticatedHrEmployeesEmployeeIdOnboardingRouteImport
      parentRoute: typeof AuthenticatedHrEmployeesEmployeeIdRoute
    }
    '/_authenticated/hr/performance/cycles/$cycleId': {
      id: '/_authenticated/hr/performance/cycles/$cycleId'
      path: '/hr/performance/cycles/$cycleId'
      fullPath: '/hr/performance/cycles/$cycleId'
      preLoaderRoute: typeof AuthenticatedHrPerformanceCyclesCycleIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/performance/reviews/$reviewId': {
      id: '/_authenticated/hr/performance/reviews/$reviewId'
      path: '/hr/performance/reviews/$reviewId'
      fullPath: '/hr/performance/reviews/$reviewId'
      preLoaderRoute: typeof AuthenticatedHrPerformanceReviewsReviewIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inventory/counts/$sessionId/': {
      id: '/_authenticated/inventory/counts/$sessionId/'
      path: '/inventory/counts/$sessionId'
      fullPath: '/inventory/counts/$sessionId/'
      preLoaderRoute: typeof AuthenticatedInventoryCountsSessionIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inventory/counts/$sessionId/review': {
      id: '/_authenticated/inventory/counts/$sessionId/review'
      path: '/inventory/counts/$sessionId/review'
      fullPath: '/inventory/counts/$sessionId/review'
      preLoaderRoute: typeof AuthenticatedInventoryCountsSessionIdReviewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inventory/reports/insights/$report': {
      id: '/_authenticated/inventory/reports/insights/$report'
      path: '/inventory/reports/insights/$report'
      fullPath: '/inventory/reports/insights/$report'
      preLoaderRoute: typeof AuthenticatedInventoryReportsInsightsReportRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/purchasing/landed-costs/$landedCostId/': {
      id: '/_authenticated/purchasing/landed-costs/$landedCostId/'
      path: '/$landedCostId'
      fullPath: '/purchasing/landed-costs/$landedCostId/'
      preLoaderRoute: typeof AuthenticatedPurchasingLandedCostsLandedCostIdIndexRouteImport
      parentRoute: typeof AuthenticatedPurchasingLandedCostsRoute
    }
    '/_authenticated/purchasing/orders/$orderId/': {
      id: '/_authenticated/purchasing/orders/$orderId/'
      path: '/$orderId'
      fullPath: '/purchasing/orders/$orderId/'
      preLoaderRoute: typeof AuthenticatedPurchasingOrdersOrderIdIndexRouteImport
      parentRoute: typeof AuthenticatedPurchasingOrdersRoute
    }
    '/_authenticated/purchasing/orders/$orderId/edit': {
      id: '/_authenticated/purchasing/orders/$orderId/edit'
      path: '/$orderId/edit'
      fullPath: '/purchasing/orders/$orderId/edit'
      preLoaderRoute: typeof AuthenticatedPurchasingOrdersOrderIdEditRouteImport
      parentRoute: typeof AuthenticatedPurchasingOrdersRoute
    }
    '/_authenticated/purchasing/orders/$orderId/receive': {
      id: '/_authenticated/purchasing/orders/$orderId/receive'
      path: '/$orderId/receive'
      fullPath: '/purchasing/orders/$orderId/receive'
      preLoaderRoute: typeof AuthenticatedPurchasingOrdersOrderIdReceiveRouteImport
      parentRoute: typeof AuthenticatedPurchasingOrdersRoute
    }
    '/_authenticated/purchasing/receipts/$receiptId/': {
      id: '/_authenticated/purchasing/receipts/$receiptId/'
      path: '/$receiptId'
      fullPath: '/purchasing/receipts/$receiptId/'
      preLoaderRoute: typeof AuthenticatedPurchasingReceiptsReceiptIdIndexRouteImport
      parentRoute: typeof AuthenticatedPurchasingReceiptsRoute
    }
    '/_authenticated/purchasing/returns/$returnId/': {
      id: '/_authenticated/purchasing/returns/$returnId/'
      path: '/$returnId'
      fullPath: '/purchasing/returns/$returnId/'
      preLoaderRoute: typeof AuthenticatedPurchasingReturnsReturnIdIndexRouteImport
      parentRoute: typeof AuthenticatedPurchasingReturnsRoute
    }
    '/_authenticated/sales/orders/$orderId/': {
      id: '/_authenticated/sales/orders/$orderId/'
      path: '/$orderId'
      fullPath: '/sales/orders/$orderId/'
      preLoaderRoute: typeof AuthenticatedSalesOrdersOrderIdIndexRouteImport
      parentRoute: typeof AuthenticatedSalesOrdersRoute
    }
    '/_authenticated/sales/orders/$orderId/edit': {
      id: '/_authenticated/sales/orders/$orderId/edit'
      path: '/$orderId/edit'
      fullPath: '/sales/orders/$orderId/edit'
      preLoaderRoute: typeof AuthenticatedSalesOrdersOrderIdEditRouteImport
      parentRoute: typeof AuthenticatedSalesOrdersRoute
    }
    '/_authenticated/sales/returns/$returnId/': {
      id: '/_authenticated/sales/returns/$returnId/'
      path: '/$returnId'
      fullPath: '/sales/returns/$returnId/'
      preLoaderRoute: typeof AuthenticatedSalesReturnsReturnIdIndexRouteImport
      parentRoute: typeof AuthenticatedSalesReturnsRoute
    }
    '/_authenticated/accounting/bank-accounts/$accountId/reconcile/$reconciliationId': {
      id: '/_authenticated/accounting/bank-accounts/$accountId/reconcile/$reconciliationId'
      path: '/bank-accounts/$accountId/reconcile/$reconciliationId'
      fullPath: '/accounting/bank-accounts/$accountId/reconcile/$reconciliationId'
      preLoaderRoute: typeof AuthenticatedAccountingBankAccountsAccountIdReconcileReconciliationIdRouteImport
      parentRoute: typeof AuthenticatedAccountingRoute
    }
  }
}

interface AuthenticatedAccountRouteChildren {
  AuthenticatedAccountNotificationsRoute: typeof AuthenticatedAccountNotificationsRoute
  AuthenticatedAccountSecurityRoute: typeof AuthenticatedAccountSecurityRoute
  AuthenticatedAccountIndexRoute: typeof AuthenticatedAccountIndexRoute
}

const AuthenticatedAccountRouteChildren: AuthenticatedAccountRouteChildren = {
  AuthenticatedAccountNotificationsRoute:
    AuthenticatedAccountNotificationsRoute,
  AuthenticatedAccountSecurityRoute: AuthenticatedAccountSecurityRoute,
  AuthenticatedAccountIndexRoute: AuthenticatedAccountIndexRoute,
}

const AuthenticatedAccountRouteWithChildren =
  AuthenticatedAccountRoute._addFileChildren(AuthenticatedAccountRouteChildren)

interface AuthenticatedAccountingAssetsRouteChildren {
  AuthenticatedAccountingAssetsAssetIdRoute: typeof AuthenticatedAccountingAssetsAssetIdRoute
  AuthenticatedAccountingAssetsDepreciationRoute: typeof AuthenticatedAccountingAssetsDepreciationRoute
}

const AuthenticatedAccountingAssetsRouteChildren: AuthenticatedAccountingAssetsRouteChildren =
  {
    AuthenticatedAccountingAssetsAssetIdRoute:
      AuthenticatedAccountingAssetsAssetIdRoute,
    AuthenticatedAccountingAssetsDepreciationRoute:
      AuthenticatedAccountingAssetsDepreciationRoute,
  }

const AuthenticatedAccountingAssetsRouteWithChildren =
  AuthenticatedAccountingAssetsRoute._addFileChildren(
    AuthenticatedAccountingAssetsRouteChildren,
  )

interface AuthenticatedAccountingBillsRouteChildren {
  AuthenticatedAccountingBillsNewRoute: typeof AuthenticatedAccountingBillsNewRoute
  AuthenticatedAccountingBillsPayRoute: typeof AuthenticatedAccountingBillsPayRoute
  AuthenticatedAccountingBillsBillIdDebitNoteRoute: typeof AuthenticatedAccountingBillsBillIdDebitNoteRoute
  AuthenticatedAccountingBillsBillIdEditRoute: typeof AuthenticatedAccountingBillsBillIdEditRoute
  AuthenticatedAccountingBillsBillIdIndexRoute: typeof AuthenticatedAccountingBillsBillIdIndexRoute
}

const AuthenticatedAccountingBillsRouteChildren: AuthenticatedAccountingBillsRouteChildren =
  {
    AuthenticatedAccountingBillsNewRoute: AuthenticatedAccountingBillsNewRoute,
    AuthenticatedAccountingBillsPayRoute: AuthenticatedAccountingBillsPayRoute,
    AuthenticatedAccountingBillsBillIdDebitNoteRoute:
      AuthenticatedAccountingBillsBillIdDebitNoteRoute,
    AuthenticatedAccountingBillsBillIdEditRoute:
      AuthenticatedAccountingBillsBillIdEditRoute,
    AuthenticatedAccountingBillsBillIdIndexRoute:
      AuthenticatedAccountingBillsBillIdIndexRoute,
  }

const AuthenticatedAccountingBillsRouteWithChildren =
  AuthenticatedAccountingBillsRoute._addFileChildren(
    AuthenticatedAccountingBillsRouteChildren,
  )

interface AuthenticatedAccountingBudgetsRouteChildren {
  AuthenticatedAccountingBudgetsBudgetIdRoute: typeof AuthenticatedAccountingBudgetsBudgetIdRoute
  AuthenticatedAccountingBudgetsNewRoute: typeof AuthenticatedAccountingBudgetsNewRoute
}

const AuthenticatedAccountingBudgetsRouteChildren: AuthenticatedAccountingBudgetsRouteChildren =
  {
    AuthenticatedAccountingBudgetsBudgetIdRoute:
      AuthenticatedAccountingBudgetsBudgetIdRoute,
    AuthenticatedAccountingBudgetsNewRoute:
      AuthenticatedAccountingBudgetsNewRoute,
  }

const AuthenticatedAccountingBudgetsRouteWithChildren =
  AuthenticatedAccountingBudgetsRoute._addFileChildren(
    AuthenticatedAccountingBudgetsRouteChildren,
  )

interface AuthenticatedAccountingCashSalesRouteChildren {
  AuthenticatedAccountingCashSalesNewRoute: typeof AuthenticatedAccountingCashSalesNewRoute
  AuthenticatedAccountingCashSalesCashSaleIdEditRoute: typeof AuthenticatedAccountingCashSalesCashSaleIdEditRoute
  AuthenticatedAccountingCashSalesCashSaleIdIndexRoute: typeof AuthenticatedAccountingCashSalesCashSaleIdIndexRoute
}

const AuthenticatedAccountingCashSalesRouteChildren: AuthenticatedAccountingCashSalesRouteChildren =
  {
    AuthenticatedAccountingCashSalesNewRoute:
      AuthenticatedAccountingCashSalesNewRoute,
    AuthenticatedAccountingCashSalesCashSaleIdEditRoute:
      AuthenticatedAccountingCashSalesCashSaleIdEditRoute,
    AuthenticatedAccountingCashSalesCashSaleIdIndexRoute:
      AuthenticatedAccountingCashSalesCashSaleIdIndexRoute,
  }

const AuthenticatedAccountingCashSalesRouteWithChildren =
  AuthenticatedAccountingCashSalesRoute._addFileChildren(
    AuthenticatedAccountingCashSalesRouteChildren,
  )

interface AuthenticatedAccountingChequesRouteChildren {
  AuthenticatedAccountingChequesOutstandingRoute: typeof AuthenticatedAccountingChequesOutstandingRoute
  AuthenticatedAccountingChequesChequeIdIndexRoute: typeof AuthenticatedAccountingChequesChequeIdIndexRoute
}

const AuthenticatedAccountingChequesRouteChildren: AuthenticatedAccountingChequesRouteChildren =
  {
    AuthenticatedAccountingChequesOutstandingRoute:
      AuthenticatedAccountingChequesOutstandingRoute,
    AuthenticatedAccountingChequesChequeIdIndexRoute:
      AuthenticatedAccountingChequesChequeIdIndexRoute,
  }

const AuthenticatedAccountingChequesRouteWithChildren =
  AuthenticatedAccountingChequesRoute._addFileChildren(
    AuthenticatedAccountingChequesRouteChildren,
  )

interface AuthenticatedAccountingCreditNotesRouteChildren {
  AuthenticatedAccountingCreditNotesNewRoute: typeof AuthenticatedAccountingCreditNotesNewRoute
}

const AuthenticatedAccountingCreditNotesRouteChildren: AuthenticatedAccountingCreditNotesRouteChildren =
  {
    AuthenticatedAccountingCreditNotesNewRoute:
      AuthenticatedAccountingCreditNotesNewRoute,
  }

const AuthenticatedAccountingCreditNotesRouteWithChildren =
  AuthenticatedAccountingCreditNotesRoute._addFileChildren(
    AuthenticatedAccountingCreditNotesRouteChildren,
  )

interface AuthenticatedAccountingInvoicesRouteChildren {
  AuthenticatedAccountingInvoicesNewRoute: typeof AuthenticatedAccountingInvoicesNewRoute
  AuthenticatedAccountingInvoicesInvoiceIdCreditNoteRoute: typeof AuthenticatedAccountingInvoicesInvoiceIdCreditNoteRoute
  AuthenticatedAccountingInvoicesInvoiceIdEditRoute: typeof AuthenticatedAccountingInvoicesInvoiceIdEditRoute
  AuthenticatedAccountingInvoicesInvoiceIdIndexRoute: typeof AuthenticatedAccountingInvoicesInvoiceIdIndexRoute
}

const AuthenticatedAccountingInvoicesRouteChildren: AuthenticatedAccountingInvoicesRouteChildren =
  {
    AuthenticatedAccountingInvoicesNewRoute:
      AuthenticatedAccountingInvoicesNewRoute,
    AuthenticatedAccountingInvoicesInvoiceIdCreditNoteRoute:
      AuthenticatedAccountingInvoicesInvoiceIdCreditNoteRoute,
    AuthenticatedAccountingInvoicesInvoiceIdEditRoute:
      AuthenticatedAccountingInvoicesInvoiceIdEditRoute,
    AuthenticatedAccountingInvoicesInvoiceIdIndexRoute:
      AuthenticatedAccountingInvoicesInvoiceIdIndexRoute,
  }

const AuthenticatedAccountingInvoicesRouteWithChildren =
  AuthenticatedAccountingInvoicesRoute._addFileChildren(
    AuthenticatedAccountingInvoicesRouteChildren,
  )

interface AuthenticatedAccountingJournalRouteChildren {
  AuthenticatedAccountingJournalEntryIdRoute: typeof AuthenticatedAccountingJournalEntryIdRoute
  AuthenticatedAccountingJournalNewRoute: typeof AuthenticatedAccountingJournalNewRoute
}

const AuthenticatedAccountingJournalRouteChildren: AuthenticatedAccountingJournalRouteChildren =
  {
    AuthenticatedAccountingJournalEntryIdRoute:
      AuthenticatedAccountingJournalEntryIdRoute,
    AuthenticatedAccountingJournalNewRoute:
      AuthenticatedAccountingJournalNewRoute,
  }

const AuthenticatedAccountingJournalRouteWithChildren =
  AuthenticatedAccountingJournalRoute._addFileChildren(
    AuthenticatedAccountingJournalRouteChildren,
  )

interface AuthenticatedAccountingPaymentsRouteChildren {
  AuthenticatedAccountingPaymentsPaymentIdRoute: typeof AuthenticatedAccountingPaymentsPaymentIdRoute
  AuthenticatedAccountingPaymentsNewRoute: typeof AuthenticatedAccountingPaymentsNewRoute
}

const AuthenticatedAccountingPaymentsRouteChildren: AuthenticatedAccountingPaymentsRouteChildren =
  {
    AuthenticatedAccountingPaymentsPaymentIdRoute:
      AuthenticatedAccountingPaymentsPaymentIdRoute,
    AuthenticatedAccountingPaymentsNewRoute:
      AuthenticatedAccountingPaymentsNewRoute,
  }

const AuthenticatedAccountingPaymentsRouteWithChildren =
  AuthenticatedAccountingPaymentsRoute._addFileChildren(
    AuthenticatedAccountingPaymentsRouteChildren,
  )

interface AuthenticatedAccountingReconciliationRouteChildren {
  AuthenticatedAccountingReconciliationStatementIdRoute: typeof AuthenticatedAccountingReconciliationStatementIdRoute
}

const AuthenticatedAccountingReconciliationRouteChildren: AuthenticatedAccountingReconciliationRouteChildren =
  {
    AuthenticatedAccountingReconciliationStatementIdRoute:
      AuthenticatedAccountingReconciliationStatementIdRoute,
  }

const AuthenticatedAccountingReconciliationRouteWithChildren =
  AuthenticatedAccountingReconciliationRoute._addFileChildren(
    AuthenticatedAccountingReconciliationRouteChildren,
  )

interface AuthenticatedAccountingSalesReceiptsRouteChildren {
  AuthenticatedAccountingSalesReceiptsNewRoute: typeof AuthenticatedAccountingSalesReceiptsNewRoute
  AuthenticatedAccountingSalesReceiptsCashSaleIdEditRoute: typeof AuthenticatedAccountingSalesReceiptsCashSaleIdEditRoute
  AuthenticatedAccountingSalesReceiptsCashSaleIdIndexRoute: typeof AuthenticatedAccountingSalesReceiptsCashSaleIdIndexRoute
}

const AuthenticatedAccountingSalesReceiptsRouteChildren: AuthenticatedAccountingSalesReceiptsRouteChildren =
  {
    AuthenticatedAccountingSalesReceiptsNewRoute:
      AuthenticatedAccountingSalesReceiptsNewRoute,
    AuthenticatedAccountingSalesReceiptsCashSaleIdEditRoute:
      AuthenticatedAccountingSalesReceiptsCashSaleIdEditRoute,
    AuthenticatedAccountingSalesReceiptsCashSaleIdIndexRoute:
      AuthenticatedAccountingSalesReceiptsCashSaleIdIndexRoute,
  }

const AuthenticatedAccountingSalesReceiptsRouteWithChildren =
  AuthenticatedAccountingSalesReceiptsRoute._addFileChildren(
    AuthenticatedAccountingSalesReceiptsRouteChildren,
  )

interface AuthenticatedAccountingRouteChildren {
  AuthenticatedAccountingAnalysisTagsRoute: typeof AuthenticatedAccountingAnalysisTagsRoute
  AuthenticatedAccountingAssetsRoute: typeof AuthenticatedAccountingAssetsRouteWithChildren
  AuthenticatedAccountingBankRulesRoute: typeof AuthenticatedAccountingBankRulesRoute
  AuthenticatedAccountingBankTransactionsRoute: typeof AuthenticatedAccountingBankTransactionsRoute
  AuthenticatedAccountingBillsRoute: typeof AuthenticatedAccountingBillsRouteWithChildren
  AuthenticatedAccountingBudgetsRoute: typeof AuthenticatedAccountingBudgetsRouteWithChildren
  AuthenticatedAccountingCashSalesRoute: typeof AuthenticatedAccountingCashSalesRouteWithChildren
  AuthenticatedAccountingChartRoute: typeof AuthenticatedAccountingChartRoute
  AuthenticatedAccountingChequesRoute: typeof AuthenticatedAccountingChequesRouteWithChildren
  AuthenticatedAccountingCloseRoute: typeof AuthenticatedAccountingCloseRoute
  AuthenticatedAccountingCostCentersRoute: typeof AuthenticatedAccountingCostCentersRoute
  AuthenticatedAccountingCreditNotesRoute: typeof AuthenticatedAccountingCreditNotesRouteWithChildren
  AuthenticatedAccountingInvoicesRoute: typeof AuthenticatedAccountingInvoicesRouteWithChildren
  AuthenticatedAccountingJournalRoute: typeof AuthenticatedAccountingJournalRouteWithChildren
  AuthenticatedAccountingJournalsRoute: typeof AuthenticatedAccountingJournalsRoute
  AuthenticatedAccountingPaymentTermsRoute: typeof AuthenticatedAccountingPaymentTermsRoute
  AuthenticatedAccountingPaymentsRoute: typeof AuthenticatedAccountingPaymentsRouteWithChildren
  AuthenticatedAccountingPeriodsRoute: typeof AuthenticatedAccountingPeriodsRoute
  AuthenticatedAccountingPostingIntentsRoute: typeof AuthenticatedAccountingPostingIntentsRoute
  AuthenticatedAccountingPrepaidRoute: typeof AuthenticatedAccountingPrepaidRoute
  AuthenticatedAccountingReconciliationRoute: typeof AuthenticatedAccountingReconciliationRouteWithChildren
  AuthenticatedAccountingRecurringRoute: typeof AuthenticatedAccountingRecurringRoute
  AuthenticatedAccountingSalesReceiptsRoute: typeof AuthenticatedAccountingSalesReceiptsRouteWithChildren
  AuthenticatedAccountingSettingsRoute: typeof AuthenticatedAccountingSettingsRoute
  AuthenticatedAccountingStatementsRoute: typeof AuthenticatedAccountingStatementsRoute
  AuthenticatedAccountingTaxRoute: typeof AuthenticatedAccountingTaxRoute
  AuthenticatedAccountingTrialBalanceRoute: typeof AuthenticatedAccountingTrialBalanceRoute
  AuthenticatedAccountingWorkingCapitalRoute: typeof AuthenticatedAccountingWorkingCapitalRoute
  AuthenticatedAccountingIndexRoute: typeof AuthenticatedAccountingIndexRoute
  AuthenticatedAccountingCardCreditsNewRoute: typeof AuthenticatedAccountingCardCreditsNewRoute
  AuthenticatedAccountingDepositsDepositIdRoute: typeof AuthenticatedAccountingDepositsDepositIdRoute
  AuthenticatedAccountingDepositsNewRoute: typeof AuthenticatedAccountingDepositsNewRoute
  AuthenticatedAccountingExpensesDocumentIdRoute: typeof AuthenticatedAccountingExpensesDocumentIdRoute
  AuthenticatedAccountingExpensesNewRoute: typeof AuthenticatedAccountingExpensesNewRoute
  AuthenticatedAccountingOpeningBalancesBatchIdRoute: typeof AuthenticatedAccountingOpeningBalancesBatchIdRoute
  AuthenticatedAccountingReconcileReconciliationIdRoute: typeof AuthenticatedAccountingReconcileReconciliationIdRoute
  AuthenticatedAccountingRefundsNewRoute: typeof AuthenticatedAccountingRefundsNewRoute
  AuthenticatedAccountingReportsReportTokenRoute: typeof AuthenticatedAccountingReportsReportTokenRoute
  AuthenticatedAccountingReportsAgingRoute: typeof AuthenticatedAccountingReportsAgingRoute
  AuthenticatedAccountingReportsBalanceSheetRoute: typeof AuthenticatedAccountingReportsBalanceSheetRoute
  AuthenticatedAccountingReportsCashFlowRoute: typeof AuthenticatedAccountingReportsCashFlowRoute
  AuthenticatedAccountingReportsCashPositionRoute: typeof AuthenticatedAccountingReportsCashPositionRoute
  AuthenticatedAccountingReportsCostByNameRoute: typeof AuthenticatedAccountingReportsCostByNameRoute
  AuthenticatedAccountingReportsGeneralLedgerRoute: typeof AuthenticatedAccountingReportsGeneralLedgerRoute
  AuthenticatedAccountingReportsMonthlyStatementsRoute: typeof AuthenticatedAccountingReportsMonthlyStatementsRoute
  AuthenticatedAccountingReportsProfitAndLossRoute: typeof AuthenticatedAccountingReportsProfitAndLossRoute
  AuthenticatedAccountingReportsTaxRoute: typeof AuthenticatedAccountingReportsTaxRoute
  AuthenticatedAccountingSpendDocumentIdRoute: typeof AuthenticatedAccountingSpendDocumentIdRoute
  AuthenticatedAccountingSpendNewRoute: typeof AuthenticatedAccountingSpendNewRoute
  AuthenticatedAccountingSupplierCreditsNewRoute: typeof AuthenticatedAccountingSupplierCreditsNewRoute
  AuthenticatedAccountingSupplierStatementSupplierIdRoute: typeof AuthenticatedAccountingSupplierStatementSupplierIdRoute
  AuthenticatedAccountingTransfersNewRoute: typeof AuthenticatedAccountingTransfersNewRoute
  AuthenticatedAccountingBankAccountsIndexRoute: typeof AuthenticatedAccountingBankAccountsIndexRoute
  AuthenticatedAccountingDepositsIndexRoute: typeof AuthenticatedAccountingDepositsIndexRoute
  AuthenticatedAccountingExpensesIndexRoute: typeof AuthenticatedAccountingExpensesIndexRoute
  AuthenticatedAccountingOpeningBalancesIndexRoute: typeof AuthenticatedAccountingOpeningBalancesIndexRoute
  AuthenticatedAccountingReconcileIndexRoute: typeof AuthenticatedAccountingReconcileIndexRoute
  AuthenticatedAccountingReportsIndexRoute: typeof AuthenticatedAccountingReportsIndexRoute
  AuthenticatedAccountingSalesIndexRoute: typeof AuthenticatedAccountingSalesIndexRoute
  AuthenticatedAccountingSpendIndexRoute: typeof AuthenticatedAccountingSpendIndexRoute
  AuthenticatedAccountingAccountsAccountIdRegisterRoute: typeof AuthenticatedAccountingAccountsAccountIdRegisterRoute
  AuthenticatedAccountingBankAccountsAccountIdIndexRoute: typeof AuthenticatedAccountingBankAccountsAccountIdIndexRoute
  AuthenticatedAccountingBankAccountsAccountIdReconcileReconciliationIdRoute: typeof AuthenticatedAccountingBankAccountsAccountIdReconcileReconciliationIdRoute
}

const AuthenticatedAccountingRouteChildren: AuthenticatedAccountingRouteChildren =
  {
    AuthenticatedAccountingAnalysisTagsRoute:
      AuthenticatedAccountingAnalysisTagsRoute,
    AuthenticatedAccountingAssetsRoute:
      AuthenticatedAccountingAssetsRouteWithChildren,
    AuthenticatedAccountingBankRulesRoute:
      AuthenticatedAccountingBankRulesRoute,
    AuthenticatedAccountingBankTransactionsRoute:
      AuthenticatedAccountingBankTransactionsRoute,
    AuthenticatedAccountingBillsRoute:
      AuthenticatedAccountingBillsRouteWithChildren,
    AuthenticatedAccountingBudgetsRoute:
      AuthenticatedAccountingBudgetsRouteWithChildren,
    AuthenticatedAccountingCashSalesRoute:
      AuthenticatedAccountingCashSalesRouteWithChildren,
    AuthenticatedAccountingChartRoute: AuthenticatedAccountingChartRoute,
    AuthenticatedAccountingChequesRoute:
      AuthenticatedAccountingChequesRouteWithChildren,
    AuthenticatedAccountingCloseRoute: AuthenticatedAccountingCloseRoute,
    AuthenticatedAccountingCostCentersRoute:
      AuthenticatedAccountingCostCentersRoute,
    AuthenticatedAccountingCreditNotesRoute:
      AuthenticatedAccountingCreditNotesRouteWithChildren,
    AuthenticatedAccountingInvoicesRoute:
      AuthenticatedAccountingInvoicesRouteWithChildren,
    AuthenticatedAccountingJournalRoute:
      AuthenticatedAccountingJournalRouteWithChildren,
    AuthenticatedAccountingJournalsRoute: AuthenticatedAccountingJournalsRoute,
    AuthenticatedAccountingPaymentTermsRoute:
      AuthenticatedAccountingPaymentTermsRoute,
    AuthenticatedAccountingPaymentsRoute:
      AuthenticatedAccountingPaymentsRouteWithChildren,
    AuthenticatedAccountingPeriodsRoute: AuthenticatedAccountingPeriodsRoute,
    AuthenticatedAccountingPostingIntentsRoute:
      AuthenticatedAccountingPostingIntentsRoute,
    AuthenticatedAccountingPrepaidRoute: AuthenticatedAccountingPrepaidRoute,
    AuthenticatedAccountingReconciliationRoute:
      AuthenticatedAccountingReconciliationRouteWithChildren,
    AuthenticatedAccountingRecurringRoute:
      AuthenticatedAccountingRecurringRoute,
    AuthenticatedAccountingSalesReceiptsRoute:
      AuthenticatedAccountingSalesReceiptsRouteWithChildren,
    AuthenticatedAccountingSettingsRoute: AuthenticatedAccountingSettingsRoute,
    AuthenticatedAccountingStatementsRoute:
      AuthenticatedAccountingStatementsRoute,
    AuthenticatedAccountingTaxRoute: AuthenticatedAccountingTaxRoute,
    AuthenticatedAccountingTrialBalanceRoute:
      AuthenticatedAccountingTrialBalanceRoute,
    AuthenticatedAccountingWorkingCapitalRoute:
      AuthenticatedAccountingWorkingCapitalRoute,
    AuthenticatedAccountingIndexRoute: AuthenticatedAccountingIndexRoute,
    AuthenticatedAccountingCardCreditsNewRoute:
      AuthenticatedAccountingCardCreditsNewRoute,
    AuthenticatedAccountingDepositsDepositIdRoute:
      AuthenticatedAccountingDepositsDepositIdRoute,
    AuthenticatedAccountingDepositsNewRoute:
      AuthenticatedAccountingDepositsNewRoute,
    AuthenticatedAccountingExpensesDocumentIdRoute:
      AuthenticatedAccountingExpensesDocumentIdRoute,
    AuthenticatedAccountingExpensesNewRoute:
      AuthenticatedAccountingExpensesNewRoute,
    AuthenticatedAccountingOpeningBalancesBatchIdRoute:
      AuthenticatedAccountingOpeningBalancesBatchIdRoute,
    AuthenticatedAccountingReconcileReconciliationIdRoute:
      AuthenticatedAccountingReconcileReconciliationIdRoute,
    AuthenticatedAccountingRefundsNewRoute:
      AuthenticatedAccountingRefundsNewRoute,
    AuthenticatedAccountingReportsReportTokenRoute:
      AuthenticatedAccountingReportsReportTokenRoute,
    AuthenticatedAccountingReportsAgingRoute:
      AuthenticatedAccountingReportsAgingRoute,
    AuthenticatedAccountingReportsBalanceSheetRoute:
      AuthenticatedAccountingReportsBalanceSheetRoute,
    AuthenticatedAccountingReportsCashFlowRoute:
      AuthenticatedAccountingReportsCashFlowRoute,
    AuthenticatedAccountingReportsCashPositionRoute:
      AuthenticatedAccountingReportsCashPositionRoute,
    AuthenticatedAccountingReportsCostByNameRoute:
      AuthenticatedAccountingReportsCostByNameRoute,
    AuthenticatedAccountingReportsGeneralLedgerRoute:
      AuthenticatedAccountingReportsGeneralLedgerRoute,
    AuthenticatedAccountingReportsMonthlyStatementsRoute:
      AuthenticatedAccountingReportsMonthlyStatementsRoute,
    AuthenticatedAccountingReportsProfitAndLossRoute:
      AuthenticatedAccountingReportsProfitAndLossRoute,
    AuthenticatedAccountingReportsTaxRoute:
      AuthenticatedAccountingReportsTaxRoute,
    AuthenticatedAccountingSpendDocumentIdRoute:
      AuthenticatedAccountingSpendDocumentIdRoute,
    AuthenticatedAccountingSpendNewRoute: AuthenticatedAccountingSpendNewRoute,
    AuthenticatedAccountingSupplierCreditsNewRoute:
      AuthenticatedAccountingSupplierCreditsNewRoute,
    AuthenticatedAccountingSupplierStatementSupplierIdRoute:
      AuthenticatedAccountingSupplierStatementSupplierIdRoute,
    AuthenticatedAccountingTransfersNewRoute:
      AuthenticatedAccountingTransfersNewRoute,
    AuthenticatedAccountingBankAccountsIndexRoute:
      AuthenticatedAccountingBankAccountsIndexRoute,
    AuthenticatedAccountingDepositsIndexRoute:
      AuthenticatedAccountingDepositsIndexRoute,
    AuthenticatedAccountingExpensesIndexRoute:
      AuthenticatedAccountingExpensesIndexRoute,
    AuthenticatedAccountingOpeningBalancesIndexRoute:
      AuthenticatedAccountingOpeningBalancesIndexRoute,
    AuthenticatedAccountingReconcileIndexRoute:
      AuthenticatedAccountingReconcileIndexRoute,
    AuthenticatedAccountingReportsIndexRoute:
      AuthenticatedAccountingReportsIndexRoute,
    AuthenticatedAccountingSalesIndexRoute:
      AuthenticatedAccountingSalesIndexRoute,
    AuthenticatedAccountingSpendIndexRoute:
      AuthenticatedAccountingSpendIndexRoute,
    AuthenticatedAccountingAccountsAccountIdRegisterRoute:
      AuthenticatedAccountingAccountsAccountIdRegisterRoute,
    AuthenticatedAccountingBankAccountsAccountIdIndexRoute:
      AuthenticatedAccountingBankAccountsAccountIdIndexRoute,
    AuthenticatedAccountingBankAccountsAccountIdReconcileReconciliationIdRoute:
      AuthenticatedAccountingBankAccountsAccountIdReconcileReconciliationIdRoute,
  }

const AuthenticatedAccountingRouteWithChildren =
  AuthenticatedAccountingRoute._addFileChildren(
    AuthenticatedAccountingRouteChildren,
  )

interface AuthenticatedPayrollPayslipsRouteChildren {
  AuthenticatedPayrollPayslipsPayslipIdRoute: typeof AuthenticatedPayrollPayslipsPayslipIdRoute
}

const AuthenticatedPayrollPayslipsRouteChildren: AuthenticatedPayrollPayslipsRouteChildren =
  {
    AuthenticatedPayrollPayslipsPayslipIdRoute:
      AuthenticatedPayrollPayslipsPayslipIdRoute,
  }

const AuthenticatedPayrollPayslipsRouteWithChildren =
  AuthenticatedPayrollPayslipsRoute._addFileChildren(
    AuthenticatedPayrollPayslipsRouteChildren,
  )

interface AuthenticatedPayrollRunsRouteChildren {
  AuthenticatedPayrollRunsRunIdRoute: typeof AuthenticatedPayrollRunsRunIdRoute
}

const AuthenticatedPayrollRunsRouteChildren: AuthenticatedPayrollRunsRouteChildren =
  {
    AuthenticatedPayrollRunsRunIdRoute: AuthenticatedPayrollRunsRunIdRoute,
  }

const AuthenticatedPayrollRunsRouteWithChildren =
  AuthenticatedPayrollRunsRoute._addFileChildren(
    AuthenticatedPayrollRunsRouteChildren,
  )

interface AuthenticatedPayrollRouteChildren {
  AuthenticatedPayrollAdvancesRoute: typeof AuthenticatedPayrollAdvancesRoute
  AuthenticatedPayrollBulkAssignRoute: typeof AuthenticatedPayrollBulkAssignRoute
  AuthenticatedPayrollComponentsRoute: typeof AuthenticatedPayrollComponentsRoute
  AuthenticatedPayrollPayslipsRoute: typeof AuthenticatedPayrollPayslipsRouteWithChildren
  AuthenticatedPayrollRunsRoute: typeof AuthenticatedPayrollRunsRouteWithChildren
  AuthenticatedPayrollSettingsRoute: typeof AuthenticatedPayrollSettingsRoute
  AuthenticatedPayrollSettlementsRunIdRoute: typeof AuthenticatedPayrollSettlementsRunIdRoute
}

const AuthenticatedPayrollRouteChildren: AuthenticatedPayrollRouteChildren = {
  AuthenticatedPayrollAdvancesRoute: AuthenticatedPayrollAdvancesRoute,
  AuthenticatedPayrollBulkAssignRoute: AuthenticatedPayrollBulkAssignRoute,
  AuthenticatedPayrollComponentsRoute: AuthenticatedPayrollComponentsRoute,
  AuthenticatedPayrollPayslipsRoute:
    AuthenticatedPayrollPayslipsRouteWithChildren,
  AuthenticatedPayrollRunsRoute: AuthenticatedPayrollRunsRouteWithChildren,
  AuthenticatedPayrollSettingsRoute: AuthenticatedPayrollSettingsRoute,
  AuthenticatedPayrollSettlementsRunIdRoute:
    AuthenticatedPayrollSettlementsRunIdRoute,
}

const AuthenticatedPayrollRouteWithChildren =
  AuthenticatedPayrollRoute._addFileChildren(AuthenticatedPayrollRouteChildren)

interface AuthenticatedRolesRouteChildren {
  AuthenticatedRolesRoleIdRoute: typeof AuthenticatedRolesRoleIdRoute
  AuthenticatedRolesNewRoute: typeof AuthenticatedRolesNewRoute
  AuthenticatedRolesIndexRoute: typeof AuthenticatedRolesIndexRoute
}

const AuthenticatedRolesRouteChildren: AuthenticatedRolesRouteChildren = {
  AuthenticatedRolesRoleIdRoute: AuthenticatedRolesRoleIdRoute,
  AuthenticatedRolesNewRoute: AuthenticatedRolesNewRoute,
  AuthenticatedRolesIndexRoute: AuthenticatedRolesIndexRoute,
}

const AuthenticatedRolesRouteWithChildren =
  AuthenticatedRolesRoute._addFileChildren(AuthenticatedRolesRouteChildren)

interface AuthenticatedHrAssetsRouteChildren {
  AuthenticatedHrAssetsAssetIdRoute: typeof AuthenticatedHrAssetsAssetIdRoute
}

const AuthenticatedHrAssetsRouteChildren: AuthenticatedHrAssetsRouteChildren = {
  AuthenticatedHrAssetsAssetIdRoute: AuthenticatedHrAssetsAssetIdRoute,
}

const AuthenticatedHrAssetsRouteWithChildren =
  AuthenticatedHrAssetsRoute._addFileChildren(
    AuthenticatedHrAssetsRouteChildren,
  )

interface AuthenticatedHrAttendanceCorrectionsRouteChildren {
  AuthenticatedHrAttendanceCorrectionsRequestIdRoute: typeof AuthenticatedHrAttendanceCorrectionsRequestIdRoute
}

const AuthenticatedHrAttendanceCorrectionsRouteChildren: AuthenticatedHrAttendanceCorrectionsRouteChildren =
  {
    AuthenticatedHrAttendanceCorrectionsRequestIdRoute:
      AuthenticatedHrAttendanceCorrectionsRequestIdRoute,
  }

const AuthenticatedHrAttendanceCorrectionsRouteWithChildren =
  AuthenticatedHrAttendanceCorrectionsRoute._addFileChildren(
    AuthenticatedHrAttendanceCorrectionsRouteChildren,
  )

interface AuthenticatedHrCashCustodyRouteChildren {
  AuthenticatedHrCashCustodyCustodyIdRoute: typeof AuthenticatedHrCashCustodyCustodyIdRoute
}

const AuthenticatedHrCashCustodyRouteChildren: AuthenticatedHrCashCustodyRouteChildren =
  {
    AuthenticatedHrCashCustodyCustodyIdRoute:
      AuthenticatedHrCashCustodyCustodyIdRoute,
  }

const AuthenticatedHrCashCustodyRouteWithChildren =
  AuthenticatedHrCashCustodyRoute._addFileChildren(
    AuthenticatedHrCashCustodyRouteChildren,
  )

interface AuthenticatedHrExpensesRouteChildren {
  AuthenticatedHrExpensesClaimIdRoute: typeof AuthenticatedHrExpensesClaimIdRoute
}

const AuthenticatedHrExpensesRouteChildren: AuthenticatedHrExpensesRouteChildren =
  {
    AuthenticatedHrExpensesClaimIdRoute: AuthenticatedHrExpensesClaimIdRoute,
  }

const AuthenticatedHrExpensesRouteWithChildren =
  AuthenticatedHrExpensesRoute._addFileChildren(
    AuthenticatedHrExpensesRouteChildren,
  )

interface AuthenticatedHrLeaveRouteChildren {
  AuthenticatedHrLeaveRequestIdRoute: typeof AuthenticatedHrLeaveRequestIdRoute
}

const AuthenticatedHrLeaveRouteChildren: AuthenticatedHrLeaveRouteChildren = {
  AuthenticatedHrLeaveRequestIdRoute: AuthenticatedHrLeaveRequestIdRoute,
}

const AuthenticatedHrLeaveRouteWithChildren =
  AuthenticatedHrLeaveRoute._addFileChildren(AuthenticatedHrLeaveRouteChildren)

interface AuthenticatedInventorySerialsRouteChildren {
  AuthenticatedInventorySerialsUnitIdRoute: typeof AuthenticatedInventorySerialsUnitIdRoute
}

const AuthenticatedInventorySerialsRouteChildren: AuthenticatedInventorySerialsRouteChildren =
  {
    AuthenticatedInventorySerialsUnitIdRoute:
      AuthenticatedInventorySerialsUnitIdRoute,
  }

const AuthenticatedInventorySerialsRouteWithChildren =
  AuthenticatedInventorySerialsRoute._addFileChildren(
    AuthenticatedInventorySerialsRouteChildren,
  )

interface AuthenticatedPurchasingLandedCostsRouteChildren {
  AuthenticatedPurchasingLandedCostsNewRoute: typeof AuthenticatedPurchasingLandedCostsNewRoute
  AuthenticatedPurchasingLandedCostsLandedCostIdIndexRoute: typeof AuthenticatedPurchasingLandedCostsLandedCostIdIndexRoute
}

const AuthenticatedPurchasingLandedCostsRouteChildren: AuthenticatedPurchasingLandedCostsRouteChildren =
  {
    AuthenticatedPurchasingLandedCostsNewRoute:
      AuthenticatedPurchasingLandedCostsNewRoute,
    AuthenticatedPurchasingLandedCostsLandedCostIdIndexRoute:
      AuthenticatedPurchasingLandedCostsLandedCostIdIndexRoute,
  }

const AuthenticatedPurchasingLandedCostsRouteWithChildren =
  AuthenticatedPurchasingLandedCostsRoute._addFileChildren(
    AuthenticatedPurchasingLandedCostsRouteChildren,
  )

interface AuthenticatedPurchasingOrdersRouteChildren {
  AuthenticatedPurchasingOrdersNewRoute: typeof AuthenticatedPurchasingOrdersNewRoute
  AuthenticatedPurchasingOrdersOrderIdEditRoute: typeof AuthenticatedPurchasingOrdersOrderIdEditRoute
  AuthenticatedPurchasingOrdersOrderIdReceiveRoute: typeof AuthenticatedPurchasingOrdersOrderIdReceiveRoute
  AuthenticatedPurchasingOrdersOrderIdIndexRoute: typeof AuthenticatedPurchasingOrdersOrderIdIndexRoute
}

const AuthenticatedPurchasingOrdersRouteChildren: AuthenticatedPurchasingOrdersRouteChildren =
  {
    AuthenticatedPurchasingOrdersNewRoute:
      AuthenticatedPurchasingOrdersNewRoute,
    AuthenticatedPurchasingOrdersOrderIdEditRoute:
      AuthenticatedPurchasingOrdersOrderIdEditRoute,
    AuthenticatedPurchasingOrdersOrderIdReceiveRoute:
      AuthenticatedPurchasingOrdersOrderIdReceiveRoute,
    AuthenticatedPurchasingOrdersOrderIdIndexRoute:
      AuthenticatedPurchasingOrdersOrderIdIndexRoute,
  }

const AuthenticatedPurchasingOrdersRouteWithChildren =
  AuthenticatedPurchasingOrdersRoute._addFileChildren(
    AuthenticatedPurchasingOrdersRouteChildren,
  )

interface AuthenticatedPurchasingReceiptsRouteChildren {
  AuthenticatedPurchasingReceiptsReceiptIdIndexRoute: typeof AuthenticatedPurchasingReceiptsReceiptIdIndexRoute
}

const AuthenticatedPurchasingReceiptsRouteChildren: AuthenticatedPurchasingReceiptsRouteChildren =
  {
    AuthenticatedPurchasingReceiptsReceiptIdIndexRoute:
      AuthenticatedPurchasingReceiptsReceiptIdIndexRoute,
  }

const AuthenticatedPurchasingReceiptsRouteWithChildren =
  AuthenticatedPurchasingReceiptsRoute._addFileChildren(
    AuthenticatedPurchasingReceiptsRouteChildren,
  )

interface AuthenticatedPurchasingReturnsRouteChildren {
  AuthenticatedPurchasingReturnsNewRoute: typeof AuthenticatedPurchasingReturnsNewRoute
  AuthenticatedPurchasingReturnsReturnIdIndexRoute: typeof AuthenticatedPurchasingReturnsReturnIdIndexRoute
}

const AuthenticatedPurchasingReturnsRouteChildren: AuthenticatedPurchasingReturnsRouteChildren =
  {
    AuthenticatedPurchasingReturnsNewRoute:
      AuthenticatedPurchasingReturnsNewRoute,
    AuthenticatedPurchasingReturnsReturnIdIndexRoute:
      AuthenticatedPurchasingReturnsReturnIdIndexRoute,
  }

const AuthenticatedPurchasingReturnsRouteWithChildren =
  AuthenticatedPurchasingReturnsRoute._addFileChildren(
    AuthenticatedPurchasingReturnsRouteChildren,
  )

interface AuthenticatedSalesOrdersRouteChildren {
  AuthenticatedSalesOrdersNewRoute: typeof AuthenticatedSalesOrdersNewRoute
  AuthenticatedSalesOrdersOrderIdEditRoute: typeof AuthenticatedSalesOrdersOrderIdEditRoute
  AuthenticatedSalesOrdersOrderIdIndexRoute: typeof AuthenticatedSalesOrdersOrderIdIndexRoute
}

const AuthenticatedSalesOrdersRouteChildren: AuthenticatedSalesOrdersRouteChildren =
  {
    AuthenticatedSalesOrdersNewRoute: AuthenticatedSalesOrdersNewRoute,
    AuthenticatedSalesOrdersOrderIdEditRoute:
      AuthenticatedSalesOrdersOrderIdEditRoute,
    AuthenticatedSalesOrdersOrderIdIndexRoute:
      AuthenticatedSalesOrdersOrderIdIndexRoute,
  }

const AuthenticatedSalesOrdersRouteWithChildren =
  AuthenticatedSalesOrdersRoute._addFileChildren(
    AuthenticatedSalesOrdersRouteChildren,
  )

interface AuthenticatedSalesReturnsRouteChildren {
  AuthenticatedSalesReturnsNewRoute: typeof AuthenticatedSalesReturnsNewRoute
  AuthenticatedSalesReturnsReturnIdIndexRoute: typeof AuthenticatedSalesReturnsReturnIdIndexRoute
}

const AuthenticatedSalesReturnsRouteChildren: AuthenticatedSalesReturnsRouteChildren =
  {
    AuthenticatedSalesReturnsNewRoute: AuthenticatedSalesReturnsNewRoute,
    AuthenticatedSalesReturnsReturnIdIndexRoute:
      AuthenticatedSalesReturnsReturnIdIndexRoute,
  }

const AuthenticatedSalesReturnsRouteWithChildren =
  AuthenticatedSalesReturnsRoute._addFileChildren(
    AuthenticatedSalesReturnsRouteChildren,
  )

interface AuthenticatedHrEmployeesEmployeeIdRouteChildren {
  AuthenticatedHrEmployeesEmployeeIdEditRoute: typeof AuthenticatedHrEmployeesEmployeeIdEditRoute
  AuthenticatedHrEmployeesEmployeeIdOnboardingRoute: typeof AuthenticatedHrEmployeesEmployeeIdOnboardingRoute
}

const AuthenticatedHrEmployeesEmployeeIdRouteChildren: AuthenticatedHrEmployeesEmployeeIdRouteChildren =
  {
    AuthenticatedHrEmployeesEmployeeIdEditRoute:
      AuthenticatedHrEmployeesEmployeeIdEditRoute,
    AuthenticatedHrEmployeesEmployeeIdOnboardingRoute:
      AuthenticatedHrEmployeesEmployeeIdOnboardingRoute,
  }

const AuthenticatedHrEmployeesEmployeeIdRouteWithChildren =
  AuthenticatedHrEmployeesEmployeeIdRoute._addFileChildren(
    AuthenticatedHrEmployeesEmployeeIdRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedSplatRoute: typeof AuthenticatedSplatRoute
  AuthenticatedAccountRoute: typeof AuthenticatedAccountRouteWithChildren
  AuthenticatedAccountingRoute: typeof AuthenticatedAccountingRouteWithChildren
  AuthenticatedAlertsRoute: typeof AuthenticatedAlertsRoute
  AuthenticatedApprovalsRoute: typeof AuthenticatedApprovalsRoute
  AuthenticatedAuditRoute: typeof AuthenticatedAuditRoute
  AuthenticatedBranchesRoute: typeof AuthenticatedBranchesRoute
  AuthenticatedCollectionsRoute: typeof AuthenticatedCollectionsRoute
  AuthenticatedCompaniesRoute: typeof AuthenticatedCompaniesRoute
  AuthenticatedDepartmentsRoute: typeof AuthenticatedDepartmentsRoute
  AuthenticatedNotificationsRoute: typeof AuthenticatedNotificationsRoute
  AuthenticatedPayrollRoute: typeof AuthenticatedPayrollRouteWithChildren
  AuthenticatedPositionsRoute: typeof AuthenticatedPositionsRoute
  AuthenticatedProductAttributesRoute: typeof AuthenticatedProductAttributesRoute
  AuthenticatedRolesRoute: typeof AuthenticatedRolesRouteWithChildren
  AuthenticatedSequencesRoute: typeof AuthenticatedSequencesRoute
  AuthenticatedTwoFactorSetupRoute: typeof AuthenticatedTwoFactorSetupRoute
  AuthenticatedUsersRoute: typeof AuthenticatedUsersRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedAccountingPayrollPaymentsRoute: typeof AuthenticatedAccountingPayrollPaymentsRoute
  AuthenticatedCustomersNewRoute: typeof AuthenticatedCustomersNewRoute
  AuthenticatedHrAssetsRoute: typeof AuthenticatedHrAssetsRouteWithChildren
  AuthenticatedHrAttendanceRoute: typeof AuthenticatedHrAttendanceRoute
  AuthenticatedHrAttendanceBoardRoute: typeof AuthenticatedHrAttendanceBoardRoute
  AuthenticatedHrAttendanceCorrectionsRoute: typeof AuthenticatedHrAttendanceCorrectionsRouteWithChildren
  AuthenticatedHrCashCustodyRoute: typeof AuthenticatedHrCashCustodyRouteWithChildren
  AuthenticatedHrExpensesRoute: typeof AuthenticatedHrExpensesRouteWithChildren
  AuthenticatedHrFieldSettingsRoute: typeof AuthenticatedHrFieldSettingsRoute
  AuthenticatedHrLeaveRoute: typeof AuthenticatedHrLeaveRouteWithChildren
  AuthenticatedHrOrgRoute: typeof AuthenticatedHrOrgRoute
  AuthenticatedHrSettingsRoute: typeof AuthenticatedHrSettingsRoute
  AuthenticatedHrWorkEntriesRoute: typeof AuthenticatedHrWorkEntriesRoute
  AuthenticatedHrWorkSchedulesRoute: typeof AuthenticatedHrWorkSchedulesRoute
  AuthenticatedInventoryAccessRoute: typeof AuthenticatedInventoryAccessRoute
  AuthenticatedInventoryAdjustmentsRoute: typeof AuthenticatedInventoryAdjustmentsRoute
  AuthenticatedInventoryDisposalsRoute: typeof AuthenticatedInventoryDisposalsRoute
  AuthenticatedInventoryLocationsRoute: typeof AuthenticatedInventoryLocationsRoute
  AuthenticatedInventoryMovementsRoute: typeof AuthenticatedInventoryMovementsRoute
  AuthenticatedInventorySerialsRoute: typeof AuthenticatedInventorySerialsRouteWithChildren
  AuthenticatedInventoryStockRoute: typeof AuthenticatedInventoryStockRoute
  AuthenticatedInventoryWarehousesRoute: typeof AuthenticatedInventoryWarehousesRoute
  AuthenticatedProductCategoriesNewRoute: typeof AuthenticatedProductCategoriesNewRoute
  AuthenticatedProductsNewRoute: typeof AuthenticatedProductsNewRoute
  AuthenticatedProductsUnitsOfMeasureRoute: typeof AuthenticatedProductsUnitsOfMeasureRoute
  AuthenticatedPurchasingLandedCostCategoriesRoute: typeof AuthenticatedPurchasingLandedCostCategoriesRoute
  AuthenticatedPurchasingLandedCostsRoute: typeof AuthenticatedPurchasingLandedCostsRouteWithChildren
  AuthenticatedPurchasingOrdersRoute: typeof AuthenticatedPurchasingOrdersRouteWithChildren
  AuthenticatedPurchasingReceiptsRoute: typeof AuthenticatedPurchasingReceiptsRouteWithChildren
  AuthenticatedPurchasingReturnsRoute: typeof AuthenticatedPurchasingReturnsRouteWithChildren
  AuthenticatedSalesOrdersRoute: typeof AuthenticatedSalesOrdersRouteWithChildren
  AuthenticatedSalesReservationsRoute: typeof AuthenticatedSalesReservationsRoute
  AuthenticatedSalesReturnsRoute: typeof AuthenticatedSalesReturnsRouteWithChildren
  AuthenticatedSettingsAlertsRoute: typeof AuthenticatedSettingsAlertsRoute
  AuthenticatedSettingsDataImportRoute: typeof AuthenticatedSettingsDataImportRoute
  AuthenticatedSettingsNotificationsRoute: typeof AuthenticatedSettingsNotificationsRoute
  AuthenticatedSettingsWorkflowsRoute: typeof AuthenticatedSettingsWorkflowsRoute
  AuthenticatedSuppliersNewRoute: typeof AuthenticatedSuppliersNewRoute
  AuthenticatedCustomersIndexRoute: typeof AuthenticatedCustomersIndexRoute
  AuthenticatedHrIndexRoute: typeof AuthenticatedHrIndexRoute
  AuthenticatedInventoryIndexRoute: typeof AuthenticatedInventoryIndexRoute
  AuthenticatedProductCategoriesIndexRoute: typeof AuthenticatedProductCategoriesIndexRoute
  AuthenticatedProductsIndexRoute: typeof AuthenticatedProductsIndexRoute
  AuthenticatedPurchasingIndexRoute: typeof AuthenticatedPurchasingIndexRoute
  AuthenticatedRecruitmentIndexRoute: typeof AuthenticatedRecruitmentIndexRoute
  AuthenticatedSalesIndexRoute: typeof AuthenticatedSalesIndexRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
  AuthenticatedSuppliersIndexRoute: typeof AuthenticatedSuppliersIndexRoute
  AuthenticatedTagsIndexRoute: typeof AuthenticatedTagsIndexRoute
  AuthenticatedCustomersCustomerIdEditRoute: typeof AuthenticatedCustomersCustomerIdEditRoute
  AuthenticatedGroupReportsBalanceSheetRoute: typeof AuthenticatedGroupReportsBalanceSheetRoute
  AuthenticatedGroupReportsProfitAndLossRoute: typeof AuthenticatedGroupReportsProfitAndLossRoute
  AuthenticatedHrEmployeesEmployeeIdRoute: typeof AuthenticatedHrEmployeesEmployeeIdRouteWithChildren
  AuthenticatedHrEmployeesNewRoute: typeof AuthenticatedHrEmployeesNewRoute
  AuthenticatedHrPerformanceSchedulesRoute: typeof AuthenticatedHrPerformanceSchedulesRoute
  AuthenticatedHrPerformanceTemplatesRoute: typeof AuthenticatedHrPerformanceTemplatesRoute
  AuthenticatedHrReportsAbsenceCoverageRoute: typeof AuthenticatedHrReportsAbsenceCoverageRoute
  AuthenticatedHrReportsAbsenceDetailRoute: typeof AuthenticatedHrReportsAbsenceDetailRoute
  AuthenticatedHrReportsAnalyticsRoute: typeof AuthenticatedHrReportsAnalyticsRoute
  AuthenticatedHrReportsAssetCustodyRoute: typeof AuthenticatedHrReportsAssetCustodyRoute
  AuthenticatedHrReportsAssetExceptionsRoute: typeof AuthenticatedHrReportsAssetExceptionsRoute
  AuthenticatedHrReportsAttendanceExceptionsRoute: typeof AuthenticatedHrReportsAttendanceExceptionsRoute
  AuthenticatedHrReportsAttendanceSheetRoute: typeof AuthenticatedHrReportsAttendanceSheetRoute
  AuthenticatedHrReportsAttendanceSummaryRoute: typeof AuthenticatedHrReportsAttendanceSummaryRoute
  AuthenticatedHrReportsBirthdaysRoute: typeof AuthenticatedHrReportsBirthdaysRoute
  AuthenticatedHrReportsBreaksSessionsRoute: typeof AuthenticatedHrReportsBreaksSessionsRoute
  AuthenticatedHrReportsCashCustodyBalancesRoute: typeof AuthenticatedHrReportsCashCustodyBalancesRoute
  AuthenticatedHrReportsDemographicsRoute: typeof AuthenticatedHrReportsDemographicsRoute
  AuthenticatedHrReportsDocumentExpiryRoute: typeof AuthenticatedHrReportsDocumentExpiryRoute
  AuthenticatedHrReportsExpenseAgeingRoute: typeof AuthenticatedHrReportsExpenseAgeingRoute
  AuthenticatedHrReportsExpenseClaimsRoute: typeof AuthenticatedHrReportsExpenseClaimsRoute
  AuthenticatedHrReportsHeadcountRoute: typeof AuthenticatedHrReportsHeadcountRoute
  AuthenticatedHrReportsHolidayRollRoute: typeof AuthenticatedHrReportsHolidayRollRoute
  AuthenticatedHrReportsJoinersLeaversRoute: typeof AuthenticatedHrReportsJoinersLeaversRoute
  AuthenticatedHrReportsLatenessRoute: typeof AuthenticatedHrReportsLatenessRoute
  AuthenticatedHrReportsLeaveBalancesRoute: typeof AuthenticatedHrReportsLeaveBalancesRoute
  AuthenticatedHrReportsLeaveLiabilityRoute: typeof AuthenticatedHrReportsLeaveLiabilityRoute
  AuthenticatedHrReportsLeaveTakenRoute: typeof AuthenticatedHrReportsLeaveTakenRoute
  AuthenticatedHrReportsOrgHygieneRoute: typeof AuthenticatedHrReportsOrgHygieneRoute
  AuthenticatedHrReportsOvertimeRoute: typeof AuthenticatedHrReportsOvertimeRoute
  AuthenticatedHrReportsPayrollDeductionsRoute: typeof AuthenticatedHrReportsPayrollDeductionsRoute
  AuthenticatedHrReportsPayrollRegisterRoute: typeof AuthenticatedHrReportsPayrollRegisterRoute
  AuthenticatedHrReportsPayrollSummaryRoute: typeof AuthenticatedHrReportsPayrollSummaryRoute
  AuthenticatedHrReportsPayrollVarianceRoute: typeof AuthenticatedHrReportsPayrollVarianceRoute
  AuthenticatedHrReportsPermissionRequestsRoute: typeof AuthenticatedHrReportsPermissionRequestsRoute
  AuthenticatedHrReportsProbationContractRoute: typeof AuthenticatedHrReportsProbationContractRoute
  AuthenticatedHrReportsReviewCompletionRoute: typeof AuthenticatedHrReportsReviewCompletionRoute
  AuthenticatedHrReportsRosterBankRoute: typeof AuthenticatedHrReportsRosterBankRoute
  AuthenticatedHrReportsRosterCompensationRoute: typeof AuthenticatedHrReportsRosterCompensationRoute
  AuthenticatedHrReportsRosterContactRoute: typeof AuthenticatedHrReportsRosterContactRoute
  AuthenticatedHrReportsRosterEmergencyRoute: typeof AuthenticatedHrReportsRosterEmergencyRoute
  AuthenticatedHrReportsRosterEmploymentRoute: typeof AuthenticatedHrReportsRosterEmploymentRoute
  AuthenticatedHrReportsRosterTeamMemberRoute: typeof AuthenticatedHrReportsRosterTeamMemberRoute
  AuthenticatedHrReportsScoreDistributionRoute: typeof AuthenticatedHrReportsScoreDistributionRoute
  AuthenticatedHrReportsTimeOffReviewRoute: typeof AuthenticatedHrReportsTimeOffReviewRoute
  AuthenticatedHrReportsTurnoverRoute: typeof AuthenticatedHrReportsTurnoverRoute
  AuthenticatedHrReportsViolationsRoute: typeof AuthenticatedHrReportsViolationsRoute
  AuthenticatedHrReportsWorkHoursRoute: typeof AuthenticatedHrReportsWorkHoursRoute
  AuthenticatedHrViolationsViolationIdRoute: typeof AuthenticatedHrViolationsViolationIdRoute
  AuthenticatedInventoryLotsLotIdRoute: typeof AuthenticatedInventoryLotsLotIdRoute
  AuthenticatedInventoryReportsAgingRoute: typeof AuthenticatedInventoryReportsAgingRoute
  AuthenticatedInventoryReportsNoSalesRoute: typeof AuthenticatedInventoryReportsNoSalesRoute
  AuthenticatedInventoryReportsPerformanceRoute: typeof AuthenticatedInventoryReportsPerformanceRoute
  AuthenticatedInventoryReportsReplenishmentRoute: typeof AuthenticatedInventoryReportsReplenishmentRoute
  AuthenticatedInventoryReportsStockValuationRoute: typeof AuthenticatedInventoryReportsStockValuationRoute
  AuthenticatedInventoryReportsStockValueRoute: typeof AuthenticatedInventoryReportsStockValueRoute
  AuthenticatedInventoryTransfersTransferIdRoute: typeof AuthenticatedInventoryTransfersTransferIdRoute
  AuthenticatedInventoryTransfersNewRoute: typeof AuthenticatedInventoryTransfersNewRoute
  AuthenticatedProductCategoriesCategoryIdEditRoute: typeof AuthenticatedProductCategoriesCategoryIdEditRoute
  AuthenticatedProductsProductIdEditRoute: typeof AuthenticatedProductsProductIdEditRoute
  AuthenticatedPurchasingReportsGoodsReceivedNotInvoicedRoute: typeof AuthenticatedPurchasingReportsGoodsReceivedNotInvoicedRoute
  AuthenticatedPurchasingReportsLandedCostsPendingRoute: typeof AuthenticatedPurchasingReportsLandedCostsPendingRoute
  AuthenticatedPurchasingReportsThreeWayMatchRoute: typeof AuthenticatedPurchasingReportsThreeWayMatchRoute
  AuthenticatedRecruitmentCandidatesCandidateIdRoute: typeof AuthenticatedRecruitmentCandidatesCandidateIdRoute
  AuthenticatedRecruitmentOpeningsOpeningIdRoute: typeof AuthenticatedRecruitmentOpeningsOpeningIdRoute
  AuthenticatedSalesReportsTrendRoute: typeof AuthenticatedSalesReportsTrendRoute
  AuthenticatedSuppliersSupplierIdEditRoute: typeof AuthenticatedSuppliersSupplierIdEditRoute
  AuthenticatedCustomersCustomerIdIndexRoute: typeof AuthenticatedCustomersCustomerIdIndexRoute
  AuthenticatedGroupReportsIndexRoute: typeof AuthenticatedGroupReportsIndexRoute
  AuthenticatedHrEmployeesIndexRoute: typeof AuthenticatedHrEmployeesIndexRoute
  AuthenticatedHrPerformanceIndexRoute: typeof AuthenticatedHrPerformanceIndexRoute
  AuthenticatedHrReportsIndexRoute: typeof AuthenticatedHrReportsIndexRoute
  AuthenticatedHrViolationsIndexRoute: typeof AuthenticatedHrViolationsIndexRoute
  AuthenticatedInventoryCountsIndexRoute: typeof AuthenticatedInventoryCountsIndexRoute
  AuthenticatedInventoryLotsIndexRoute: typeof AuthenticatedInventoryLotsIndexRoute
  AuthenticatedInventoryReportsIndexRoute: typeof AuthenticatedInventoryReportsIndexRoute
  AuthenticatedInventoryTransfersIndexRoute: typeof AuthenticatedInventoryTransfersIndexRoute
  AuthenticatedProductsProductIdIndexRoute: typeof AuthenticatedProductsProductIdIndexRoute
  AuthenticatedSuppliersSupplierIdIndexRoute: typeof AuthenticatedSuppliersSupplierIdIndexRoute
  AuthenticatedHrPerformanceCyclesCycleIdRoute: typeof AuthenticatedHrPerformanceCyclesCycleIdRoute
  AuthenticatedHrPerformanceReviewsReviewIdRoute: typeof AuthenticatedHrPerformanceReviewsReviewIdRoute
  AuthenticatedInventoryCountsSessionIdReviewRoute: typeof AuthenticatedInventoryCountsSessionIdReviewRoute
  AuthenticatedInventoryReportsInsightsReportRoute: typeof AuthenticatedInventoryReportsInsightsReportRoute
  AuthenticatedInventoryCountsSessionIdIndexRoute: typeof AuthenticatedInventoryCountsSessionIdIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedSplatRoute: AuthenticatedSplatRoute,
  AuthenticatedAccountRoute: AuthenticatedAccountRouteWithChildren,
  AuthenticatedAccountingRoute: AuthenticatedAccountingRouteWithChildren,
  AuthenticatedAlertsRoute: AuthenticatedAlertsRoute,
  AuthenticatedApprovalsRoute: AuthenticatedApprovalsRoute,
  AuthenticatedAuditRoute: AuthenticatedAuditRoute,
  AuthenticatedBranchesRoute: AuthenticatedBranchesRoute,
  AuthenticatedCollectionsRoute: AuthenticatedCollectionsRoute,
  AuthenticatedCompaniesRoute: AuthenticatedCompaniesRoute,
  AuthenticatedDepartmentsRoute: AuthenticatedDepartmentsRoute,
  AuthenticatedNotificationsRoute: AuthenticatedNotificationsRoute,
  AuthenticatedPayrollRoute: AuthenticatedPayrollRouteWithChildren,
  AuthenticatedPositionsRoute: AuthenticatedPositionsRoute,
  AuthenticatedProductAttributesRoute: AuthenticatedProductAttributesRoute,
  AuthenticatedRolesRoute: AuthenticatedRolesRouteWithChildren,
  AuthenticatedSequencesRoute: AuthenticatedSequencesRoute,
  AuthenticatedTwoFactorSetupRoute: AuthenticatedTwoFactorSetupRoute,
  AuthenticatedUsersRoute: AuthenticatedUsersRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedAccountingPayrollPaymentsRoute:
    AuthenticatedAccountingPayrollPaymentsRoute,
  AuthenticatedCustomersNewRoute: AuthenticatedCustomersNewRoute,
  AuthenticatedHrAssetsRoute: AuthenticatedHrAssetsRouteWithChildren,
  AuthenticatedHrAttendanceRoute: AuthenticatedHrAttendanceRoute,
  AuthenticatedHrAttendanceBoardRoute: AuthenticatedHrAttendanceBoardRoute,
  AuthenticatedHrAttendanceCorrectionsRoute:
    AuthenticatedHrAttendanceCorrectionsRouteWithChildren,
  AuthenticatedHrCashCustodyRoute: AuthenticatedHrCashCustodyRouteWithChildren,
  AuthenticatedHrExpensesRoute: AuthenticatedHrExpensesRouteWithChildren,
  AuthenticatedHrFieldSettingsRoute: AuthenticatedHrFieldSettingsRoute,
  AuthenticatedHrLeaveRoute: AuthenticatedHrLeaveRouteWithChildren,
  AuthenticatedHrOrgRoute: AuthenticatedHrOrgRoute,
  AuthenticatedHrSettingsRoute: AuthenticatedHrSettingsRoute,
  AuthenticatedHrWorkEntriesRoute: AuthenticatedHrWorkEntriesRoute,
  AuthenticatedHrWorkSchedulesRoute: AuthenticatedHrWorkSchedulesRoute,
  AuthenticatedInventoryAccessRoute: AuthenticatedInventoryAccessRoute,
  AuthenticatedInventoryAdjustmentsRoute:
    AuthenticatedInventoryAdjustmentsRoute,
  AuthenticatedInventoryDisposalsRoute: AuthenticatedInventoryDisposalsRoute,
  AuthenticatedInventoryLocationsRoute: AuthenticatedInventoryLocationsRoute,
  AuthenticatedInventoryMovementsRoute: AuthenticatedInventoryMovementsRoute,
  AuthenticatedInventorySerialsRoute:
    AuthenticatedInventorySerialsRouteWithChildren,
  AuthenticatedInventoryStockRoute: AuthenticatedInventoryStockRoute,
  AuthenticatedInventoryWarehousesRoute: AuthenticatedInventoryWarehousesRoute,
  AuthenticatedProductCategoriesNewRoute:
    AuthenticatedProductCategoriesNewRoute,
  AuthenticatedProductsNewRoute: AuthenticatedProductsNewRoute,
  AuthenticatedProductsUnitsOfMeasureRoute:
    AuthenticatedProductsUnitsOfMeasureRoute,
  AuthenticatedPurchasingLandedCostCategoriesRoute:
    AuthenticatedPurchasingLandedCostCategoriesRoute,
  AuthenticatedPurchasingLandedCostsRoute:
    AuthenticatedPurchasingLandedCostsRouteWithChildren,
  AuthenticatedPurchasingOrdersRoute:
    AuthenticatedPurchasingOrdersRouteWithChildren,
  AuthenticatedPurchasingReceiptsRoute:
    AuthenticatedPurchasingReceiptsRouteWithChildren,
  AuthenticatedPurchasingReturnsRoute:
    AuthenticatedPurchasingReturnsRouteWithChildren,
  AuthenticatedSalesOrdersRoute: AuthenticatedSalesOrdersRouteWithChildren,
  AuthenticatedSalesReservationsRoute: AuthenticatedSalesReservationsRoute,
  AuthenticatedSalesReturnsRoute: AuthenticatedSalesReturnsRouteWithChildren,
  AuthenticatedSettingsAlertsRoute: AuthenticatedSettingsAlertsRoute,
  AuthenticatedSettingsDataImportRoute: AuthenticatedSettingsDataImportRoute,
  AuthenticatedSettingsNotificationsRoute:
    AuthenticatedSettingsNotificationsRoute,
  AuthenticatedSettingsWorkflowsRoute: AuthenticatedSettingsWorkflowsRoute,
  AuthenticatedSuppliersNewRoute: AuthenticatedSuppliersNewRoute,
  AuthenticatedCustomersIndexRoute: AuthenticatedCustomersIndexRoute,
  AuthenticatedHrIndexRoute: AuthenticatedHrIndexRoute,
  AuthenticatedInventoryIndexRoute: AuthenticatedInventoryIndexRoute,
  AuthenticatedProductCategoriesIndexRoute:
    AuthenticatedProductCategoriesIndexRoute,
  AuthenticatedProductsIndexRoute: AuthenticatedProductsIndexRoute,
  AuthenticatedPurchasingIndexRoute: AuthenticatedPurchasingIndexRoute,
  AuthenticatedRecruitmentIndexRoute: AuthenticatedRecruitmentIndexRoute,
  AuthenticatedSalesIndexRoute: AuthenticatedSalesIndexRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  AuthenticatedSuppliersIndexRoute: AuthenticatedSuppliersIndexRoute,
  AuthenticatedTagsIndexRoute: AuthenticatedTagsIndexRoute,
  AuthenticatedCustomersCustomerIdEditRoute:
    AuthenticatedCustomersCustomerIdEditRoute,
  AuthenticatedGroupReportsBalanceSheetRoute:
    AuthenticatedGroupReportsBalanceSheetRoute,
  AuthenticatedGroupReportsProfitAndLossRoute:
    AuthenticatedGroupReportsProfitAndLossRoute,
  AuthenticatedHrEmployeesEmployeeIdRoute:
    AuthenticatedHrEmployeesEmployeeIdRouteWithChildren,
  AuthenticatedHrEmployeesNewRoute: AuthenticatedHrEmployeesNewRoute,
  AuthenticatedHrPerformanceSchedulesRoute:
    AuthenticatedHrPerformanceSchedulesRoute,
  AuthenticatedHrPerformanceTemplatesRoute:
    AuthenticatedHrPerformanceTemplatesRoute,
  AuthenticatedHrReportsAbsenceCoverageRoute:
    AuthenticatedHrReportsAbsenceCoverageRoute,
  AuthenticatedHrReportsAbsenceDetailRoute:
    AuthenticatedHrReportsAbsenceDetailRoute,
  AuthenticatedHrReportsAnalyticsRoute: AuthenticatedHrReportsAnalyticsRoute,
  AuthenticatedHrReportsAssetCustodyRoute:
    AuthenticatedHrReportsAssetCustodyRoute,
  AuthenticatedHrReportsAssetExceptionsRoute:
    AuthenticatedHrReportsAssetExceptionsRoute,
  AuthenticatedHrReportsAttendanceExceptionsRoute:
    AuthenticatedHrReportsAttendanceExceptionsRoute,
  AuthenticatedHrReportsAttendanceSheetRoute:
    AuthenticatedHrReportsAttendanceSheetRoute,
  AuthenticatedHrReportsAttendanceSummaryRoute:
    AuthenticatedHrReportsAttendanceSummaryRoute,
  AuthenticatedHrReportsBirthdaysRoute: AuthenticatedHrReportsBirthdaysRoute,
  AuthenticatedHrReportsBreaksSessionsRoute:
    AuthenticatedHrReportsBreaksSessionsRoute,
  AuthenticatedHrReportsCashCustodyBalancesRoute:
    AuthenticatedHrReportsCashCustodyBalancesRoute,
  AuthenticatedHrReportsDemographicsRoute:
    AuthenticatedHrReportsDemographicsRoute,
  AuthenticatedHrReportsDocumentExpiryRoute:
    AuthenticatedHrReportsDocumentExpiryRoute,
  AuthenticatedHrReportsExpenseAgeingRoute:
    AuthenticatedHrReportsExpenseAgeingRoute,
  AuthenticatedHrReportsExpenseClaimsRoute:
    AuthenticatedHrReportsExpenseClaimsRoute,
  AuthenticatedHrReportsHeadcountRoute: AuthenticatedHrReportsHeadcountRoute,
  AuthenticatedHrReportsHolidayRollRoute:
    AuthenticatedHrReportsHolidayRollRoute,
  AuthenticatedHrReportsJoinersLeaversRoute:
    AuthenticatedHrReportsJoinersLeaversRoute,
  AuthenticatedHrReportsLatenessRoute: AuthenticatedHrReportsLatenessRoute,
  AuthenticatedHrReportsLeaveBalancesRoute:
    AuthenticatedHrReportsLeaveBalancesRoute,
  AuthenticatedHrReportsLeaveLiabilityRoute:
    AuthenticatedHrReportsLeaveLiabilityRoute,
  AuthenticatedHrReportsLeaveTakenRoute: AuthenticatedHrReportsLeaveTakenRoute,
  AuthenticatedHrReportsOrgHygieneRoute: AuthenticatedHrReportsOrgHygieneRoute,
  AuthenticatedHrReportsOvertimeRoute: AuthenticatedHrReportsOvertimeRoute,
  AuthenticatedHrReportsPayrollDeductionsRoute:
    AuthenticatedHrReportsPayrollDeductionsRoute,
  AuthenticatedHrReportsPayrollRegisterRoute:
    AuthenticatedHrReportsPayrollRegisterRoute,
  AuthenticatedHrReportsPayrollSummaryRoute:
    AuthenticatedHrReportsPayrollSummaryRoute,
  AuthenticatedHrReportsPayrollVarianceRoute:
    AuthenticatedHrReportsPayrollVarianceRoute,
  AuthenticatedHrReportsPermissionRequestsRoute:
    AuthenticatedHrReportsPermissionRequestsRoute,
  AuthenticatedHrReportsProbationContractRoute:
    AuthenticatedHrReportsProbationContractRoute,
  AuthenticatedHrReportsReviewCompletionRoute:
    AuthenticatedHrReportsReviewCompletionRoute,
  AuthenticatedHrReportsRosterBankRoute: AuthenticatedHrReportsRosterBankRoute,
  AuthenticatedHrReportsRosterCompensationRoute:
    AuthenticatedHrReportsRosterCompensationRoute,
  AuthenticatedHrReportsRosterContactRoute:
    AuthenticatedHrReportsRosterContactRoute,
  AuthenticatedHrReportsRosterEmergencyRoute:
    AuthenticatedHrReportsRosterEmergencyRoute,
  AuthenticatedHrReportsRosterEmploymentRoute:
    AuthenticatedHrReportsRosterEmploymentRoute,
  AuthenticatedHrReportsRosterTeamMemberRoute:
    AuthenticatedHrReportsRosterTeamMemberRoute,
  AuthenticatedHrReportsScoreDistributionRoute:
    AuthenticatedHrReportsScoreDistributionRoute,
  AuthenticatedHrReportsTimeOffReviewRoute:
    AuthenticatedHrReportsTimeOffReviewRoute,
  AuthenticatedHrReportsTurnoverRoute: AuthenticatedHrReportsTurnoverRoute,
  AuthenticatedHrReportsViolationsRoute: AuthenticatedHrReportsViolationsRoute,
  AuthenticatedHrReportsWorkHoursRoute: AuthenticatedHrReportsWorkHoursRoute,
  AuthenticatedHrViolationsViolationIdRoute:
    AuthenticatedHrViolationsViolationIdRoute,
  AuthenticatedInventoryLotsLotIdRoute: AuthenticatedInventoryLotsLotIdRoute,
  AuthenticatedInventoryReportsAgingRoute:
    AuthenticatedInventoryReportsAgingRoute,
  AuthenticatedInventoryReportsNoSalesRoute:
    AuthenticatedInventoryReportsNoSalesRoute,
  AuthenticatedInventoryReportsPerformanceRoute:
    AuthenticatedInventoryReportsPerformanceRoute,
  AuthenticatedInventoryReportsReplenishmentRoute:
    AuthenticatedInventoryReportsReplenishmentRoute,
  AuthenticatedInventoryReportsStockValuationRoute:
    AuthenticatedInventoryReportsStockValuationRoute,
  AuthenticatedInventoryReportsStockValueRoute:
    AuthenticatedInventoryReportsStockValueRoute,
  AuthenticatedInventoryTransfersTransferIdRoute:
    AuthenticatedInventoryTransfersTransferIdRoute,
  AuthenticatedInventoryTransfersNewRoute:
    AuthenticatedInventoryTransfersNewRoute,
  AuthenticatedProductCategoriesCategoryIdEditRoute:
    AuthenticatedProductCategoriesCategoryIdEditRoute,
  AuthenticatedProductsProductIdEditRoute:
    AuthenticatedProductsProductIdEditRoute,
  AuthenticatedPurchasingReportsGoodsReceivedNotInvoicedRoute:
    AuthenticatedPurchasingReportsGoodsReceivedNotInvoicedRoute,
  AuthenticatedPurchasingReportsLandedCostsPendingRoute:
    AuthenticatedPurchasingReportsLandedCostsPendingRoute,
  AuthenticatedPurchasingReportsThreeWayMatchRoute:
    AuthenticatedPurchasingReportsThreeWayMatchRoute,
  AuthenticatedRecruitmentCandidatesCandidateIdRoute:
    AuthenticatedRecruitmentCandidatesCandidateIdRoute,
  AuthenticatedRecruitmentOpeningsOpeningIdRoute:
    AuthenticatedRecruitmentOpeningsOpeningIdRoute,
  AuthenticatedSalesReportsTrendRoute: AuthenticatedSalesReportsTrendRoute,
  AuthenticatedSuppliersSupplierIdEditRoute:
    AuthenticatedSuppliersSupplierIdEditRoute,
  AuthenticatedCustomersCustomerIdIndexRoute:
    AuthenticatedCustomersCustomerIdIndexRoute,
  AuthenticatedGroupReportsIndexRoute: AuthenticatedGroupReportsIndexRoute,
  AuthenticatedHrEmployeesIndexRoute: AuthenticatedHrEmployeesIndexRoute,
  AuthenticatedHrPerformanceIndexRoute: AuthenticatedHrPerformanceIndexRoute,
  AuthenticatedHrReportsIndexRoute: AuthenticatedHrReportsIndexRoute,
  AuthenticatedHrViolationsIndexRoute: AuthenticatedHrViolationsIndexRoute,
  AuthenticatedInventoryCountsIndexRoute:
    AuthenticatedInventoryCountsIndexRoute,
  AuthenticatedInventoryLotsIndexRoute: AuthenticatedInventoryLotsIndexRoute,
  AuthenticatedInventoryReportsIndexRoute:
    AuthenticatedInventoryReportsIndexRoute,
  AuthenticatedInventoryTransfersIndexRoute:
    AuthenticatedInventoryTransfersIndexRoute,
  AuthenticatedProductsProductIdIndexRoute:
    AuthenticatedProductsProductIdIndexRoute,
  AuthenticatedSuppliersSupplierIdIndexRoute:
    AuthenticatedSuppliersSupplierIdIndexRoute,
  AuthenticatedHrPerformanceCyclesCycleIdRoute:
    AuthenticatedHrPerformanceCyclesCycleIdRoute,
  AuthenticatedHrPerformanceReviewsReviewIdRoute:
    AuthenticatedHrPerformanceReviewsReviewIdRoute,
  AuthenticatedInventoryCountsSessionIdReviewRoute:
    AuthenticatedInventoryCountsSessionIdReviewRoute,
  AuthenticatedInventoryReportsInsightsReportRoute:
    AuthenticatedInventoryReportsInsightsReportRoute,
  AuthenticatedInventoryCountsSessionIdIndexRoute:
    AuthenticatedInventoryCountsSessionIdIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AcceptInvitationRoute: AcceptInvitationRoute,
  ActivateRoute: ActivateRoute,
  FaceDiagnosticsRoute: FaceDiagnosticsRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  GetTheAppRoute: GetTheAppRoute,
  KioskRoute: KioskRoute,
  LoginRoute: LoginRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  ResetCodeRoute: ResetCodeRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  TwoFactorRoute: TwoFactorRoute,
  ApplyTokenRoute: ApplyTokenRoute,
  SupportEndedRoute: SupportEndedRoute,
  SupportEnterRoute: SupportEnterRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
